{
  "level": "q309",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:q309",
    "objects": "AREAS.E3:q309.e3",
    "mesh": "TREES.E3:q309.e3"
  },
  "spawn_point": {
    "position": [
      1325.1588238848756,
      1375.0805738335414,
      1.300048828125
    ],
    "facing_rad": 0.0,
    "look_point": [
      1325.1588238848756,
      1475.0805738335414,
      1.300048828125
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -5545.388671875,
      -2849.047607421875,
      -22.699951171875
    ],
    "bbox_max": [
      2400.0,
      6871.484375,
      1857.3123779296875
    ],
    "vertex_count": 1208,
    "vertices": [
      [
        -3714.042724609375,
        -2323.521484375,
        1179.1292724609375
      ],
      [
        -5545.388671875,
        4741.15380859375,
        334.1224365234375
      ],
      [
        -3179.908447265625,
        3702.748046875,
        150.0
      ],
      [
        -2916.739501953125,
        3191.2431640625,
        124.09432983398438
      ],
      [
        -5174.01171875,
        5224.01171875,
        41.12890625
      ],
      [
        -5020.71826171875,
        5326.439453125,
        -22.699951171875
      ],
      [
        -5174.01171875,
        5224.01171875,
        671.7750244140625
      ],
      [
        -3662.578857421875,
        6233.91845703125,
        -22.699951171875
      ],
      [
        -5174.01171875,
        5224.01171875,
        714.5433349609375
      ],
      [
        -2708.39404296875,
        6871.484375,
        182.69976806640625
      ],
      [
        2400.0,
        -2849.047607421875,
        1857.3123779296875
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        650.0,
        -2598.9130859375,
        1493.904296875
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        2400.0,
        -1546.88427734375,
        433.001953125
      ],
      [
        650.0,
        -867.0938720703125,
        16.996383666992188
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      [
        1655.0,
        1830.0,
        140.0
      ],
      [
        1655.0,
        1830.0,
        120.0
      ],
      [
        1550.0001220703125,
        2011.7158203125,
        1060.0
      ],
      [
        1550.0,
        1830.0,
        1060.0
      ],
      [
        1910.0,
        2050.0,
        1060.0
      ],
      [
        1910.0,
        1940.0999755859375,
        1060.0
      ],
      [
        2020.0,
        1830.0,
        1060.0
      ],
      [
        2011.0,
        1865.199951171875,
        1060.0
      ],
      [
        1945.0999755859375,
        1931.0999755859375,
        1060.0
      ],
      [
        1910.0,
        1940.0999755859375,
        1060.0
      ],
      [
        1910.0,
        1830.0,
        350.0
      ],
      [
        1910.0,
        1896.0,
        1059.422119140625
      ],
      [
        1910.0,
        1895.4892578125,
        1060.0
      ],
      [
        1975.4892578125,
        1830.0,
        1060.0
      ],
      [
        1975.800048828125,
        1830.0,
        1059.6484375
      ],
      [
        1910.0,
        1896.0,
        1060.0
      ],
      [
        1910.0,
        1896.0,
        1059.422119140625
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1704.5107421875,
        1830.0,
        1060.0
      ],
      [
        1704.19970703125,
        1830.0,
        1060.0
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1745.6768798828125,
        1830.0,
        120.0
      ],
      [
        1730.694091796875,
        1830.0,
        120.0
      ],
      [
        1655.0001220703125,
        1830.0,
        120.0
      ],
      [
        1730.694091796875,
        1830.0,
        120.0
      ],
      [
        1730.0684814453125,
        1830.0,
        140.0
      ],
      [
        1745.6768798828125,
        1830.0,
        140.0
      ],
      [
        1655.0001220703125,
        1830.0,
        140.0
      ],
      [
        1730.0684814453125,
        1830.0,
        140.0
      ],
      [
        1864.1424560546875,
        1830.0,
        320.0
      ],
      [
        1815.857666015625,
        1830.0,
        320.0
      ],
      [
        1770.0,
        1830.0,
        337.5489196777344
      ],
      [
        1756.5230712890625,
        1830.0,
        350.0
      ],
      [
        1692.8388671875,
        1830.0,
        340.0
      ],
      [
        1692.8388671875,
        1830.0,
        350.0
      ],
      [
        1703.1702880859375,
        1830.0,
        340.0
      ],
      [
        1692.8388671875,
        1830.0,
        340.0
      ],
      [
        1910.0,
        1830.0,
        1130.0
      ],
      [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      [
        1910.0,
        1881.243408203125,
        1130.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1880.41455078125,
        1830.0,
        1130.0
      ],
      [
        1880.41455078125,
        1830.0,
        1130.0
      ],
      [
        1840.0001220703125,
        1830.0,
        1130.0
      ],
      [
        1840.0001220703125,
        1830.0,
        1130.0
      ],
      [
        1799.58544921875,
        1830.0,
        1130.0
      ],
      [
        1706.639892578125,
        1830.0,
        1130.0
      ],
      [
        1675.58154296875,
        1830.0,
        1130.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1872.5,
        1841.2916259765625,
        1110.0
      ],
      [
        1852.5001220703125,
        1846.6507568359375,
        1110.0
      ],
      [
        1852.5001220703125,
        1846.6507568359375,
        1110.0
      ],
      [
        1852.5001220703125,
        1846.6507568359375,
        1115.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1892.9427490234375,
        1830.0,
        1106.0
      ],
      [
        1784.6409912109375,
        1830.0,
        1110.0
      ],
      [
        1784.3255615234375,
        1830.0,
        1110.0
      ],
      [
        1869.4744873046875,
        1830.0,
        1110.0
      ],
      [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      [
        1848.03857421875,
        1830.0,
        1115.0
      ],
      [
        1956.5875244140625,
        1690.0,
        1060.0
      ],
      [
        1723.4124755859375,
        1690.0,
        1060.0
      ],
      [
        1956.5875244140625,
        1690.0,
        1060.0
      ],
      [
        1892.9422607421875,
        1690.0,
        1060.0
      ],
      [
        1655.0,
        1690.0,
        140.0
      ],
      [
        1655.0,
        1690.0,
        120.0
      ],
      [
        1655.0,
        1830.0,
        350.0
      ],
      [
        1655.0,
        1689.9998779296875,
        350.0
      ],
      [
        1225.0,
        1690.0,
        270.0
      ],
      [
        1170.0,
        1690.0,
        230.0
      ],
      [
        1225.0,
        1690.0,
        329.0
      ],
      [
        1225.0,
        1690.0,
        270.0
      ],
      [
        1815.8575439453125,
        1690.0,
        320.0
      ],
      [
        1864.1422119140625,
        1690.0,
        320.0
      ],
      [
        1756.5230712890625,
        1690.0,
        350.0
      ],
      [
        1770.0,
        1690.0,
        337.5488586425781
      ],
      [
        1910.0,
        1690.0,
        337.5489196777344
      ],
      [
        1923.4769287109375,
        1690.0,
        350.0
      ],
      [
        1864.1422119140625,
        1690.0,
        320.0
      ],
      [
        1910.0,
        1690.0,
        337.5489196777344
      ],
      [
        1976.82958984375,
        1690.0,
        350.0
      ],
      [
        1976.82958984375,
        1690.0,
        340.0
      ],
      [
        1703.17041015625,
        1690.0,
        340.0
      ],
      [
        1692.8388671875,
        1690.0,
        340.0
      ],
      [
        1692.8388671875,
        1690.0,
        340.0
      ],
      [
        1692.8388671875,
        1690.0,
        350.0
      ],
      [
        1735.5450439453125,
        1818.4022216796875,
        120.0
      ],
      [
        1715.4573974609375,
        1830.0,
        120.0
      ],
      [
        1735.5450439453125,
        1818.4022216796875,
        140.0
      ],
      [
        1715.4573974609375,
        1830.0,
        140.0
      ],
      [
        1730.2777099609375,
        1690.0,
        120.0
      ],
      [
        1746.4769287109375,
        1690.0,
        120.0
      ],
      [
        1730.2777099609375,
        1690.0,
        120.0
      ],
      [
        1655.0001220703125,
        1690.0,
        120.0
      ],
      [
        1746.4769287109375,
        1690.0,
        140.0
      ],
      [
        1730.2777099609375,
        1690.0,
        140.0
      ],
      [
        1730.2777099609375,
        1690.0,
        140.0
      ],
      [
        1655.0001220703125,
        1690.0,
        140.0
      ],
      [
        1746.4769287109375,
        1690.0,
        120.0
      ],
      [
        1736.076904296875,
        1700.4000244140625,
        123.0
      ],
      [
        1746.4769287109375,
        1690.0,
        123.0
      ],
      [
        1721.0067138671875,
        1756.268310546875,
        132.0
      ],
      [
        1731.3160400390625,
        1795.0,
        130.0
      ],
      [
        1730.78369140625,
        1793.0,
        124.0
      ],
      [
        1730.78369140625,
        1793.0,
        124.0
      ],
      [
        1738.8155517578125,
        1697.661376953125,
        140.0
      ],
      [
        1746.4769287109375,
        1690.0,
        140.0
      ],
      [
        1738.8155517578125,
        1697.661376953125,
        123.0
      ],
      [
        1736.076904296875,
        1700.4000244140625,
        132.0
      ],
      [
        1738.8155517578125,
        1697.661376953125,
        132.0
      ],
      [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      [
        1660.0,
        1767.4713134765625,
        1130.0
      ],
      [
        1930.0001220703125,
        1760.000244140625,
        1110.0
      ],
      [
        1917.9425048828125,
        1805.000244140625,
        1110.0
      ],
      [
        -309.5,
        971.800048828125,
        400.0
      ],
      [
        -309.5,
        1051.800048828125,
        400.0
      ],
      [
        -399.5,
        1158.39990234375,
        400.0
      ],
      [
        -434.5,
        1219.021728515625,
        400.0
      ],
      [
        -434.5,
        1219.021728515625,
        400.0
      ],
      [
        -504.5,
        1219.021728515625,
        400.0
      ],
      [
        -309.5,
        1210.361328125,
        450.0
      ],
      [
        -309.5,
        1210.361328125,
        400.0
      ],
      [
        -254.5,
        911.17822265625,
        400.0
      ],
      [
        -289.5,
        971.800048828125,
        400.0
      ],
      [
        -289.5,
        971.800048828125,
        400.0
      ],
      [
        -309.5,
        971.800048828125,
        400.0
      ],
      [
        -109.5,
        1158.39990234375,
        400.0
      ],
      [
        -144.5,
        1219.021728515625,
        400.0
      ],
      [
        -144.5,
        1219.021728515625,
        400.0
      ],
      [
        -214.5,
        1219.021728515625,
        400.0
      ],
      [
        -144.5,
        1097.7781982421875,
        400.0
      ],
      [
        -109.5,
        1158.39990234375,
        400.0
      ],
      [
        1522.5999755859375,
        630.0,
        317.0
      ],
      [
        1522.5999755859375,
        600.0,
        317.0
      ],
      [
        1640.0,
        630.0,
        348.0
      ],
      [
        1640.0,
        630.0,
        338.0
      ],
      [
        1640.0,
        650.0,
        348.0
      ],
      [
        1640.0,
        650.0,
        338.0
      ],
      [
        1910.0,
        1579.9000244140625,
        1060.0
      ],
      [
        1910.0,
        1470.0,
        1060.0
      ],
      [
        1910.0,
        1690.0,
        350.0
      ],
      [
        1910.0,
        1619.3614501953125,
        340.0
      ],
      [
        1910.0,
        1608.986083984375,
        340.0
      ],
      [
        1910.0,
        1608.986083984375,
        340.0
      ],
      [
        1910.0,
        1608.986083984375,
        350.0
      ],
      [
        1911.8759765625,
        1688.1240234375,
        340.0
      ],
      [
        1912.653076171875,
        1690.0,
        340.0
      ],
      [
        1910.0,
        1676.5230712890625,
        350.0
      ],
      [
        1911.8759765625,
        1688.1240234375,
        340.0
      ],
      [
        1910.0,
        1687.346923828125,
        340.0
      ],
      [
        1770.0,
        1689.9998779296875,
        350.0
      ],
      [
        1770.0,
        1555.0,
        140.0
      ],
      [
        1770.0,
        1666.4769287109375,
        140.0
      ],
      [
        1770.0,
        1608.9862060546875,
        340.0
      ],
      [
        1770.0,
        1608.9862060546875,
        350.0
      ],
      [
        1770.0,
        1619.3614501953125,
        340.0
      ],
      [
        1770.0,
        1608.9862060546875,
        340.0
      ],
      [
        1840.0,
        1469.9998779296875,
        120.0
      ],
      [
        1814.0194091796875,
        1469.9998779296875,
        120.0
      ],
      [
        1865.9805908203125,
        1469.9998779296875,
        120.0
      ],
      [
        1840.0,
        1469.9998779296875,
        120.0
      ],
      [
        1890.6220703125,
        1469.9998779296875,
        120.0
      ],
      [
        1865.9805908203125,
        1469.9998779296875,
        120.0
      ],
      [
        1789.3779296875,
        1469.9998779296875,
        120.0
      ],
      [
        1814.0194091796875,
        1469.9998779296875,
        120.0
      ],
      [
        1770.0,
        1666.4769287109375,
        120.0
      ],
      [
        1770.0,
        1555.0,
        120.0
      ],
      [
        1770.0,
        1666.4769287109375,
        120.0
      ],
      [
        1770.0,
        1666.4769287109375,
        140.0
      ],
      [
        1789.3779296875,
        1469.9998779296875,
        135.0
      ],
      [
        1814.019287109375,
        1469.9998779296875,
        135.0
      ],
      [
        1840.0,
        1469.9998779296875,
        135.0
      ],
      [
        1865.980712890625,
        1469.9998779296875,
        135.0
      ],
      [
        1814.019287109375,
        1469.9998779296875,
        135.0
      ],
      [
        1840.0,
        1469.9998779296875,
        135.0
      ],
      [
        1789.3779296875,
        1469.9998779296875,
        120.0
      ],
      [
        1789.3779296875,
        1469.9998779296875,
        135.0
      ],
      [
        1890.6220703125,
        1469.9998779296875,
        120.0
      ],
      [
        1890.6220703125,
        1469.9998779296875,
        135.0
      ],
      [
        1830.0,
        1466.438720703125,
        120.0
      ],
      [
        1830.0,
        1469.9998779296875,
        120.0
      ],
      [
        1830.0,
        1466.438720703125,
        135.0
      ],
      [
        1830.0,
        1469.9998779296875,
        135.0
      ],
      [
        1830.0,
        1383.561279296875,
        120.0
      ],
      [
        1830.0,
        1357.679443359375,
        120.0
      ],
      [
        1830.0,
        1357.679443359375,
        135.0
      ],
      [
        1830.0,
        1383.561279296875,
        135.0
      ],
      [
        1830.0,
        1357.679443359375,
        120.0
      ],
      [
        1830.0,
        1357.679443359375,
        135.0
      ],
      [
        1770.0,
        700.0,
        258.0
      ],
      [
        1770.0,
        700.0,
        338.0
      ],
      [
        1683.5,
        1400.0,
        140.0
      ],
      [
        1630.0,
        1450.0,
        138.0
      ],
      [
        1630.0,
        1450.0,
        140.0
      ],
      [
        1655.0,
        1450.0,
        135.0
      ],
      [
        1630.0,
        1470.0,
        140.0
      ],
      [
        1630.0,
        1450.0001220703125,
        120.0
      ],
      [
        1655.0,
        1468.0,
        138.0
      ],
      [
        1655.0,
        1470.0,
        138.0
      ],
      [
        1630.0,
        1470.0,
        138.0
      ],
      [
        1630.0,
        1467.9998779296875,
        138.0
      ],
      [
        1630.0,
        1470.0,
        138.0
      ],
      [
        1655.0,
        1470.0,
        138.0
      ],
      [
        1655.0,
        1470.0,
        140.0
      ],
      [
        1630.0,
        1470.0,
        140.0
      ],
      [
        1630.0,
        1450.0,
        138.0
      ],
      [
        1655.0,
        1450.0,
        138.0
      ],
      [
        1655.0001220703125,
        1450.0,
        140.0
      ],
      [
        1653.0001220703125,
        1450.0,
        138.0
      ],
      [
        1653.0,
        1468.0,
        138.0
      ],
      [
        1650.0,
        1450.0,
        135.0
      ],
      [
        1650.0,
        1450.0,
        135.0
      ],
      [
        1770.0,
        1450.0,
        138.0
      ],
      [
        1770.0,
        1468.0,
        138.0
      ],
      [
        1695.0,
        1468.0,
        138.0
      ],
      [
        1695.0,
        1450.0,
        140.0
      ],
      [
        1697.0,
        1468.0,
        138.0
      ],
      [
        1697.0,
        1450.0,
        138.0
      ],
      [
        1655.0,
        1470.0,
        135.0
      ],
      [
        1695.0001220703125,
        1470.0,
        135.0
      ],
      [
        1695.0001220703125,
        1470.0,
        135.0
      ],
      [
        1695.0,
        1470.0,
        120.0
      ],
      [
        1655.0,
        1450.0,
        135.0
      ],
      [
        1695.0,
        1450.0,
        135.0
      ],
      [
        1700.0,
        1450.0,
        135.0
      ],
      [
        1695.0,
        1450.0,
        135.0
      ],
      [
        1700.0,
        1450.0,
        135.0
      ],
      [
        1746.4769287109375,
        1690.0,
        135.0
      ],
      [
        1770.0,
        1666.4769287109375,
        135.0
      ],
      [
        1680.0,
        1655.0,
        135.0
      ],
      [
        1690.0,
        1655.0,
        135.0
      ],
      [
        1690.0,
        1655.0,
        135.0
      ],
      [
        1690.0,
        1665.0,
        135.0
      ],
      [
        1680.0,
        1665.0,
        135.0
      ],
      [
        1680.0,
        1655.0,
        135.0
      ],
      [
        1690.0,
        1610.0,
        135.0
      ],
      [
        1690.0,
        1620.0,
        135.0
      ],
      [
        1680.0,
        1620.0,
        135.0
      ],
      [
        1680.0,
        1610.0,
        135.0
      ],
      [
        1680.0,
        1610.0,
        135.0
      ],
      [
        1690.0,
        1610.0,
        135.0
      ],
      [
        1740.0,
        1550.0,
        125.0
      ],
      [
        1710.5,
        1535.0,
        120.0
      ],
      [
        1720.0,
        1535.0,
        125.0
      ],
      [
        1720.0,
        1535.0,
        132.0
      ],
      [
        1630.0,
        1450.0,
        120.0
      ],
      [
        1660.0,
        1400.0,
        138.0
      ],
      [
        1660.0,
        1400.0,
        138.0
      ],
      [
        1660.0,
        1400.0,
        140.0
      ],
      [
        1680.0,
        1441.0,
        138.0
      ],
      [
        1660.0,
        1441.0001220703125,
        138.0
      ],
      [
        1660.0,
        1440.0001220703125,
        140.0
      ],
      [
        1680.0,
        1440.0,
        140.0
      ],
      [
        1697.0,
        1441.0,
        138.0
      ],
      [
        1695.0,
        1441.0,
        138.0
      ],
      [
        1695.0,
        1441.0,
        138.0
      ],
      [
        1697.0,
        1450.0,
        138.0
      ],
      [
        1697.0,
        1441.0,
        138.0
      ],
      [
        1683.5,
        1410.0,
        140.0
      ],
      [
        1683.5,
        1400.0,
        140.0
      ],
      [
        1683.5,
        1410.0,
        140.0
      ],
      [
        1653.0001220703125,
        1441.0001220703125,
        138.0
      ],
      [
        1653.0001220703125,
        1450.0,
        138.0
      ],
      [
        1655.0001220703125,
        1441.0001220703125,
        138.0
      ],
      [
        1653.0001220703125,
        1441.0001220703125,
        138.0
      ],
      [
        1655.0001220703125,
        1441.0001220703125,
        138.0
      ],
      [
        1630.0,
        920.0,
        80.0
      ],
      [
        1680.0,
        920.0,
        80.0
      ],
      [
        1680.0,
        920.0,
        100.0
      ],
      [
        1630.0,
        920.0,
        100.0
      ],
      [
        1630.0,
        920.0,
        100.0
      ],
      [
        1680.0,
        920.0,
        100.0
      ],
      [
        1680.0,
        840.0,
        100.0
      ],
      [
        1630.0,
        840.0,
        100.0
      ],
      [
        1630.0,
        810.0,
        100.0
      ],
      [
        1680.0,
        810.0,
        100.0
      ],
      [
        1680.0,
        810.0,
        140.0
      ],
      [
        1630.0,
        810.0,
        140.0
      ],
      [
        1630.0,
        840.0,
        120.0
      ],
      [
        1680.0,
        840.0,
        120.0
      ],
      [
        1680.0,
        810.0,
        120.0
      ],
      [
        1630.0,
        810.0,
        120.0
      ],
      [
        1680.0,
        840.0,
        120.0
      ],
      [
        1630.0,
        840.0,
        120.0
      ],
      [
        1630.0,
        840.0,
        100.0
      ],
      [
        1680.0,
        840.0,
        100.0
      ],
      [
        1667.5,
        882.5,
        140.0
      ],
      [
        1667.5,
        877.5,
        140.0
      ],
      [
        1667.5,
        882.5,
        140.0
      ],
      [
        1672.5,
        882.5,
        140.0
      ],
      [
        1672.5,
        882.5,
        140.0
      ],
      [
        1672.5,
        877.5,
        140.0
      ],
      [
        1680.0,
        960.0,
        98.0
      ],
      [
        1680.0,
        960.0,
        100.0
      ],
      [
        1630.0,
        960.0,
        100.0
      ],
      [
        1630.0,
        960.0,
        98.0
      ],
      [
        1630.0,
        960.0,
        80.0
      ],
      [
        1680.0,
        960.0,
        80.0
      ],
      [
        1650.0,
        960.0,
        118.0
      ],
      [
        1630.0,
        960.0,
        118.0
      ],
      [
        1680.0,
        920.0,
        118.0
      ],
      [
        1680.0,
        940.0,
        118.0
      ],
      [
        1630.0,
        960.0,
        120.0
      ],
      [
        1650.0,
        960.0,
        120.0
      ],
      [
        1680.0,
        940.0,
        120.0
      ],
      [
        1680.0,
        920.0,
        120.0
      ],
      [
        1680.0,
        940.0,
        118.0
      ],
      [
        1680.0,
        940.0,
        120.0
      ],
      [
        1650.0,
        960.0,
        118.0
      ],
      [
        1650.0,
        960.0,
        120.0
      ],
      [
        1680.0,
        940.0,
        100.0
      ],
      [
        1680.0,
        960.0,
        100.0
      ],
      [
        1630.0,
        960.0,
        100.0
      ],
      [
        1630.0,
        940.0,
        100.0
      ],
      [
        1630.0,
        1026.25,
        87.49999237060547
      ],
      [
        1680.0,
        1026.25,
        87.49999237060547
      ],
      [
        1657.0,
        1150.0,
        138.0
      ],
      [
        1657.0,
        1140.0,
        138.0
      ],
      [
        1657.0,
        1150.0,
        138.0
      ],
      [
        1633.0,
        1140.0,
        120.0
      ],
      [
        1633.0,
        1150.0,
        120.0
      ],
      [
        1633.0,
        1150.0,
        120.0
      ],
      [
        1650.0,
        1150.0,
        133.3333282470703
      ],
      [
        1650.0,
        1140.0,
        133.3333282470703
      ],
      [
        1650.0,
        1140.0,
        131.3333282470703
      ],
      [
        1650.0,
        1150.0,
        131.3333282470703
      ],
      [
        1650.0,
        1150.0,
        133.3333282470703
      ],
      [
        1650.0,
        1150.0,
        131.3333282470703
      ],
      [
        1650.0,
        1120.0,
        100.0
      ],
      [
        1650.0,
        1026.25,
        87.49999237060547
      ],
      [
        1650.0,
        1120.0,
        100.0
      ],
      [
        1650.0,
        1170.0,
        100.0
      ],
      [
        1653.0,
        993.0,
        120.0
      ],
      [
        1660.0,
        993.0,
        120.0
      ],
      [
        1653.0,
        993.0,
        120.0
      ],
      [
        1650.0,
        993.0,
        120.0
      ],
      [
        1750.0,
        810.0,
        140.0
      ],
      [
        1690.0,
        1120.0,
        140.0
      ],
      [
        1690.0,
        1200.0,
        139.99998474121094
      ],
      [
        1690.0,
        1120.0,
        139.99998474121094
      ],
      [
        1690.0,
        995.0,
        140.0
      ],
      [
        1690.0,
        982.5,
        80.0
      ],
      [
        1690.0,
        970.0,
        80.0
      ],
      [
        1690.0,
        920.0,
        80.0
      ],
      [
        1690.0,
        970.0,
        80.0
      ],
      [
        1690.0,
        940.0,
        118.0
      ],
      [
        1690.0,
        940.0,
        120.0
      ],
      [
        1690.0,
        940.0,
        120.0
      ],
      [
        1690.0,
        920.0,
        120.0
      ],
      [
        1690.0,
        920.0,
        118.0
      ],
      [
        1690.0,
        940.0,
        118.0
      ],
      [
        1750.0,
        1220.0,
        139.99998474121094
      ],
      [
        1710.0,
        1220.0,
        140.0
      ],
      [
        1690.0,
        1210.0,
        100.0
      ],
      [
        1690.0,
        1210.0,
        140.0
      ],
      [
        1710.0,
        1220.0,
        139.99998474121094
      ],
      [
        1690.0,
        1200.0,
        140.0
      ],
      [
        1770.0,
        1200.0,
        139.99998474121094
      ],
      [
        1750.0,
        1220.0,
        140.0
      ],
      [
        1690.0,
        940.0,
        100.0
      ],
      [
        1690.0,
        960.0,
        100.0
      ],
      [
        1690.0,
        960.0,
        98.0
      ],
      [
        1690.0,
        960.0,
        100.0
      ],
      [
        1690.0,
        1210.0,
        100.0
      ],
      [
        1681.9998779296875,
        970.0,
        80.0
      ],
      [
        1685.9998779296875,
        920.0,
        80.0
      ],
      [
        1681.9998779296875,
        970.0,
        80.0
      ],
      [
        1690.0,
        1210.0,
        119.99980163574219
      ],
      [
        1680.0,
        1200.0,
        112.79998016357422
      ],
      [
        1690.0,
        1210.0,
        134.40017700195312
      ],
      [
        1547.9998779296875,
        1467.9998779296875,
        138.0
      ],
      [
        1547.9998779296875,
        1480.0,
        138.0
      ],
      [
        1547.9998779296875,
        1684.999755859375,
        138.0
      ],
      [
        1547.9998779296875,
        1690.0,
        138.0
      ],
      [
        1547.9998779296875,
        1467.9998779296875,
        138.0
      ],
      [
        1547.9998779296875,
        1450.0,
        138.0
      ],
      [
        1550.0,
        1450.0,
        138.0
      ],
      [
        1547.9998779296875,
        1684.999755859375,
        138.0
      ],
      [
        1547.9998779296875,
        1480.0,
        138.0
      ],
      [
        1547.9998779296875,
        1507.455810546875,
        138.0
      ],
      [
        1549.9998779296875,
        1505.455810546875,
        138.0
      ],
      [
        1530.0,
        1450.0,
        120.0
      ],
      [
        1550.0,
        1480.0,
        120.0
      ],
      [
        1550.0,
        1450.0,
        120.0
      ],
      [
        1550.0,
        1480.0,
        120.0
      ],
      [
        1530.0,
        1450.0,
        138.0
      ],
      [
        1530.0,
        1690.0,
        138.0
      ],
      [
        1587.455810546875,
        1467.9998779296875,
        138.0
      ],
      [
        1630.0,
        1468.0,
        138.0
      ],
      [
        1587.455810546875,
        1467.9998779296875,
        138.0
      ],
      [
        1585.4556884765625,
        1470.0,
        138.0
      ],
      [
        1549.9998779296875,
        1505.455810546875,
        138.0
      ],
      [
        1530.0,
        1120.0,
        100.0
      ],
      [
        1530.0,
        1170.0,
        100.0
      ],
      [
        1530.0,
        1140.0,
        120.0
      ],
      [
        1530.0,
        1120.0,
        120.0
      ],
      [
        1530.0,
        1120.0,
        118.0
      ],
      [
        1530.0,
        1140.0,
        118.0
      ],
      [
        1530.0,
        1140.0,
        120.0
      ],
      [
        1530.0,
        1140.0,
        118.0
      ],
      [
        1555.0,
        1120.0,
        130.0
      ],
      [
        1615.0,
        1120.0,
        130.0
      ],
      [
        1535.0,
        1120.0,
        130.0
      ],
      [
        1530.0,
        1130.0,
        140.0
      ],
      [
        1530.0,
        1120.0,
        130.0
      ],
      [
        1535.0,
        1120.0,
        140.0
      ],
      [
        1535.0,
        1120.0,
        130.0
      ],
      [
        1615.0,
        1120.0,
        140.0
      ],
      [
        1615.0,
        1120.0,
        130.0
      ],
      [
        1555.0,
        1120.0,
        140.0
      ],
      [
        1555.0,
        1130.0,
        140.0
      ],
      [
        1555.0,
        1128.0,
        138.0
      ],
      [
        1555.0,
        1120.0,
        138.0
      ],
      [
        1566.5,
        1440.0,
        124.75005340576172
      ],
      [
        1566.5,
        1450.0,
        124.75005340576172
      ],
      [
        1600.0,
        860.0,
        140.0
      ],
      [
        1600.0,
        890.0,
        140.0
      ],
      [
        1600.0,
        920.0,
        140.0
      ],
      [
        1580.0,
        845.0,
        138.5
      ],
      [
        1598.0,
        845.0,
        138.5
      ],
      [
        1580.0,
        845.0,
        140.0
      ],
      [
        1598.0,
        845.0,
        140.0
      ],
      [
        1600.0,
        860.0,
        140.0
      ],
      [
        1598.0,
        860.0,
        140.0
      ],
      [
        1600.0,
        810.0,
        140.0
      ],
      [
        1530.0,
        960.0,
        100.0
      ],
      [
        1530.0,
        960.0,
        98.0
      ],
      [
        1530.0,
        960.0,
        80.0
      ],
      [
        1630.0,
        960.0,
        80.0
      ],
      [
        1530.0,
        960.0,
        100.0
      ],
      [
        1530.0,
        940.0,
        100.0
      ],
      [
        1600.0,
        940.0,
        140.0
      ],
      [
        1530.0,
        940.0,
        140.0
      ],
      [
        1600.0,
        920.0,
        140.0
      ],
      [
        1600.0,
        940.0,
        140.0
      ],
      [
        1530.0,
        1110.0,
        120.0
      ],
      [
        1530.0,
        1120.0,
        100.0
      ],
      [
        1530.0,
        1110.0,
        120.0
      ],
      [
        1250.0,
        880.0,
        139.99998474121094
      ],
      [
        1250.0,
        720.0,
        140.0
      ],
      [
        1480.0,
        1350.0,
        140.0
      ],
      [
        1480.0,
        1350.0,
        115.65217590332031
      ],
      [
        1480.0,
        1120.0,
        100.0
      ],
      [
        1480.0,
        1170.0,
        100.0
      ],
      [
        1480.0,
        1140.0,
        120.0
      ],
      [
        1480.0,
        1120.0,
        120.0
      ],
      [
        1480.0,
        1120.0,
        118.0
      ],
      [
        1480.0,
        1140.0,
        118.0
      ],
      [
        1480.0,
        1140.0,
        120.0
      ],
      [
        1480.0,
        1140.0,
        118.0
      ],
      [
        1480.0,
        1120.0,
        130.0
      ],
      [
        1530.0,
        1120.0,
        130.0
      ],
      [
        1480.0,
        1130.0,
        140.0
      ],
      [
        1513.2716064453125,
        1232.2733154296875,
        140.0
      ],
      [
        1505.5,
        1235.4296875,
        140.0
      ],
      [
        1513.2716064453125,
        1217.7266845703125,
        140.0
      ],
      [
        1516.3448486328125,
        1225.0,
        140.0
      ],
      [
        1505.5,
        1214.5703125,
        140.0
      ],
      [
        1513.2716064453125,
        1217.7266845703125,
        140.0
      ],
      [
        1516.3448486328125,
        1225.0,
        140.0
      ],
      [
        1513.2716064453125,
        1232.2733154296875,
        140.0
      ],
      [
        1480.0,
        1350.0,
        115.65217590332031
      ],
      [
        1480.0,
        1419.553466796875,
        138.0
      ],
      [
        1480.0,
        1610.0,
        138.0
      ],
      [
        1500.0,
        1690.0,
        138.0
      ],
      [
        1500.0,
        1640.0,
        138.0
      ],
      [
        1480.0,
        1419.553466796875,
        138.0
      ],
      [
        1480.0,
        1380.0,
        138.0
      ],
      [
        1480.0,
        1380.0,
        138.0
      ],
      [
        1480.0,
        1380.0,
        140.0
      ],
      [
        1500.0,
        1640.0,
        138.0
      ],
      [
        1500.0,
        1640.0,
        140.0
      ],
      [
        1480.0,
        1610.0,
        138.0
      ],
      [
        1480.0,
        1610.0,
        140.0
      ],
      [
        1260.75,
        1590.0,
        100.93478393554688
      ],
      [
        1260.75,
        1598.0,
        100.93478393554688
      ],
      [
        1260.75,
        1590.0,
        100.93478393554688
      ],
      [
        1260.75,
        1598.0,
        100.93478393554688
      ],
      [
        1257.887939453125,
        1629.6195068359375,
        140.0
      ],
      [
        1361.7835693359375,
        1625.1204833984375,
        140.0
      ],
      [
        1361.7835693359375,
        1625.1204833984375,
        140.0
      ],
      [
        1257.887939453125,
        1690.0,
        140.0
      ],
      [
        1257.887939453125,
        1629.6195068359375,
        140.0
      ],
      [
        1266.5,
        1590.0,
        138.0
      ],
      [
        1438.5,
        1580.0,
        140.0
      ],
      [
        1438.5,
        1570.0,
        140.0
      ],
      [
        1438.5,
        1580.0,
        140.0
      ],
      [
        1266.5,
        1580.0,
        138.0
      ],
      [
        1266.5,
        1590.0,
        138.0
      ],
      [
        1266.5,
        1580.0,
        138.0
      ],
      [
        1250.0,
        1590.0,
        126.57142639160156
      ],
      [
        1250.0,
        1580.0,
        126.57142639160156
      ],
      [
        1250.0,
        1580.0,
        128.57142639160156
      ],
      [
        1250.0,
        1590.0,
        128.57142639160156
      ],
      [
        1250.0,
        1590.0,
        128.57142639160156
      ],
      [
        1250.0,
        1590.0,
        126.57142639160156
      ],
      [
        1250.0,
        1580.0,
        126.57142639160156
      ],
      [
        1250.0,
        1580.0,
        128.57142639160156
      ],
      [
        1250.0,
        1598.0,
        112.11428833007812
      ],
      [
        1250.0,
        1590.0,
        112.11428833007812
      ],
      [
        1250.0,
        1590.0,
        112.11428833007812
      ],
      [
        1250.0,
        1590.0,
        110.11428833007812
      ],
      [
        1250.0,
        1598.0,
        110.11428833007812
      ],
      [
        1250.0,
        1598.0,
        112.11428833007812
      ],
      [
        1250.0,
        1590.0,
        110.11428833007812
      ],
      [
        1250.0,
        1598.0,
        110.11428833007812
      ],
      [
        1260.75,
        1590.0,
        104.46280670166016
      ],
      [
        1260.75,
        1598.0,
        104.46280670166016
      ],
      [
        1250.0,
        1120.0,
        120.0
      ],
      [
        1270.0001220703125,
        1140.0,
        120.0
      ],
      [
        1270.0001220703125,
        1140.0,
        118.0
      ],
      [
        1250.0,
        1120.0,
        118.0
      ],
      [
        1270.0001220703125,
        1140.0,
        118.0
      ],
      [
        1270.0001220703125,
        1140.0,
        120.0
      ],
      [
        1395.0,
        1120.0,
        130.0
      ],
      [
        1455.0,
        1120.0,
        130.0
      ],
      [
        1475.0,
        1120.0,
        130.0
      ],
      [
        1455.0,
        1120.0,
        140.0
      ],
      [
        1455.0,
        1120.0,
        130.0
      ],
      [
        1475.0,
        1120.0,
        140.0
      ],
      [
        1475.0,
        1130.0,
        140.0
      ],
      [
        1475.0,
        1128.0,
        138.0
      ],
      [
        1475.0,
        1120.0,
        138.0
      ],
      [
        1290.0,
        1160.0,
        138.0
      ],
      [
        1480.0,
        1420.0,
        138.0
      ],
      [
        1280.0,
        1180.0001220703125,
        138.0
      ],
      [
        1280.0,
        1180.0001220703125,
        140.0
      ],
      [
        1265.0,
        1205.0,
        100.0
      ],
      [
        1250.0,
        1190.0,
        100.0
      ],
      [
        1250.0,
        1140.0,
        118.0
      ],
      [
        1250.0,
        1140.0,
        120.0
      ],
      [
        1250.0,
        1140.0,
        118.0
      ],
      [
        1250.0,
        1140.0,
        120.0
      ],
      [
        1480.0,
        720.0,
        139.99998474121094
      ],
      [
        1480.0,
        880.0,
        140.0
      ],
      [
        1480.0,
        880.0,
        139.99998474121094
      ],
      [
        1250.0,
        880.0,
        140.0
      ],
      [
        1480.0,
        960.0,
        100.0
      ],
      [
        1250.0,
        1030.0,
        80.0
      ],
      [
        1258.0,
        1030.0,
        140.0
      ],
      [
        1250.0,
        1030.0,
        140.0
      ],
      [
        1030.0,
        1120.0,
        130.0
      ],
      [
        1030.0,
        1120.0,
        82.10526275634766
      ],
      [
        1200.0,
        1280.0,
        140.0
      ],
      [
        1200.0,
        1300.0,
        140.0
      ],
      [
        1200.0,
        1550.0,
        140.0
      ],
      [
        1200.0,
        1570.0,
        140.0
      ],
      [
        1200.0,
        1170.0,
        140.0
      ],
      [
        1200.0,
        1280.0,
        140.0
      ],
      [
        1200.0,
        1550.0,
        140.0
      ],
      [
        1200.0,
        1460.0,
        140.0
      ],
      [
        1200.0,
        1390.0,
        140.0
      ],
      [
        1200.0,
        1300.0,
        140.0
      ],
      [
        1250.0,
        1170.0,
        100.0
      ],
      [
        1235.0,
        1170.0,
        118.0
      ],
      [
        1235.0,
        1170.0,
        120.0
      ],
      [
        1235.0,
        1670.0,
        120.0
      ],
      [
        1200.0,
        1400.0,
        120.0
      ],
      [
        1200.0,
        1460.0,
        120.0
      ],
      [
        1215.0,
        1170.0,
        120.0
      ],
      [
        1235.0,
        1170.0,
        120.0
      ],
      [
        1200.0,
        1610.0,
        120.0
      ],
      [
        1200.0,
        1590.0,
        120.0
      ],
      [
        1235.0,
        1670.0,
        118.0
      ],
      [
        1200.0,
        1460.0,
        118.0
      ],
      [
        1200.0,
        1390.0,
        118.0
      ],
      [
        1235.0,
        1170.0,
        118.0
      ],
      [
        1215.0,
        1170.0,
        118.0
      ],
      [
        1200.0,
        1590.0,
        118.0
      ],
      [
        1200.0,
        1610.0,
        118.0
      ],
      [
        1215.0,
        1170.0,
        120.0
      ],
      [
        1215.0,
        1170.0,
        118.0
      ],
      [
        1235.0,
        1670.0,
        120.0
      ],
      [
        1215.0,
        1670.0,
        120.0
      ],
      [
        1215.0,
        1670.0,
        118.0
      ],
      [
        1235.0,
        1670.0,
        118.0
      ],
      [
        1200.0,
        1590.0,
        118.0
      ],
      [
        1200.0,
        1590.0,
        120.0
      ],
      [
        1200.0,
        1610.0,
        120.0
      ],
      [
        1200.0,
        1610.0,
        118.0
      ],
      [
        1200.0,
        1460.0,
        120.0
      ],
      [
        1200.0,
        1460.0,
        118.0
      ],
      [
        1235.0,
        1400.0,
        138.0
      ],
      [
        1235.0,
        1400.0,
        140.0
      ],
      [
        1200.0,
        1400.0,
        120.0
      ],
      [
        1200.0,
        1400.0,
        131.42857360839844
      ],
      [
        1235.0,
        1400.0,
        138.0
      ],
      [
        1235.0,
        1390.0,
        138.0
      ],
      [
        1211.5,
        1400.0,
        138.0
      ],
      [
        1211.5,
        1390.0,
        138.0
      ],
      [
        1200.0,
        1400.0,
        131.42857360839844
      ],
      [
        1200.0,
        1390.0,
        131.42857360839844
      ],
      [
        1240.0,
        1400.0,
        138.0
      ],
      [
        1240.0,
        1400.0,
        140.0
      ],
      [
        1238.8043212890625,
        1590.0,
        118.0
      ],
      [
        1238.5,
        1590.0,
        120.0
      ],
      [
        1238.8043212890625,
        1598.0,
        118.0
      ],
      [
        1238.8043212890625,
        1590.0,
        118.0
      ],
      [
        1238.8043212890625,
        1598.0,
        118.0
      ],
      [
        1238.5,
        1590.0,
        120.0
      ],
      [
        1238.5,
        1580.0,
        120.0
      ],
      [
        1238.5,
        1580.0,
        120.0
      ],
      [
        1030.0,
        1390.0,
        140.0
      ],
      [
        1200.0,
        1390.0,
        140.0
      ],
      [
        1200.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1300.0,
        140.0
      ],
      [
        1200.0,
        1280.0,
        140.0
      ],
      [
        1030.0,
        1280.0,
        140.0
      ],
      [
        1030.0,
        1570.0,
        140.0
      ],
      [
        1200.0,
        1570.0,
        140.0
      ],
      [
        1030.0,
        1550.0,
        140.0
      ],
      [
        1200.0,
        1550.0,
        140.0
      ],
      [
        1160.0,
        1390.0,
        118.0
      ],
      [
        1160.0,
        1460.0,
        118.0
      ],
      [
        1142.5,
        1415.0,
        120.0
      ],
      [
        1140.0,
        1415.771484375,
        118.0
      ],
      [
        1153.0,
        1418.0,
        118.0
      ],
      [
        1140.0,
        1415.1785888671875,
        120.0
      ],
      [
        1142.5,
        1415.0,
        120.0
      ],
      [
        1160.0,
        1418.75,
        140.0
      ],
      [
        1160.0,
        1390.0,
        140.0
      ],
      [
        1160.0,
        1460.0,
        140.0
      ],
      [
        1160.0,
        1431.25,
        140.0
      ],
      [
        1160.0,
        1418.75,
        140.0
      ],
      [
        1142.5,
        1420.0,
        140.0
      ],
      [
        1142.5,
        1430.0,
        140.0
      ],
      [
        1142.5,
        1420.0,
        140.0
      ],
      [
        1030.0,
        1620.0,
        114.0
      ],
      [
        1030.0,
        1620.0,
        116.0
      ],
      [
        1187.731689453125,
        1630.64794921875,
        140.0
      ],
      [
        1187.731689453125,
        1690.0,
        140.0
      ],
      [
        1187.731689453125,
        1630.0,
        140.0
      ],
      [
        1037.5947265625,
        1630.0,
        140.0
      ],
      [
        1187.731689453125,
        1630.0,
        140.0
      ],
      [
        1030.0,
        1590.0,
        118.0
      ],
      [
        1030.0,
        1590.0,
        120.0
      ],
      [
        1030.0,
        1610.0,
        120.0
      ],
      [
        1030.0,
        1590.0,
        120.0
      ],
      [
        1030.0,
        1590.0,
        118.0
      ],
      [
        1030.0,
        1610.0,
        118.0
      ],
      [
        1030.0,
        1610.0,
        118.0
      ],
      [
        1030.0,
        1610.0,
        120.0
      ],
      [
        1033.75,
        1610.0,
        118.0
      ],
      [
        1030.0,
        1610.0,
        114.0
      ],
      [
        1030.0,
        1620.0,
        114.0
      ],
      [
        1030.0,
        1610.0,
        116.0
      ],
      [
        1030.0,
        1610.0,
        114.0
      ],
      [
        1030.0,
        1120.0,
        82.10526275634766
      ],
      [
        1030.0,
        1140.0,
        120.0
      ],
      [
        1030.0,
        1120.0,
        120.0
      ],
      [
        1030.0,
        1140.0,
        120.0
      ],
      [
        1030.0,
        1140.0,
        118.0
      ],
      [
        1200.0,
        1120.0,
        120.0
      ],
      [
        1200.0,
        1120.0,
        118.0
      ],
      [
        1200.0,
        930.0,
        118.0
      ],
      [
        1200.0,
        930.0,
        120.0
      ],
      [
        1186.0,
        1030.0,
        120.0
      ],
      [
        1186.0,
        1030.0,
        118.0
      ],
      [
        1200.0,
        1030.0,
        118.0
      ],
      [
        1200.0,
        1030.0,
        120.0
      ],
      [
        1235.0,
        1030.0,
        118.0
      ],
      [
        1235.0,
        1030.0,
        120.0
      ],
      [
        1210.0,
        1082.0,
        120.0
      ],
      [
        1200.0,
        867.8525390625,
        140.0
      ],
      [
        1200.0,
        825.0,
        140.0
      ],
      [
        1189.5999755859375,
        940.4000244140625,
        140.0
      ],
      [
        1189.5999755859375,
        1109.5999755859375,
        140.0
      ],
      [
        1030.0,
        1110.0,
        130.0
      ],
      [
        1189.5999755859375,
        1109.5999755859375,
        140.0
      ],
      [
        1030.0,
        1109.5999755859375,
        140.0
      ],
      [
        1186.0,
        1030.0,
        140.0
      ],
      [
        1190.4000244140625,
        1030.0,
        120.0
      ],
      [
        1189.599853515625,
        1030.0,
        140.0
      ],
      [
        1189.5999755859375,
        970.0000610351562,
        140.0
      ],
      [
        1189.199951171875,
        970.4000244140625,
        140.0
      ],
      [
        1160.0,
        1109.5999755859375,
        140.0
      ],
      [
        1159.5999755859375,
        1109.199951171875,
        140.0
      ],
      [
        1189.199951171875,
        1079.5999755859375,
        140.0
      ],
      [
        1189.5999755859375,
        1080.0,
        140.0
      ],
      [
        1050.4000244140625,
        1109.199951171875,
        140.0
      ],
      [
        1050.0,
        1109.5999755859375,
        140.0
      ],
      [
        1163.3333740234375,
        1113.3333740234375,
        140.0
      ],
      [
        1046.6666259765625,
        1113.3333740234375,
        140.0
      ],
      [
        1163.7333984375,
        1113.3333740234375,
        140.0
      ],
      [
        1046.2666015625,
        1113.3333740234375,
        140.0
      ],
      [
        1190.0,
        1120.0,
        130.0
      ],
      [
        1189.599853515625,
        1119.199951171875,
        140.0
      ],
      [
        1169.5999755859375,
        1119.199951171875,
        140.0
      ],
      [
        1030.0,
        1120.0,
        130.0
      ],
      [
        1040.4000244140625,
        1119.199951171875,
        140.0
      ],
      [
        1030.0,
        1119.199951171875,
        140.0
      ],
      [
        1040.4000244140625,
        1119.199951171875,
        140.0
      ],
      [
        1169.5999755859375,
        1119.199951171875,
        140.0
      ],
      [
        1193.3333740234375,
        1083.3333740234375,
        140.0
      ],
      [
        1193.3333740234375,
        966.6666870117188,
        140.0
      ],
      [
        1200.0,
        1030.0,
        120.0
      ],
      [
        1200.0,
        1030.0,
        130.0
      ],
      [
        1193.3333740234375,
        1030.0,
        140.0
      ],
      [
        1193.33349609375,
        966.2665405273438,
        140.0
      ],
      [
        1193.33349609375,
        1083.7335205078125,
        140.0
      ],
      [
        1193.3333740234375,
        1119.199951171875,
        140.0
      ],
      [
        1199.199951171875,
        930.7999877929688,
        140.0
      ],
      [
        1199.199951171875,
        960.4000244140625,
        140.0
      ],
      [
        1199.199951171875,
        1089.5999755859375,
        140.0
      ],
      [
        1199.199951171875,
        1119.199951171875,
        140.0
      ],
      [
        1199.199951171875,
        1089.5999755859375,
        140.0
      ],
      [
        1199.199951171875,
        1119.199951171875,
        140.0
      ],
      [
        1199.199951171875,
        960.4000244140625,
        140.0
      ],
      [
        1199.199951171875,
        1030.0,
        140.0
      ],
      [
        1200.0,
        1030.0,
        140.0
      ],
      [
        1235.0,
        1030.0,
        140.0
      ],
      [
        1235.0,
        1035.0,
        138.0
      ],
      [
        1235.0,
        1055.0,
        138.0
      ],
      [
        1235.0,
        1055.0,
        138.0
      ],
      [
        1235.0,
        1055.0,
        140.0
      ],
      [
        1210.0,
        1058.0,
        138.0
      ],
      [
        1235.0,
        1120.0,
        100.0
      ],
      [
        1235.0,
        930.0,
        80.0
      ],
      [
        1186.0,
        1030.0,
        90.52631378173828
      ],
      [
        1235.0,
        1030.0,
        80.0
      ],
      [
        1235.0,
        1030.0,
        90.52631378173828
      ],
      [
        1200.0,
        1030.0,
        90.52631378173828
      ],
      [
        1200.0,
        1030.0,
        118.0
      ],
      [
        1250.0,
        1030.0,
        90.52631378173828
      ],
      [
        1235.0,
        1030.0,
        90.52631378173828
      ],
      [
        780.0,
        1540.0,
        100.0
      ],
      [
        780.0,
        1540.0,
        98.0
      ],
      [
        790.0,
        1540.0,
        98.0
      ],
      [
        790.0,
        1540.0,
        100.0
      ],
      [
        820.0,
        1540.0,
        100.0
      ],
      [
        820.0,
        1540.0,
        98.0
      ],
      [
        945.5584716796875,
        1540.0,
        98.0
      ],
      [
        945.5584716796875,
        1540.0,
        100.0
      ],
      [
        890.0,
        1472.83544921875,
        98.0
      ],
      [
        890.0,
        1472.83544921875,
        100.0
      ],
      [
        945.5584716796875,
        1540.0,
        100.0
      ],
      [
        945.5584716796875,
        1540.0,
        98.0
      ],
      [
        790.0,
        1540.0,
        100.0
      ],
      [
        790.0,
        1540.0,
        98.0
      ],
      [
        790.0,
        1530.0,
        98.0
      ],
      [
        790.0,
        1530.0,
        100.0
      ],
      [
        980.0,
        1170.0,
        98.0
      ],
      [
        960.0,
        1120.0,
        98.0
      ],
      [
        933.0026245117188,
        1540.0,
        98.0
      ],
      [
        933.0026245117188,
        1570.0,
        98.0
      ],
      [
        960.0,
        1570.0,
        100.0
      ],
      [
        960.0,
        1570.0,
        98.0
      ],
      [
        980.0,
        1570.0,
        98.0
      ],
      [
        980.0,
        1570.0,
        100.0
      ],
      [
        895.0,
        1635.0,
        100.0
      ],
      [
        885.0,
        1635.0,
        100.0
      ],
      [
        885.0,
        1625.0,
        100.0
      ],
      [
        980.0,
        1120.0,
        80.0
      ],
      [
        780.0,
        1540.0,
        80.0
      ],
      [
        790.0,
        1540.0,
        80.0
      ],
      [
        820.0,
        1540.0,
        80.0
      ],
      [
        945.5584716796875,
        1540.0,
        80.0
      ],
      [
        890.0,
        1472.83544921875,
        80.0
      ],
      [
        945.5584716796875,
        1540.0,
        80.0
      ],
      [
        790.0,
        1540.0,
        80.0
      ],
      [
        790.0,
        1530.0,
        80.0
      ],
      [
        960.0,
        1570.0,
        80.0
      ],
      [
        840.0,
        1540.0,
        120.0
      ],
      [
        840.0,
        1570.0,
        120.0
      ],
      [
        960.0,
        1570.0,
        120.0
      ],
      [
        980.0,
        1570.0,
        120.0
      ],
      [
        840.0,
        1570.0,
        120.0
      ],
      [
        840.0,
        1570.0,
        140.0
      ],
      [
        890.0,
        1472.83544921875,
        120.0
      ],
      [
        890.0,
        1472.83544921875,
        140.0
      ],
      [
        945.5584716796875,
        1540.0,
        140.0
      ],
      [
        971.7703247070312,
        1120.0,
        120.0
      ],
      [
        980.0,
        1120.0,
        133.9837646484375
      ],
      [
        980.0,
        1143.07421875,
        120.0
      ],
      [
        840.0,
        1610.0,
        140.0
      ],
      [
        940.0,
        1610.0,
        120.0
      ],
      [
        840.0,
        1610.0,
        120.0
      ],
      [
        940.0,
        1650.0,
        120.0
      ],
      [
        940.0,
        1610.0,
        120.0
      ],
      [
        955.0,
        1655.0,
        140.0
      ],
      [
        980.0,
        1670.0,
        140.0
      ],
      [
        980.0,
        1670.0,
        140.0
      ],
      [
        960.0,
        1690.0,
        140.0
      ],
      [
        980.0,
        1590.0,
        140.0
      ],
      [
        955.0,
        1605.0,
        140.0
      ],
      [
        960.0,
        1570.0,
        140.0
      ],
      [
        980.0,
        1590.0,
        140.0
      ],
      [
        840.0,
        1540.0,
        100.0
      ],
      [
        840.0,
        1540.0,
        120.0
      ],
      [
        980.0,
        1143.07421875,
        120.0
      ],
      [
        840.0,
        1610.0,
        100.0
      ],
      [
        820.0,
        1540.0,
        140.0
      ],
      [
        815.0,
        1665.0,
        140.0
      ],
      [
        800.0,
        1690.0,
        140.0
      ],
      [
        840.0,
        1610.0,
        120.0
      ],
      [
        820.0,
        1610.0,
        120.0
      ],
      [
        815.0,
        1595.0,
        140.0
      ],
      [
        805.0,
        1605.0,
        140.0
      ],
      [
        1000.0,
        1120.0,
        100.0
      ],
      [
        1003.75,
        1610.0,
        100.0
      ],
      [
        1003.75,
        1620.0,
        100.0
      ],
      [
        1003.75,
        1620.0,
        100.0
      ],
      [
        1003.75,
        1610.0,
        100.0
      ],
      [
        980.0,
        1120.0,
        120.0
      ],
      [
        950.0,
        1120.0,
        80.0
      ],
      [
        950.0,
        970.0,
        80.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        120.0
      ],
      [
        865.0,
        1100.0,
        120.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        140.0
      ],
      [
        865.0,
        1100.0,
        140.0
      ],
      [
        1010.7999877929688,
        1119.199951171875,
        140.0
      ],
      [
        1020.4000244140625,
        1109.5999755859375,
        140.0
      ],
      [
        720.0,
        1640.0,
        140.0
      ],
      [
        720.0,
        1460.0,
        140.0
      ],
      [
        700.0,
        1000.0,
        140.0
      ],
      [
        700.0,
        1090.0,
        140.0
      ],
      [
        720.0,
        1550.0,
        190.0
      ],
      [
        720.0,
        1550.0,
        140.0
      ],
      [
        450.0,
        1550.0,
        190.0
      ],
      [
        450.0,
        1550.0,
        240.0
      ],
      [
        450.0,
        1550.0,
        240.0
      ],
      [
        450.0,
        1550.0,
        279.13043212890625
      ],
      [
        380.6481018066406,
        1550.0,
        291.6202087402344
      ],
      [
        419.63916015625,
        1550.0,
        281.75616455078125
      ],
      [
        309.8317565917969,
        1550.0,
        319.85107421875
      ],
      [
        380.6481018066406,
        1550.0,
        291.6202087402344
      ],
      [
        269.94561767578125,
        1550.0,
        340.0
      ],
      [
        309.8317565917969,
        1550.0,
        319.85107421875
      ],
      [
        1480.0,
        1550.0,
        140.0
      ],
      [
        1480.0,
        1550.0,
        160.0
      ],
      [
        1549.9998779296875,
        1550.0,
        370.0
      ],
      [
        1549.9998779296875,
        1550.0,
        500.0
      ],
      [
        1549.9998779296875,
        1550.0,
        370.0
      ],
      [
        1549.9998779296875,
        1550.0,
        140.0
      ],
      [
        1549.9998779296875,
        1550.0,
        500.0
      ],
      [
        1549.9998779296875,
        1550.0,
        1180.0
      ],
      [
        1480.0,
        1618.300048828125,
        177.0
      ],
      [
        1480.0,
        1690.0,
        177.0
      ],
      [
        1480.0,
        1610.0,
        177.0
      ],
      [
        1480.0,
        1618.300048828125,
        177.0
      ],
      [
        1480.0,
        1690.0,
        179.0
      ],
      [
        1480.0,
        1618.3021240234375,
        179.0
      ],
      [
        1480.0,
        1618.3021240234375,
        179.0
      ],
      [
        1480.0,
        1610.0,
        179.0
      ],
      [
        1480.0,
        1610.0,
        179.0
      ],
      [
        1480.0,
        1610.0,
        177.0
      ],
      [
        1200.0,
        1630.0,
        158.0
      ],
      [
        1200.0,
        1630.0,
        148.0
      ],
      [
        1200.0,
        1630.0,
        429.0
      ],
      [
        1200.0,
        1630.0,
        379.0
      ],
      [
        1200.0,
        1690.0,
        379.0
      ],
      [
        1200.0,
        1630.0,
        379.0
      ],
      [
        1225.0,
        1630.0,
        329.0
      ],
      [
        1225.0,
        1630.0,
        270.0
      ],
      [
        1225.0,
        1630.0,
        270.0
      ],
      [
        1200.0,
        1690.0,
        251.81817626953125
      ],
      [
        1200.0,
        1630.0,
        251.81817626953125
      ],
      [
        1200.0,
        1640.7330322265625,
        158.0
      ],
      [
        1200.0,
        1679.2669677734375,
        158.0
      ],
      [
        1200.0,
        1690.0,
        158.0
      ],
      [
        1200.0,
        1679.2669677734375,
        158.0
      ],
      [
        1200.0,
        1640.7330322265625,
        158.0
      ],
      [
        1200.0,
        1630.0,
        158.0
      ],
      [
        1225.0,
        1630.0,
        158.0
      ],
      [
        1225.0,
        1642.071044921875,
        158.0
      ],
      [
        1225.0,
        1677.928955078125,
        158.0
      ],
      [
        1225.0,
        1690.0,
        158.0
      ],
      [
        1200.0,
        1679.2669677734375,
        148.0
      ],
      [
        1200.0,
        1640.7330322265625,
        148.0
      ],
      [
        1200.0,
        1630.0,
        148.0
      ],
      [
        1200.0,
        1640.7330322265625,
        148.0
      ],
      [
        1200.0,
        1679.2669677734375,
        148.0
      ],
      [
        1200.0,
        1690.0,
        148.0
      ],
      [
        1225.0,
        1690.0,
        148.0
      ],
      [
        1225.0,
        1677.928955078125,
        148.0
      ],
      [
        1225.0,
        1642.071044921875,
        148.0
      ],
      [
        1225.0,
        1630.0,
        148.0
      ],
      [
        1225.0,
        1642.071044921875,
        158.0
      ],
      [
        1225.0,
        1642.071044921875,
        148.0
      ],
      [
        1225.0,
        1677.928955078125,
        158.0
      ],
      [
        1225.0,
        1677.928955078125,
        148.0
      ],
      [
        1257.887939453125,
        1630.0,
        140.0
      ],
      [
        1480.0,
        1630.0,
        179.0
      ],
      [
        1480.0,
        1630.0,
        140.0
      ],
      [
        1468.3050537109375,
        1630.0,
        177.0
      ],
      [
        1468.3050537109375,
        1690.0,
        177.0
      ],
      [
        1480.0,
        1630.0,
        177.0
      ],
      [
        1200.0,
        1610.0,
        251.81817626953125
      ],
      [
        1320.0,
        1610.0,
        158.61538696289062
      ],
      [
        1320.0,
        1630.0,
        158.61538696289062
      ],
      [
        1215.0,
        1610.0,
        157.38461303710938
      ],
      [
        1215.0,
        1630.0,
        157.38461303710938
      ],
      [
        800.0,
        1610.0,
        150.0
      ],
      [
        790.0,
        1610.0,
        150.0
      ],
      [
        960.0,
        1610.0,
        150.0
      ],
      [
        970.0,
        1610.0,
        150.0
      ],
      [
        1187.731689453125,
        1630.0,
        150.0
      ],
      [
        1200.0,
        1630.0,
        150.0
      ],
      [
        1187.731689453125,
        1630.0,
        150.0
      ],
      [
        1037.5947265625,
        1630.0,
        150.0
      ],
      [
        815.0,
        1665.0,
        150.0
      ],
      [
        800.0,
        1690.0,
        150.0
      ],
      [
        955.0,
        1655.0,
        150.0
      ],
      [
        980.0,
        1670.0,
        150.0
      ],
      [
        980.0,
        1670.0,
        150.0
      ],
      [
        960.0,
        1690.0,
        150.0
      ],
      [
        970.0,
        1664.0,
        150.0
      ],
      [
        970.0,
        1664.0,
        200.0
      ],
      [
        970.0,
        1630.0,
        150.0
      ],
      [
        970.0,
        1630.0,
        200.0
      ],
      [
        1200.0,
        1630.0,
        251.81817626953125
      ],
      [
        1170.0,
        1630.0,
        230.0
      ],
      [
        970.0,
        1625.0,
        200.0
      ],
      [
        970.0,
        1630.0,
        189.99993896484375
      ],
      [
        970.0,
        1610.0,
        150.0
      ],
      [
        970.0,
        1610.0,
        200.0
      ],
      [
        950.0,
        1630.0,
        140.0
      ],
      [
        960.0,
        1630.0,
        150.0
      ],
      [
        955.0,
        1655.0,
        145.0000457763672
      ],
      [
        960.0,
        1658.0,
        150.0
      ],
      [
        950.0,
        1610.0,
        140.0
      ],
      [
        960.0,
        1610.0,
        150.0
      ],
      [
        1466.5,
        1570.0,
        158.0
      ],
      [
        1466.5,
        1580.0,
        158.0
      ],
      [
        1466.5,
        1580.0,
        158.0
      ],
      [
        1323.1578369140625,
        1600.0,
        160.0
      ],
      [
        1323.1578369140625,
        1610.0,
        160.0
      ],
      [
        1323.1578369140625,
        1600.0,
        160.0
      ],
      [
        1353.157958984375,
        1600.0,
        179.0
      ],
      [
        1353.157958984375,
        1610.0,
        179.0
      ],
      [
        1350.0,
        1550.0,
        190.0
      ],
      [
        1290.0,
        1550.0,
        190.0
      ],
      [
        1290.0,
        1550.0,
        190.0
      ],
      [
        1266.0,
        1570.0,
        160.0
      ],
      [
        1266.0,
        1550.0,
        160.0
      ],
      [
        1266.0,
        1570.0,
        160.0
      ],
      [
        1290.0,
        1550.0,
        190.0
      ],
      [
        1266.0,
        1550.0,
        160.0
      ],
      [
        1350.0,
        1565.0,
        200.0
      ],
      [
        1350.0,
        1565.0,
        200.0
      ],
      [
        1350.0,
        1565.0,
        190.0
      ],
      [
        1250.0,
        1550.0,
        140.0
      ],
      [
        1250.0,
        1550.0,
        140.0
      ],
      [
        980.0,
        1590.0,
        150.0
      ],
      [
        955.0,
        1605.0,
        150.0
      ],
      [
        970.0,
        1580.0,
        216.0
      ],
      [
        980.0,
        1590.0,
        150.0
      ],
      [
        970.0,
        1580.0,
        150.0
      ],
      [
        815.0,
        1595.0,
        150.0
      ],
      [
        805.0,
        1605.0,
        150.0
      ],
      [
        970.0,
        1595.9998779296875,
        150.0
      ],
      [
        970.0,
        1595.9998779296875,
        200.0
      ],
      [
        963.3333129882812,
        1600.0,
        140.0
      ],
      [
        950.0,
        1608.0,
        140.0
      ],
      [
        960.0,
        1602.0,
        150.0
      ],
      [
        815.0,
        1595.0,
        145.0
      ],
      [
        810.0,
        1600.0,
        140.0
      ],
      [
        970.0,
        1580.0,
        140.0
      ],
      [
        1660.0,
        1469.9998779296875,
        370.0
      ],
      [
        1660.0,
        1469.9998779296875,
        500.0
      ],
      [
        1660.0,
        1469.9998779296875,
        370.0
      ],
      [
        1660.0,
        1469.9998779296875,
        140.0
      ],
      [
        1660.0,
        1469.9998779296875,
        500.0
      ],
      [
        1660.0,
        1469.9998779296875,
        1180.0
      ],
      [
        1680.0,
        1469.9998779296875,
        280.0
      ],
      [
        1680.0,
        1469.9998779296875,
        400.0
      ],
      [
        1735.0,
        1469.9998779296875,
        280.0
      ],
      [
        1680.0,
        1469.9998779296875,
        280.0
      ],
      [
        1748.13330078125,
        1410.0,
        178.933349609375
      ],
      [
        1753.5,
        1408.25,
        180.0
      ],
      [
        1753.5,
        1400.0,
        180.0
      ],
      [
        1753.5,
        1410.0,
        180.0
      ],
      [
        1753.5,
        1408.25,
        180.0
      ],
      [
        1770.0,
        1410.0,
        178.0
      ],
      [
        1770.0,
        1410.0,
        180.0
      ],
      [
        1748.13330078125,
        1420.0,
        178.933349609375
      ],
      [
        1748.13330078125,
        1410.0,
        178.933349609375
      ],
      [
        1713.9998779296875,
        1410.0,
        198.0
      ],
      [
        1706.0,
        1414.0,
        200.0
      ],
      [
        1706.0,
        1420.0,
        200.0
      ],
      [
        1706.0,
        1410.0,
        200.0
      ],
      [
        1706.0,
        1414.0,
        200.0
      ],
      [
        1713.9998779296875,
        1400.0,
        198.0
      ],
      [
        1713.9998779296875,
        1410.0,
        198.0
      ],
      [
        1750.0,
        1385.0,
        160.0
      ],
      [
        1750.0,
        1400.0,
        180.0
      ],
      [
        1750.0,
        1235.0,
        160.0
      ],
      [
        1750.0,
        1220.0,
        180.0
      ],
      [
        1750.0,
        1235.0,
        153.3333282470703
      ],
      [
        1750.0,
        1235.0,
        160.0
      ],
      [
        1750.0,
        1385.0,
        160.0
      ],
      [
        1750.0,
        1385.0,
        153.3333282470703
      ],
      [
        1750.0,
        1385.0,
        140.0
      ],
      [
        1750.0,
        1235.0,
        140.0
      ],
      [
        1695.0,
        1385.0,
        155.0
      ],
      [
        1695.0,
        1235.0,
        155.0
      ],
      [
        1700.0,
        1385.0,
        160.0
      ],
      [
        1695.0,
        1385.0,
        155.0
      ],
      [
        1695.0,
        1235.0,
        155.0
      ],
      [
        1700.0,
        1235.0,
        160.0
      ],
      [
        1700.0,
        1235.0,
        160.0
      ],
      [
        1719.9998779296875,
        1220.0,
        180.0
      ],
      [
        1700.0,
        1385.0,
        160.0
      ],
      [
        1719.9998779296875,
        1400.0,
        180.0
      ],
      [
        1700.0,
        1290.0,
        200.0
      ],
      [
        1700.0,
        1320.0,
        200.0
      ],
      [
        1700.0,
        1400.0,
        180.0
      ],
      [
        1700.0,
        1220.0,
        180.0
      ],
      [
        1697.142822265625,
        1235.0,
        157.14285278320312
      ],
      [
        1697.142822265625,
        1385.0,
        157.14285278320312
      ],
      [
        1700.0,
        1290.0,
        200.0
      ],
      [
        1700.0,
        1320.0,
        200.0
      ],
      [
        1680.0,
        810.0,
        240.0
      ],
      [
        1660.0,
        810.0,
        240.0
      ],
      [
        1660.0,
        810.0,
        140.0
      ],
      [
        1680.0,
        810.0,
        140.0
      ],
      [
        1680.0,
        840.0,
        220.0
      ],
      [
        1660.0,
        840.0,
        220.0
      ],
      [
        1660.0,
        840.0,
        140.0
      ],
      [
        1680.0,
        840.0,
        140.0
      ],
      [
        1660.0,
        840.0,
        220.0
      ],
      [
        1680.0,
        840.0,
        220.0
      ],
      [
        1680.0,
        900.0,
        220.0
      ],
      [
        1660.0,
        900.0,
        220.0
      ],
      [
        1660.0,
        900.0,
        220.0
      ],
      [
        1680.0,
        900.0,
        220.0
      ],
      [
        1680.0,
        900.0,
        240.0
      ],
      [
        1660.0,
        900.0,
        240.0
      ],
      [
        1700.0,
        1210.0,
        310.0
      ],
      [
        1700.0,
        1210.0,
        140.0
      ],
      [
        1700.0,
        810.0,
        240.0
      ],
      [
        1700.0,
        810.0,
        140.0
      ],
      [
        1700.0,
        700.0,
        258.0
      ],
      [
        1700.0,
        700.0,
        338.0
      ],
      [
        1700.0,
        840.0,
        220.0
      ],
      [
        1700.0,
        840.0,
        140.0
      ],
      [
        1700.0,
        840.0,
        220.0
      ],
      [
        1700.0,
        900.0,
        220.0
      ],
      [
        1700.0,
        900.0,
        220.0
      ],
      [
        1700.0,
        900.0,
        240.0
      ],
      [
        1690.0,
        810.0,
        240.0
      ],
      [
        1690.0,
        810.0,
        140.0
      ],
      [
        1690.0,
        700.0,
        258.0
      ],
      [
        1690.0,
        700.0,
        338.0
      ],
      [
        1690.0,
        840.0,
        220.0
      ],
      [
        1690.0,
        840.0,
        140.0
      ],
      [
        1690.0,
        840.0,
        220.0
      ],
      [
        1690.0,
        900.0,
        220.0
      ],
      [
        1690.0,
        900.0,
        220.0
      ],
      [
        1690.0,
        900.0,
        240.0
      ],
      [
        1480.0,
        1469.9998779296875,
        140.0
      ],
      [
        1480.0,
        1469.9998779296875,
        160.0
      ],
      [
        1480.0,
        1469.9998779296875,
        490.0
      ],
      [
        1480.0,
        1469.9998779296875,
        728.3914184570312
      ],
      [
        1480.0,
        1469.9998779296875,
        490.0
      ],
      [
        1480.0,
        1469.9998779296875,
        160.0
      ],
      [
        1430.0,
        1400.0,
        360.0
      ],
      [
        1430.0,
        1400.0,
        340.0
      ],
      [
        1430.0,
        1400.0,
        340.0
      ],
      [
        1430.0,
        1400.0,
        310.0
      ],
      [
        1430.0,
        1400.0,
        360.0
      ],
      [
        1430.0,
        1400.0,
        390.0
      ],
      [
        1430.0,
        1400.0,
        290.0
      ],
      [
        1430.0,
        1400.0,
        310.0
      ],
      [
        1430.0,
        1400.0,
        410.0
      ],
      [
        1430.0,
        1400.0,
        390.0
      ],
      [
        1430.0,
        1400.0,
        290.0
      ],
      [
        1430.0,
        1400.0,
        140.0
      ],
      [
        1430.0,
        1400.0,
        410.0
      ],
      [
        1430.0,
        1400.0,
        643.5386962890625
      ],
      [
        1456.208984375,
        1400.0,
        310.0
      ],
      [
        1456.208984375,
        1400.0,
        290.0
      ],
      [
        1456.208984375,
        1400.0,
        290.0
      ],
      [
        1484.4931640625,
        1400.0,
        290.0
      ],
      [
        1484.4931640625,
        1400.0,
        290.0
      ],
      [
        1484.4931640625,
        1400.0,
        310.0
      ],
      [
        1480.0,
        1404.4931640625,
        290.0
      ],
      [
        1480.0,
        1404.4931640625,
        310.0
      ],
      [
        1480.0,
        1400.0,
        290.0
      ],
      [
        1480.0,
        1404.4931640625,
        290.0
      ],
      [
        1200.0,
        1270.0,
        260.0
      ],
      [
        1200.0,
        1270.0,
        140.0
      ],
      [
        1000.0,
        1270.0,
        140.0
      ],
      [
        1000.0,
        1270.0,
        280.0
      ],
      [
        1030.0,
        1270.0,
        400.0
      ],
      [
        1030.0,
        1270.0,
        300.0
      ],
      [
        1000.0,
        1270.0,
        280.0
      ],
      [
        1030.0,
        1270.0,
        300.0
      ],
      [
        717.8607788085938,
        1280.0,
        160.0
      ],
      [
        714.611572265625,
        1270.0,
        160.0
      ],
      [
        714.611572265625,
        1270.0,
        520.0
      ],
      [
        717.8607788085938,
        1280.0,
        520.0
      ],
      [
        717.8607788085938,
        1280.0,
        520.0
      ],
      [
        714.611572265625,
        1270.0,
        520.0
      ],
      [
        714.611572265625,
        1270.0,
        550.0
      ],
      [
        717.8607788085938,
        1280.0,
        550.0
      ],
      [
        1250.0,
        1460.0,
        140.0
      ],
      [
        1290.0,
        1460.0,
        190.0
      ],
      [
        1350.0,
        1460.0,
        190.0
      ],
      [
        1290.0,
        1460.0,
        190.0
      ],
      [
        1030.0,
        1310.0,
        370.0852355957031
      ],
      [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      [
        1030.0,
        1330.0,
        370.0852355957031
      ],
      [
        1050.0,
        1380.0,
        390.0852355957031
      ],
      [
        1030.0,
        1380.0,
        370.0852355957031
      ],
      [
        1030.0,
        1330.0,
        355.9431457519531
      ],
      [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      [
        1050.0,
        1390.0,
        390.0852355957031
      ],
      [
        1030.0,
        1390.0,
        370.0852355957031
      ],
      [
        1050.0,
        1460.0,
        390.0852355957031
      ],
      [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      [
        840.0,
        1330.0,
        180.085205078125
      ],
      [
        840.0,
        1460.0,
        180.085205078125
      ],
      [
        840.0,
        1310.0,
        180.08523559570312
      ],
      [
        840.0,
        1310.0,
        180.00003051757812
      ],
      [
        839.914794921875,
        1460.0,
        180.0
      ],
      [
        1266.0,
        1460.0,
        160.0
      ],
      [
        1266.0,
        1550.0,
        160.0
      ],
      [
        1266.0,
        1550.0,
        160.0
      ],
      [
        1266.0,
        1460.0,
        160.0
      ],
      [
        820.0,
        1540.0,
        160.08518981933594
      ],
      [
        799.9147338867188,
        1540.0,
        140.0
      ],
      [
        1174.9146728515625,
        1540.0,
        515.0
      ],
      [
        1175.0,
        1540.0,
        515.0852661132812
      ],
      [
        1175.0,
        1470.0,
        515.0852661132812
      ],
      [
        1175.0,
        1540.0,
        515.0852661132812
      ],
      [
        1530.0,
        1130.0,
        465.0
      ],
      [
        1530.0,
        1130.0,
        140.0
      ],
      [
        1535.0,
        1120.0,
        465.0
      ],
      [
        1535.0,
        1120.0,
        140.0
      ],
      [
        1615.0,
        1120.0,
        465.0
      ],
      [
        1615.0,
        1120.0,
        140.0
      ],
      [
        1475.0,
        880.0,
        350.0
      ],
      [
        1475.0,
        880.0,
        139.99998474121094
      ],
      [
        1395.0,
        1120.0,
        140.0
      ],
      [
        1395.0,
        1120.0,
        465.0
      ],
      [
        1455.0,
        1120.0,
        465.0
      ],
      [
        1455.0,
        1120.0,
        140.0
      ],
      [
        1240.0,
        1120.0,
        260.10211181640625
      ],
      [
        1390.0,
        1120.0,
        260.10211181640625
      ],
      [
        1390.0,
        1120.0,
        260.10211181640625
      ],
      [
        1390.0,
        1120.0,
        160.0
      ],
      [
        1390.0,
        1120.0,
        160.0
      ],
      [
        1240.0,
        1120.0,
        160.0
      ],
      [
        1250.0,
        960.0,
        140.0
      ],
      [
        1240.0,
        960.0,
        160.0
      ],
      [
        1250.0,
        1040.0,
        140.0
      ],
      [
        1380.0,
        1040.0,
        140.0
      ],
      [
        1240.0,
        1030.0,
        204.0
      ],
      [
        1240.0,
        1030.0,
        160.0001220703125
      ],
      [
        1250.0,
        1030.0,
        140.0
      ],
      [
        1240.0,
        1030.0,
        140.0
      ],
      [
        1000.0,
        1170.0,
        140.0
      ],
      [
        1000.0,
        1170.0,
        280.0
      ],
      [
        1030.0,
        1170.0,
        400.0
      ],
      [
        1030.0,
        1170.0,
        300.0
      ],
      [
        1000.0,
        1170.0,
        280.0
      ],
      [
        1030.0,
        1170.0,
        300.0
      ],
      [
        1001.373779296875,
        1170.0,
        280.9158630371094
      ],
      [
        1189.5999755859375,
        950.0,
        140.0
      ],
      [
        1189.5999755859375,
        1080.0,
        140.0
      ],
      [
        1050.0,
        1109.5999755859375,
        140.0
      ],
      [
        1160.0,
        1109.5999755859375,
        140.0
      ],
      [
        1189.5999755859375,
        970.0000610351562,
        140.0
      ],
      [
        1187.0400390625,
        1030.0,
        204.0
      ],
      [
        1189.5999755859375,
        1030.0,
        140.0
      ],
      [
        1173.0,
        1091.9998779296875,
        580.0
      ],
      [
        1199.199951171875,
        1109.5999755859375,
        140.0
      ],
      [
        1199.199951171875,
        950.0,
        140.0
      ],
      [
        1189.3616943359375,
        1030.0,
        145.95767211914062
      ],
      [
        1193.33349609375,
        1030.0,
        140.0
      ],
      [
        1194.0799560546875,
        1030.0,
        204.0
      ],
      [
        1199.199951171875,
        1030.0,
        140.0
      ],
      [
        865.0,
        1121.3931884765625,
        520.0
      ],
      [
        868.669189453125,
        1120.0,
        170.0
      ],
      [
        868.6692504882812,
        1120.0,
        520.0
      ],
      [
        868.6692504882812,
        1120.0,
        170.0
      ],
      [
        865.0,
        1120.0,
        170.0
      ],
      [
        865.0,
        1120.0,
        170.0
      ],
      [
        861.330810546875,
        1120.0,
        170.0
      ],
      [
        490.0,
        1120.0,
        290.0
      ],
      [
        440.0,
        1120.0,
        340.0
      ],
      [
        868.6692504882812,
        1120.0,
        600.0
      ],
      [
        663.947021484375,
        1197.732177734375,
        520.0
      ],
      [
        663.947021484375,
        1197.732177734375,
        550.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -2619.10009765625,
        -22.699951171875
      ],
      "bbox_max": [
        -2669.724609375,
        6871.484375,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -6971.595703125,
        -2323.521484375,
        -22.699951171875
      ],
      "bbox_max": [
        -2916.739501953125,
        6233.91845703125,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -5174.01171875,
        2154.178466796875,
        -22.699951171875
      ],
      "bbox_max": [
        -2916.739501953125,
        5326.439453125,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5174.01171875,
        5224.01171875,
        -22.699951171875
      ],
      "bbox_max": [
        -5020.71826171875,
        5326.439453125,
        41.12890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.213623046875,
      "bbox_min": [
        -5545.388671875,
        2154.178466796875,
        -22.699951171875
      ],
      "bbox_max": [
        -3662.578857421875,
        6233.91845703125,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5174.01171875,
        5224.01171875,
        -22.699951171875
      ],
      "bbox_max": [
        -3662.578857421875,
        6233.91845703125,
        671.7750244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1430054008960724,
        0.10372365266084671,
        0.9842716455459595
      ],
      "plane_d": -505.2467041015625,
      "bbox_min": [
        -5174.01171875,
        -2619.10009765625,
        -22.699951171875
      ],
      "bbox_max": [
        -2669.724609375,
        6871.484375,
        1400.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -5174.01171875,
        -2329.10009765625,
        -22.699951171875
      ],
      "bbox_max": [
        -2669.724609375,
        6871.484375,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18346190452575684,
        0.3073110282421112,
        0.9337567090988159
      ],
      "plane_d": -694.5667114257812,
      "bbox_min": [
        -4912.15185546875,
        2154.178466796875,
        124.09432983398438
      ],
      "bbox_max": [
        -2669.724609375,
        3702.748046875,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -4912.15185546875,
        2154.178466796875,
        124.09432983398438
      ],
      "bbox_max": [
        -2669.724609375,
        3398.1728515625,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5174.01171875,
        5224.01171875,
        182.69976806640625
      ],
      "bbox_max": [
        -2708.39404296875,
        6871.484375,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -1201.24462890625,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        400.0,
        -2021.68505859375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -825.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        400.0,
        -2275.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3594778776168823,
        0.9298421740531921,
        0.07854465395212173
      ],
      "plane_d": -1620.70263671875,
      "bbox_min": [
        -1726.0,
        2340.0,
        130.0
      ],
      "bbox_max": [
        -1661.9405517578125,
        2399.27880859375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112057685852051,
        0.4043944180011749,
        0.07854437828063965
      ],
      "plane_d": 557.8760986328125,
      "bbox_min": [
        -1699.8333740234375,
        2340.0,
        130.0
      ],
      "bbox_max": [
        -1661.9405517578125,
        2381.661376953125,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.023681640625,
      "bbox_min": [
        2400.0,
        -2849.047607421875,
        1100.0
      ],
      "bbox_max": [
        7550.0,
        -2050.0,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022904695942997932,
        0.8625975847244263,
        0.5053718686103821
      ],
      "plane_d": 1267.3873291015625,
      "bbox_min": [
        650.0,
        -2850.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1546.88427734375,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        650.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        2400.0,
        -2050.0,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.023681640625,
      "bbox_min": [
        2300.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        2400.0,
        -2050.0,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        650.0,
        -1700.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1546.88427734375,
        502.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        650.0,
        -1600.0,
        16.996383666992188
      ],
      "bbox_max": [
        2400.0,
        -867.0938720703125,
        433.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        650.0,
        -1600.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1150.0,
        433.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        0.0
      ],
      "bbox_max": [
        650.0,
        -846.68505859375,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        1284.1875
      ],
      "bbox_max": [
        650.0,
        -2378.125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        523.75537109375,
        -1600.0,
        0.0
      ],
      "bbox_max": [
        650.0,
        -846.68505859375,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1689.9998779296875,
      "bbox_min": [
        -504.5,
        522.5,
        20.0
      ],
      "bbox_max": [
        2110.0,
        2050.0,
        1180.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        450.0,
        1689.9998779296875,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0,
        2050.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        1550.0,
        1830.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0,
        2050.0,
        1180.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1655.0,
      "bbox_min": [
        1550.0,
        1830.0,
        119.99995422363281
      ],
      "bbox_max": [
        2020.0,
        2050.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1550.0,
        1830.0,
        140.0
      ],
      "bbox_max": [
        1550.0001220703125,
        2011.7158203125,
        1060.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1655.0,
        1830.0,
        119.99995422363281
      ],
      "bbox_max": [
        2020.0,
        2050.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9688333868980408,
        -0.24771343171596527,
        -0.0
      ],
      "plane_d": 2410.359130859375,
      "bbox_min": [
        1910.0,
        1830.0,
        205.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2483755201101303,
        -0.9686638712882996,
        -0.0
      ],
      "plane_d": 2353.7021484375,
      "bbox_min": [
        1910.0,
        1830.0,
        205.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2740.887451171875,
      "bbox_min": [
        1910.0,
        1830.0,
        205.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        1910.0,
        1830.0,
        340.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 9.8994140625,
      "bbox_min": [
        1910.0,
        1896.0,
        980.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1931.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 339.9999694824219,
      "bbox_min": [
        1917.5,
        1839.9998779296875,
        340.0
      ],
      "bbox_max": [
        1983.250732421875,
        1907.4766845703125,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        9.765615232026903e-07,
        -1.0,
        0.0
      ],
      "plane_d": 1964.9984130859375,
      "bbox_min": [
        1655.0,
        1830.0,
        119.99995422363281
      ],
      "bbox_max": [
        1910.0,
        1965.0001220703125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        1655.0,
        1830.0,
        119.99995422363281
      ],
      "bbox_max": [
        1910.0,
        1965.0001220703125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1668.9998779296875,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1704.19970703125,
        1865.1998291015625,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1909.74462890625,
        1895.4892578125,
        1059.422119140625
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 9.8994140625,
      "bbox_min": [
        1909.74462890625,
        1895.74462890625,
        1059.422119140625
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1655.0,
        1830.0,
        119.99995422363281
      ],
      "bbox_max": [
        1864.1424560546875,
        1965.0001220703125,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1655.0,
        1830.0,
        119.99995422363281
      ],
      "bbox_max": [
        1864.1424560546875,
        1965.0001220703125,
        350.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.5300001502037048,
        -0.8479976654052734
      ],
      "plane_d": 1152.219970703125,
      "bbox_min": [
        1655.0,
        1830.0,
        140.0
      ],
      "bbox_max": [
        1864.1424560546875,
        1950.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 319.9999694824219,
      "bbox_min": [
        1664.9998779296875,
        1830.0,
        140.0
      ],
      "bbox_max": [
        1864.1424560546875,
        1950.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532812714576721,
        0.270596981048584,
        -0.707107424736023
      ],
      "plane_d": 899.7987060546875,
      "bbox_min": [
        1692.8388671875,
        1830.0,
        337.5489196777344
      ],
      "bbox_max": [
        1770.0,
        1845.0643310546875,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9679223895072937,
        0.251249760389328,
        0.0
      ],
      "plane_d": 1178.7496337890625,
      "bbox_min": [
        1692.8388671875,
        1830.0,
        340.0
      ],
      "bbox_max": [
        1705.76611328125,
        1845.0643310546875,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        1692.8388671875,
        1830.0,
        340.0
      ],
      "bbox_max": [
        1705.76611328125,
        1845.0643310546875,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        8.137954864650965e-06,
        -1.0,
        0.0
      ],
      "plane_d": 1949.986328125,
      "bbox_min": [
        1664.9998779296875,
        1949.9998779296875,
        140.0
      ],
      "bbox_max": [
        1680.0,
        1950.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.9238043427758384e-06,
        -0.515036940574646,
        -0.8571680784225464
      ],
      "plane_d": 1103.7305908203125,
      "bbox_min": [
        1655.0,
        1855.0,
        119.99995422363281
      ],
      "bbox_max": [
        1690.0001220703125,
        1943.2857666015625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.220703143189894e-05,
        0.0
      ],
      "plane_d": 1680.022705078125,
      "bbox_min": [
        1680.0,
        1855.0,
        120.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1910.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.220703143189894e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1900.0206298828125,
      "bbox_min": [
        1680.0001220703125,
        1855.0,
        120.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1900.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1855.0,
      "bbox_min": [
        1680.0001220703125,
        1855.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1855.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1550.0,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        2020.0,
        2050.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9688333868980408,
        -0.24771343171596527,
        -0.0
      ],
      "plane_d": 2410.359130859375,
      "bbox_min": [
        1910.0,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2483755201101303,
        -0.9686638712882996,
        -0.0
      ],
      "plane_d": 2353.7021484375,
      "bbox_min": [
        1910.0,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1971.7369384765625,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1910.0,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1971.7369384765625,
        1891.7369384765625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1550.0,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        2011.7158203125,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1675.58154296875,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1912.11669921875,
        1130.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.2588171064853668,
        -0.9659263491630554,
        6.86823625528632e-07
      ],
      "plane_d": 2263.1865234375,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1892.9427490234375,
        1850.0001220703125,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1852.5001220703125,
        1841.2916259765625,
        1110.0
      ],
      "bbox_max": [
        1873.0001220703125,
        1848.516845703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        0.25882038474082947,
        0.0
      ],
      "plane_d": 1311.42626953125,
      "bbox_min": [
        1852.5001220703125,
        1846.6507568359375,
        1110.0
      ],
      "bbox_max": [
        1853.0001220703125,
        1848.516845703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1892.9427490234375,
        1846.6507568359375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1872.5,
        1846.6507568359375,
        1115.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        0.25882038474082947,
        0.0
      ],
      "plane_d": 1311.42626953125,
      "bbox_min": [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1852.5001220703125,
        1846.6507568359375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        450.0,
        1689.9998779296875,
        120.0
      ],
      "bbox_max": [
        2025.0,
        1830.0001220703125,
        1180.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1655.0,
      "bbox_min": [
        450.0,
        1689.9998779296875,
        120.0
      ],
      "bbox_max": [
        2020.0,
        1830.0001220703125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        450.0,
        1689.9998779296875,
        140.0
      ],
      "bbox_max": [
        1655.0,
        1830.0001220703125,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        8.719300694792764e-07,
        0.0
      ],
      "plane_d": 1549.9984130859375,
      "bbox_min": [
        1549.9998779296875,
        1689.9998779296875,
        350.0
      ],
      "bbox_max": [
        1550.0,
        1830.0,
        390.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -450.0,
      "bbox_min": [
        450.0,
        1690.0,
        140.0
      ],
      "bbox_max": [
        1645.0,
        1830.0001220703125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 230.0,
      "bbox_min": [
        778.5,
        1690.0,
        140.0
      ],
      "bbox_max": [
        1645.0,
        1830.0001220703125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5881717205047607,
        0.0,
        -0.8087361454963684
      ],
      "plane_d": -502.1515808105469,
      "bbox_min": [
        1170.0,
        1690.0,
        230.0
      ],
      "bbox_max": [
        1645.0,
        1830.0001220703125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        1225.0,
        1690.0,
        270.0
      ],
      "bbox_max": [
        1225.0,
        1710.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.662087237898959e-06,
        -0.6000000238418579,
        -0.8000000715255737
      ],
      "plane_d": 1353.9942626953125,
      "bbox_min": [
        1564.9998779296875,
        1690.0,
        320.0
      ],
      "bbox_max": [
        1645.0,
        1830.0001220703125,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1565.0,
      "bbox_min": [
        1565.0,
        1790.0,
        320.0
      ],
      "bbox_max": [
        1625.0001220703125,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -3.0517671802954283e-06,
        0.0
      ],
      "plane_d": 1625.005615234375,
      "bbox_min": [
        1625.0,
        1790.0001220703125,
        320.0
      ],
      "bbox_max": [
        1625.0001220703125,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.324115813389653e-06,
        0.5999988913536072,
        -0.8000009655952454
      ],
      "plane_d": -757.9862060546875,
      "bbox_min": [
        1564.9998779296875,
        1690.0,
        320.0
      ],
      "bbox_max": [
        1645.0,
        1730.0001220703125,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -3.0517671802954283e-06,
        0.0
      ],
      "plane_d": 1625.0052490234375,
      "bbox_min": [
        1564.9998779296875,
        1690.0,
        320.0
      ],
      "bbox_max": [
        1625.0001220703125,
        1730.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -3.0517671802954283e-06,
        0.0
      ],
      "plane_d": 1565.005126953125,
      "bbox_min": [
        1564.9998779296875,
        1690.0,
        320.0
      ],
      "bbox_max": [
        1565.0,
        1729.9998779296875,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -778.5,
      "bbox_min": [
        778.5,
        1690.0,
        140.0
      ],
      "bbox_max": [
        778.5,
        1695.0,
        145.16661071777344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        1655.0,
        1689.9998779296875,
        120.0
      ],
      "bbox_max": [
        2020.0,
        1830.0,
        1060.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 637.045654296875,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1704.355224609375,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1975.4892578125,
        1829.8446044921875,
        1059.6484375
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 319.9999694824219,
      "bbox_min": [
        1655.0001220703125,
        1690.0,
        120.0
      ],
      "bbox_max": [
        1995.0,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532833576202393,
        -0.27059581875801086,
        -0.707105815410614
      ],
      "plane_d": 1852.3011474609375,
      "bbox_min": [
        1674.6685791015625,
        1690.0,
        320.0
      ],
      "bbox_max": [
        1995.0,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532807946205139,
        -0.2705976068973541,
        -0.7071075439453125
      ],
      "plane_d": -551.77294921875,
      "bbox_min": [
        1727.5283203125,
        1690.0,
        320.0
      ],
      "bbox_max": [
        1995.0,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532812714576721,
        0.270596981048584,
        -0.707107424736023
      ],
      "plane_d": 899.7987060546875,
      "bbox_min": [
        1727.5283203125,
        1690.0,
        320.0
      ],
      "bbox_max": [
        1910.0,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27059727907180786,
        -0.6532820463180542,
        -0.7071065902709961
      ],
      "plane_d": 825.888916015625,
      "bbox_min": [
        1864.1422119140625,
        1690.0,
        320.0
      ],
      "bbox_max": [
        1910.0,
        1703.431396484375,
        337.5489196777344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9679223299026489,
        0.2512498199939728,
        0.0
      ],
      "plane_d": 1488.8052978515625,
      "bbox_min": [
        1976.82958984375,
        1690.0,
        340.0
      ],
      "bbox_max": [
        1995.0,
        1760.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        1674.6685791015625,
        1690.0,
        340.0
      ],
      "bbox_max": [
        1703.17041015625,
        1830.0,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9679223895072937,
        -0.251249760389328,
        0.0
      ],
      "plane_d": 2063.14892578125,
      "bbox_min": [
        1674.6685791015625,
        1690.0,
        340.0
      ],
      "bbox_max": [
        1692.8388671875,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9679223895072937,
        0.251249760389328,
        0.0
      ],
      "plane_d": 1178.7496337890625,
      "bbox_min": [
        1674.6685791015625,
        1760.0,
        340.0
      ],
      "bbox_max": [
        1692.8388671875,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000015497207642,
        -0.8660245537757874,
        0.0
      ],
      "plane_d": 562.5496826171875,
      "bbox_min": [
        1655.0001220703125,
        1690.0,
        120.0
      ],
      "bbox_max": [
        1901.650634765625,
        1830.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000057816505432,
        -0.8660221099853516,
        0.0
      ],
      "plane_d": 2442.55908203125,
      "bbox_min": [
        1655.0001220703125,
        1690.0,
        120.0
      ],
      "bbox_max": [
        1879.9998779296875,
        1830.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1715.4573974609375,
        1818.4022216796875,
        120.0
      ],
      "bbox_max": [
        1745.6768798828125,
        1830.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1715.4573974609375,
        1818.4022216796875,
        140.0
      ],
      "bbox_max": [
        1745.6768798828125,
        1830.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1655.0001220703125,
        1690.0,
        120.0
      ],
      "bbox_max": [
        1750.0,
        1830.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1655.0001220703125,
        1690.0,
        120.0
      ],
      "bbox_max": [
        1750.0,
        1830.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9654934406280518,
        -0.2604275941848755,
        6.466050399467349e-05
      ],
      "plane_d": 2118.992919921875,
      "bbox_min": [
        1680.0,
        1690.0,
        120.0
      ],
      "bbox_max": [
        1750.0,
        1815.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1720.0001220703125,
        1690.0,
        120.0
      ],
      "bbox_max": [
        1750.0,
        1795.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2429.956298828125,
      "bbox_min": [
        1736.076904296875,
        1690.0,
        120.0
      ],
      "bbox_max": [
        1746.4769287109375,
        1700.4000244140625,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.103888154029846e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1790.1055908203125,
      "bbox_min": [
        1727.9853515625,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1731.3160400390625,
        1795.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": 1661.777099609375,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1731.3160400390625,
        1795.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277936935425,
        0.9486833810806274
      ],
      "plane_d": 449.35968017578125,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1730.78369140625,
        1793.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9654908776283264,
        -0.2604372203350067,
        0.0
      ],
      "plane_d": 2120.94482421875,
      "bbox_min": [
        1721.0067138671875,
        1690.0,
        123.0
      ],
      "bbox_max": [
        1750.0,
        1795.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1729.9852294921875,
        1690.0,
        123.0
      ],
      "bbox_max": [
        1750.0,
        1795.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": 1661.777099609375,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1750.0,
        1795.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277936935425,
        0.9486833810806274
      ],
      "plane_d": 449.35968017578125,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1750.0,
        1793.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2429.956298828125,
      "bbox_min": [
        1738.8155517578125,
        1690.0,
        123.0
      ],
      "bbox_max": [
        1746.4769287109375,
        1697.661376953125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1721.0067138671875,
        1697.661376953125,
        123.0
      ],
      "bbox_max": [
        1738.8155517578125,
        1760.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2429.956298828125,
      "bbox_min": [
        1736.076904296875,
        1697.661376953125,
        132.0
      ],
      "bbox_max": [
        1738.8155517578125,
        1700.4000244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2429.956298828125,
      "bbox_min": [
        1736.076904296875,
        1697.661376953125,
        123.0
      ],
      "bbox_max": [
        1738.8155517578125,
        1700.4000244140625,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1755.0,
      "bbox_min": [
        1680.0,
        1705.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1815.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1755.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1815.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1680.0,
        1755.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1805.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1805.0,
      "bbox_min": [
        1680.0,
        1805.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1805.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1705.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1715.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1705.0,
      "bbox_min": [
        1680.0,
        1705.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1714.9998779296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.2207180589030031e-05,
        0.0
      ],
      "plane_d": -1690.0208740234375,
      "bbox_min": [
        1689.9998779296875,
        1705.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1714.9998779296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        8.719300694792764e-07,
        0.0
      ],
      "plane_d": 1659.9984130859375,
      "bbox_min": [
        1658.9056396484375,
        1689.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1961.243408203125,
        1830.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1660.0,
        1720.0,
        1060.0
      ],
      "bbox_max": [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1769.84228515625,
        1720.0,
        1060.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500018298625946,
        0.866014838218689,
        0.0
      ],
      "plane_d": -604.1505126953125,
      "bbox_min": [
        1917.9423828125,
        1805.0001220703125,
        1106.0
      ],
      "bbox_max": [
        1919.674560546875,
        1806.000244140625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1769.84228515625,
        1720.0,
        1106.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        -1.3164119536668295e-06
      ],
      "plane_d": 2319.757568359375,
      "bbox_min": [
        1769.84228515625,
        1760.0,
        1110.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2535.23193359375,
      "bbox_min": [
        1769.84228515625,
        1760.0,
        1110.0
      ],
      "bbox_max": [
        1848.03857421875,
        1830.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        0.25882038474082947,
        0.0
      ],
      "plane_d": 1311.42626953125,
      "bbox_min": [
        1840.0,
        1800.0,
        1110.0
      ],
      "bbox_max": [
        1848.03857421875,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        0.25882017612457275,
        0.0
      ],
      "plane_d": 1283.142333984375,
      "bbox_min": [
        1800.0,
        1760.0,
        1110.0
      ],
      "bbox_max": [
        1805.3590087890625,
        1780.0,
        1125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        -1.3164119536668295e-06
      ],
      "plane_d": 2319.757568359375,
      "bbox_min": [
        1917.9425048828125,
        1760.000244140625,
        1106.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1805.000244140625,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1658.9056396484375,
        1767.4713134765625,
        1130.0
      ],
      "bbox_max": [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -504.5,
        911.17822265625,
        20.0
      ],
      "bbox_max": [
        -109.5,
        1280.0,
        540.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 309.5,
      "bbox_min": [
        -504.5,
        911.17822265625,
        400.0
      ],
      "bbox_max": [
        -109.5,
        1219.021728515625,
        540.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -233.222412109375,
      "bbox_min": [
        -504.5,
        1158.39990234375,
        400.0
      ],
      "bbox_max": [
        -309.5,
        1219.021728515625,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1219.021728515625,
      "bbox_min": [
        -504.5,
        1219.021728515625,
        400.0
      ],
      "bbox_max": [
        -434.5,
        1219.021728515625,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.361328125,
      "bbox_min": [
        -369.4998779296875,
        1210.361328125,
        400.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        450.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -235.18533325195312,
      "bbox_min": [
        -309.5032958984375,
        911.17822265625,
        400.0
      ],
      "bbox_max": [
        -109.5,
        1219.021728515625,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        400.0
      ],
      "bbox_max": [
        -289.5,
        971.800048828125,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -484.369873046875,
      "bbox_min": [
        -309.5032958984375,
        1051.798095703125,
        400.0
      ],
      "bbox_max": [
        -109.5,
        1219.021728515625,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1219.021728515625,
      "bbox_min": [
        -309.5032958984375,
        1051.798095703125,
        400.0
      ],
      "bbox_max": [
        -109.5,
        1219.021728515625,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660252094268799,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": 674.0302734375,
      "bbox_min": [
        -309.5032958984375,
        1051.798095703125,
        400.0
      ],
      "bbox_max": [
        -109.5,
        1210.361328125,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660242557525635,
        0.5000020861625671,
        0.0
      ],
      "plane_d": -363.1293029785156,
      "bbox_min": [
        -309.5032958984375,
        1051.798095703125,
        400.0
      ],
      "bbox_max": [
        -239.5,
        1210.361328125,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.361328125,
      "bbox_min": [
        -309.5032958984375,
        1051.798095703125,
        400.0
      ],
      "bbox_max": [
        -279.5001220703125,
        1210.361328125,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289903998374939,
        -0.5592629313468933,
        4.0998944314196706e-05
      ],
      "plane_d": 844.7847900390625,
      "bbox_min": [
        -309.5032958984375,
        1051.798095703125,
        500.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 309.5,
      "bbox_min": [
        -309.5,
        911.17822265625,
        120.0
      ],
      "bbox_max": [
        -109.5,
        1219.021728515625,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -235.18533325195312,
      "bbox_min": [
        -309.5,
        911.17822265625,
        120.00611877441406
      ],
      "bbox_max": [
        -109.5,
        1219.021728515625,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        120.00611877441406
      ],
      "bbox_max": [
        -289.5,
        971.800048828125,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -484.369873046875,
      "bbox_min": [
        -214.5,
        1097.7781982421875,
        120.00611877441406
      ],
      "bbox_max": [
        -109.5,
        1219.021728515625,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1219.021728515625,
      "bbox_min": [
        -214.5,
        1097.7781982421875,
        120.00611877441406
      ],
      "bbox_max": [
        -109.5,
        1219.021728515625,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660252094268799,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": 674.0302734375,
      "bbox_min": [
        -144.5,
        1097.7781982421875,
        120.00611877441406
      ],
      "bbox_max": [
        -109.5,
        1158.39990234375,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1219.021728515625,
      "bbox_min": [
        -504.5,
        1158.39990234375,
        120.0
      ],
      "bbox_max": [
        -399.5,
        1219.021728515625,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -233.222412109375,
      "bbox_min": [
        -434.5,
        1158.39990234375,
        120.0
      ],
      "bbox_max": [
        -399.5,
        1219.021728515625,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        260.0,
        522.5,
        60.0
      ],
      "bbox_max": [
        2110.0,
        1690.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1360.0,
        522.5,
        120.0
      ],
      "bbox_max": [
        1660.0,
        670.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1522.5999755859375,
      "bbox_min": [
        1490.0,
        522.5,
        120.0
      ],
      "bbox_max": [
        1640.0,
        630.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        1490.0,
        600.0,
        317.0
      ],
      "bbox_max": [
        1522.5999755859375,
        630.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        1522.5999755859375,
        522.5,
        310.0
      ],
      "bbox_max": [
        1640.0,
        630.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        1522.5999755859375,
        600.0,
        310.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5734623670578003,
        -0.0,
        -0.8192319273948669
      ],
      "plane_d": 1154.2978515625,
      "bbox_min": [
        1560.0,
        600.0,
        310.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1522.5999755859375,
      "bbox_min": [
        1360.0,
        630.0,
        120.0
      ],
      "bbox_max": [
        1660.0,
        670.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1220812201499939,
        0.9925201535224915,
        -0.0
      ],
      "plane_d": -831.0189819335938,
      "bbox_min": [
        1360.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        1522.5999755859375,
        670.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1640.0,
        630.0,
        140.0
      ],
      "bbox_max": [
        1660.0,
        670.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        1640.0,
        630.0,
        338.0
      ],
      "bbox_max": [
        1640.0,
        650.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        1640.0,
        650.0,
        258.0
      ],
      "bbox_max": [
        1640.0,
        670.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1769.9998779296875,
      "bbox_min": [
        260.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        2110.0,
        1690.0,
        1180.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1769.9998779296875,
        700.0,
        120.0
      ],
      "bbox_max": [
        2110.0,
        1690.0,
        1180.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        1769.9998779296875,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        2025.0,
        1690.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1769.9998779296875,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        1060.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        337.5489196777344
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        1910.0,
        1608.986083984375,
        337.5489196777344
      ],
      "bbox_max": [
        1983.2508544921875,
        1690.0,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2665826082229614,
        -0.9638121128082275,
        0.0
      ],
      "plane_d": 1041.5875244140625,
      "bbox_min": [
        1910.0,
        1608.986083984375,
        340.0
      ],
      "bbox_max": [
        1976.82958984375,
        1690.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532807946205139,
        -0.2705976068973541,
        -0.7071075439453125
      ],
      "plane_d": -551.77294921875,
      "bbox_min": [
        1910.0,
        1676.5230712890625,
        340.0
      ],
      "bbox_max": [
        1976.82958984375,
        1690.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532807946205139,
        -0.2705976068973541,
        -0.7071075439453125
      ],
      "plane_d": -551.77294921875,
      "bbox_min": [
        1910.0,
        1687.346923828125,
        337.5489196777344
      ],
      "bbox_max": [
        1912.653076171875,
        1690.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27059727907180786,
        -0.6532820463180542,
        -0.7071065902709961
      ],
      "plane_d": 825.888916015625,
      "bbox_min": [
        1910.0,
        1687.346923828125,
        337.5489196777344
      ],
      "bbox_max": [
        1911.8759765625,
        1690.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        1769.9998779296875,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1910.0001220703125,
        1690.0,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1770.0,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1910.0001220703125,
        1690.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27059727907180786,
        -0.6532820463180542,
        -0.7071065902709961
      ],
      "plane_d": 825.888916015625,
      "bbox_min": [
        1770.0,
        1484.9998779296875,
        320.0
      ],
      "bbox_max": [
        1910.0001220703125,
        1690.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 319.9999694824219,
      "bbox_min": [
        1815.8575439453125,
        1680.0,
        320.0
      ],
      "bbox_max": [
        1864.1422119140625,
        1690.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26658356189727783,
        -0.9638118147850037,
        0.0
      ],
      "plane_d": 2022.61279296875,
      "bbox_min": [
        1770.0,
        1484.9998779296875,
        320.0
      ],
      "bbox_max": [
        1910.0001220703125,
        1619.3614501953125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        1770.0,
        1589.6246337890625,
        340.0
      ],
      "bbox_max": [
        1910.0,
        1619.3614501953125,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2665826082229614,
        -0.9638121128082275,
        0.0
      ],
      "plane_d": 1041.5875244140625,
      "bbox_min": [
        1840.0001220703125,
        1589.6246337890625,
        340.0
      ],
      "bbox_max": [
        1910.0,
        1608.986083984375,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5999988913536072,
        -0.0,
        -0.8000009655952454
      ],
      "plane_d": 1401.998291015625,
      "bbox_min": [
        1770.0,
        1484.9998779296875,
        320.0
      ],
      "bbox_max": [
        1910.0001220703125,
        1565.0,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1485.0,
      "bbox_min": [
        1870.0,
        1485.0,
        320.0
      ],
      "bbox_max": [
        1910.0,
        1545.0001220703125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.0517671802954283e-06,
        -1.0,
        0.0
      ],
      "plane_d": 1545.005859375,
      "bbox_min": [
        1870.0001220703125,
        1545.0,
        320.0
      ],
      "bbox_max": [
        1910.0,
        1545.0001220703125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000012159347534,
        0.0,
        -0.7999991774559021
      ],
      "plane_d": -806.00244140625,
      "bbox_min": [
        1770.0,
        1484.9998779296875,
        320.0
      ],
      "bbox_max": [
        1810.0001220703125,
        1505.0001220703125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.0517671802954283e-06,
        -1.0,
        -0.0
      ],
      "plane_d": 1485.00537109375,
      "bbox_min": [
        1770.0,
        1484.9998779296875,
        320.0
      ],
      "bbox_max": [
        1809.9998779296875,
        1485.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1770.0,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1890.6220703125,
        1666.4769287109375,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.25881069898605347,
        -0.9659281373023987,
        0.0
      ],
      "plane_d": 1920.274169921875,
      "bbox_min": [
        1770.0,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1890.6220703125,
        1666.4769287109375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2429.956298828125,
      "bbox_min": [
        1770.0,
        1656.4769287109375,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1666.4769287109375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881069898605347,
        -0.9659281373023987,
        0.0
      ],
      "plane_d": 967.8509521484375,
      "bbox_min": [
        1789.3779296875,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1890.6220703125,
        1495.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 134.99998474121094,
      "bbox_min": [
        1789.3779296875,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1890.6220703125,
        1495.0,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071118354797363,
        -0.7071017026901245,
        0.0
      ],
      "plane_d": -225.8509521484375,
      "bbox_min": [
        1789.3779296875,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1890.6220703125,
        1485.6220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70711350440979,
        -0.7071000337600708,
        0.0
      ],
      "plane_d": 2376.3212890625,
      "bbox_min": [
        1875.0001220703125,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1890.6220703125,
        1485.6220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1910.0,
        1470.0,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1579.9000244140625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        1770.0,
        700.0,
        120.0
      ],
      "bbox_max": [
        1910.0,
        1469.9998779296875,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        1830.0,
        1240.0,
        120.0
      ],
      "bbox_max": [
        1910.0,
        1469.9998779296875,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        1830.0,
        1440.0,
        280.0
      ],
      "bbox_max": [
        1910.0,
        1440.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        1830.0,
        1355.0,
        120.0
      ],
      "bbox_max": [
        1900.6217041015625,
        1469.9998779296875,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1830.0,
        1447.05908203125,
        120.0
      ],
      "bbox_max": [
        1900.6217041015625,
        1469.9998779296875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 134.99998474121094,
      "bbox_min": [
        1830.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        1900.6217041015625,
        1469.9998779296875,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.70711350440979,
        -0.7071000337600708,
        0.0
      ],
      "plane_d": 2376.3212890625,
      "bbox_min": [
        1890.6220703125,
        1460.0,
        120.0
      ],
      "bbox_max": [
        1900.6217041015625,
        1469.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1830.0,
        1355.0,
        120.0
      ],
      "bbox_max": [
        1900.6217041015625,
        1402.94091796875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 134.99998474121094,
      "bbox_min": [
        1830.0,
        1355.0,
        120.0
      ],
      "bbox_max": [
        1900.6217041015625,
        1402.94091796875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071118354797363,
        0.7071017026901245,
        0.0
      ],
      "plane_d": 361.080810546875,
      "bbox_min": [
        1830.0,
        1355.0,
        120.0
      ],
      "bbox_max": [
        1900.6217041015625,
        1390.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588115334510803,
        0.9659278392791748,
        0.0
      ],
      "plane_d": -832.6190185546875,
      "bbox_min": [
        1830.0,
        1355.0,
        120.0
      ],
      "bbox_max": [
        1875.0,
        1364.3779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588115334510803,
        0.9659278392791748,
        -0.0
      ],
      "plane_d": -1785.04541015625,
      "bbox_min": [
        1830.0,
        1355.0,
        120.0
      ],
      "bbox_max": [
        1840.0,
        1357.679443359375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1770.0,
        700.0,
        120.0
      ],
      "bbox_max": [
        1830.0,
        1469.9998779296875,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1770.0,
        1357.679443359375,
        120.0
      ],
      "bbox_max": [
        1830.0,
        1469.9998779296875,
        135.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1770.0,
        1357.679443359375,
        120.0
      ],
      "bbox_max": [
        1830.0,
        1469.9998779296875,
        135.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.2588115334510803,
        0.9659278392791748,
        -0.0
      ],
      "plane_d": -1785.04541015625,
      "bbox_min": [
        1770.0,
        1357.679443359375,
        120.0
      ],
      "bbox_max": [
        1830.0,
        1469.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        0.2588212490081787,
        0.0
      ],
      "plane_d": 1365.867431640625,
      "bbox_min": [
        1770.0,
        1386.79248046875,
        120.0
      ],
      "bbox_max": [
        1817.94091796875,
        1469.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        -0.2588212490081787,
        -0.0
      ],
      "plane_d": 2103.508056640625,
      "bbox_min": [
        1795.8818359375,
        1386.79248046875,
        120.0
      ],
      "bbox_max": [
        1817.94091796875,
        1463.20751953125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071121335029602,
        -0.7071014642715454,
        -0.0
      ],
      "plane_d": 2266.091064453125,
      "bbox_min": [
        1801.7926025390625,
        1386.79248046875,
        120.0
      ],
      "bbox_max": [
        1817.94091796875,
        1463.20751953125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071094512939453,
        0.7071041464805603,
        -5.75447211303981e-06
      ],
      "plane_d": 250.84375,
      "bbox_min": [
        1801.7926025390625,
        1447.05908203125,
        120.0
      ],
      "bbox_max": [
        1817.94091796875,
        1463.20751953125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071118354797363,
        -0.7071017026901245,
        0.0
      ],
      "plane_d": -225.8509521484375,
      "bbox_min": [
        1770.0,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1789.3779296875,
        1469.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965927004814148,
        0.25881466269493103,
        -0.0
      ],
      "plane_d": -2078.501708984375,
      "bbox_min": [
        1770.0,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1779.3782958984375,
        1460.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1770.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1776.69873046875,
        1400.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659240245819092,
        -0.2588256597518921,
        -7.860709956730716e-06
      ],
      "plane_d": -1340.857666015625,
      "bbox_min": [
        1770.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1779.3782958984375,
        1460.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1770.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1776.69873046875,
        1450.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1629.9998779296875,
      "bbox_min": [
        700.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1400.0,
      "bbox_min": [
        1630.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1630.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1655.0,
      "bbox_min": [
        1630.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1630.0,
        1467.9998779296875,
        138.0
      ],
      "bbox_max": [
        1655.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1470.0,
      "bbox_min": [
        1630.0,
        1470.0,
        138.0
      ],
      "bbox_max": [
        1655.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1630.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1655.0001220703125,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070988416671753,
        -2.8772044515790185e-06,
        0.7071146368980408
      ],
      "plane_d": 1071.2567138671875,
      "bbox_min": [
        1653.0,
        1450.0,
        138.0
      ],
      "bbox_max": [
        1655.0001220703125,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070988416671753,
        -2.8772044515790185e-06,
        0.7071146368980408
      ],
      "plane_d": 1071.2567138671875,
      "bbox_min": [
        1650.0,
        1450.0,
        135.0
      ],
      "bbox_max": [
        1653.0001220703125,
        1468.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1655.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1470.0,
      "bbox_min": [
        1655.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1655.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1470.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -1297.541015625,
      "bbox_min": [
        1695.0,
        1450.0,
        138.0
      ],
      "bbox_max": [
        1697.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 940.4520874023438,
      "bbox_min": [
        1655.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1470.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1655.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1695.0001220703125,
        1470.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -4.069010628882097e-06,
        1.220703143189894e-05
      ],
      "plane_d": 1695.0042724609375,
      "bbox_min": [
        1695.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1695.0001220703125,
        1470.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1655.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1700.0001220703125,
        1468.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -1297.541015625,
      "bbox_min": [
        1697.0,
        1450.0,
        135.0
      ],
      "bbox_max": [
        1700.0,
        1468.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        8.138020348269492e-06
      ],
      "plane_d": -1700.0009765625,
      "bbox_min": [
        1700.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1700.0001220703125,
        1465.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1655.0,
        1470.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2429.956298828125,
      "bbox_min": [
        1680.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        1680.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1665.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1680.0,
        1655.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1665.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1655.0,
        135.0
      ],
      "bbox_max": [
        1680.0,
        1665.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1680.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1680.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1610.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -2.0345094071672065e-06,
        0.0
      ],
      "plane_d": 1695.0030517578125,
      "bbox_min": [
        1680.0,
        1470.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        135.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -2.8722508886858122e-06,
        -1.0,
        -0.0
      ],
      "plane_d": 1555.0048828125,
      "bbox_min": [
        1695.0,
        1507.5,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2429.956298828125,
      "bbox_min": [
        1746.4769287109375,
        1666.4769287109375,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3826836347579956,
        0.9238794445991516
      ],
      "plane_d": 482.29412841796875,
      "bbox_min": [
        1695.0,
        1507.5,
        120.0
      ],
      "bbox_max": [
        1740.0001220703125,
        1555.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9238899350166321,
        0.3826584219932556
      ],
      "plane_d": 1388.81640625,
      "bbox_min": [
        1695.0,
        1507.5,
        120.0
      ],
      "bbox_max": [
        1740.0001220703125,
        1555.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        1695.0,
        1507.5,
        120.0
      ],
      "bbox_max": [
        1740.0001220703125,
        1554.9998779296875,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        -2.708510464799474e-06,
        0.8320503234863281
      ],
      "plane_d": 848.9727783203125,
      "bbox_min": [
        1695.0,
        1507.5,
        120.0
      ],
      "bbox_max": [
        1740.0,
        1554.9998779296875,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -4.882836492470233e-06,
        -0.0
      ],
      "plane_d": 1715.00732421875,
      "bbox_min": [
        1710.5,
        1510.0,
        120.0
      ],
      "bbox_max": [
        1740.0,
        1554.9998779296875,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1740.0,
      "bbox_min": [
        1739.9998779296875,
        1550.0,
        120.0
      ],
      "bbox_max": [
        1740.0,
        1554.9998779296875,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.4414661311311647e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1535.041748046875,
      "bbox_min": [
        1710.5,
        1534.9998779296875,
        120.0
      ],
      "bbox_max": [
        1714.9998779296875,
        1535.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1695.0,
        1507.5,
        120.0
      ],
      "bbox_max": [
        1717.9998779296875,
        1540.0001220703125,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -2.4414661311311647e-05,
        -0.0
      ],
      "plane_d": 1710.0374755859375,
      "bbox_min": [
        1709.9998779296875,
        1534.9998779296875,
        120.0
      ],
      "bbox_max": [
        1714.9998779296875,
        1539.9998779296875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.4414661311311647e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1535.041748046875,
      "bbox_min": [
        1710.0,
        1534.9998779296875,
        120.0
      ],
      "bbox_max": [
        1714.9998779296875,
        1535.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.4414661311311647e-05,
        -1.0,
        3.6621993785956874e-05
      ],
      "plane_d": 1535.0372314453125,
      "bbox_min": [
        1695.0,
        1517.5,
        123.0
      ],
      "bbox_max": [
        1717.9998779296875,
        1540.0001220703125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547095537185669,
        -1.3543043678510003e-05,
        0.8320440053939819
      ],
      "plane_d": 846.2327270507812,
      "bbox_min": [
        1695.0,
        1535.0,
        123.0
      ],
      "bbox_max": [
        1713.0,
        1540.0001220703125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6246764659881592,
        0.7808837294578552
      ],
      "plane_d": 864.391357421875,
      "bbox_min": [
        1695.0,
        1537.5,
        123.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1540.0001220703125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.0503017114824615e-05,
        -0.624732255935669,
        0.7808391451835632
      ],
      "plane_d": 851.936279296875,
      "bbox_min": [
        1695.0,
        1517.5,
        123.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1520.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        4.98243707625079e-06,
        0.0
      ],
      "plane_d": 1719.9923095703125,
      "bbox_min": [
        1695.0,
        1507.5,
        125.0
      ],
      "bbox_max": [
        1740.0001220703125,
        1554.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -6.10351571594947e-06,
        -0.0
      ],
      "plane_d": 1740.009521484375,
      "bbox_min": [
        1720.0,
        1530.0,
        125.0
      ],
      "bbox_max": [
        1740.0001220703125,
        1554.9998779296875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        1720.0,
        1535.0,
        125.0
      ],
      "bbox_max": [
        1721.0,
        1535.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1719.0,
      "bbox_min": [
        1695.0,
        1507.5,
        125.0
      ],
      "bbox_max": [
        1720.0,
        1540.0001220703125,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        1719.0,
        1535.0,
        125.0
      ],
      "bbox_max": [
        1720.0,
        1535.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1695.0,
        1507.5,
        125.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1540.0001220703125,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -3.0507484552799724e-05,
        -0.624732255935669,
        -0.7808390855789185
      ],
      "plane_d": 1049.592041015625,
      "bbox_min": [
        1695.0,
        1517.5,
        125.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1540.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.0500294087687507e-05,
        -0.6246764659881592,
        -0.7808837294578552
      ],
      "plane_d": 1061.9031982421875,
      "bbox_min": [
        1695.0,
        1537.5,
        125.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1540.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.8825746489455923e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1539.917236328125,
      "bbox_min": [
        1695.0,
        1540.0,
        125.0
      ],
      "bbox_max": [
        1697.5001220703125,
        1540.0001220703125,
        128.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.883289511781186e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1520.082763671875,
      "bbox_min": [
        1695.0001220703125,
        1519.9998779296875,
        125.0
      ],
      "bbox_max": [
        1697.4998779296875,
        1520.0,
        128.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1665.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1680.0,
        1655.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1665.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1655.0,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1665.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1610.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1630.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1450.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1650.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1450.0001220703125,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1660.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1697.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 1350.5850830078125,
      "bbox_min": [
        1660.0,
        1440.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1441.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -1297.541015625,
      "bbox_min": [
        1695.0,
        1440.0,
        138.0
      ],
      "bbox_max": [
        1697.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -713.6958618164062,
      "bbox_min": [
        1680.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1683.5,
        1410.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1680.0,
        1410.0,
        138.0
      ],
      "bbox_max": [
        1683.5,
        1410.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070988416671753,
        -2.8772044515790185e-06,
        0.7071146368980408
      ],
      "plane_d": 1071.2567138671875,
      "bbox_min": [
        1653.0001220703125,
        1440.0001220703125,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 1350.5850830078125,
      "bbox_min": [
        1653.0001220703125,
        1440.0001220703125,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1441.0001220703125,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 1350.5850830078125,
      "bbox_min": [
        1650.0,
        1441.0,
        120.0
      ],
      "bbox_max": [
        1700.0001220703125,
        1450.0001220703125,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1650.0,
        1441.0,
        120.0
      ],
      "bbox_max": [
        1700.0001220703125,
        1450.0001220703125,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -1297.541015625,
      "bbox_min": [
        1650.0,
        1441.0,
        135.0
      ],
      "bbox_max": [
        1700.0,
        1450.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070988416671753,
        -2.8772044515790185e-06,
        0.7071146368980408
      ],
      "plane_d": 1071.2567138671875,
      "bbox_min": [
        1650.0,
        1441.0001220703125,
        135.0
      ],
      "bbox_max": [
        1653.0001220703125,
        1450.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        8.138020348269492e-06
      ],
      "plane_d": -1655.0009765625,
      "bbox_min": [
        1650.0,
        1442.5,
        120.0
      ],
      "bbox_max": [
        1700.0001220703125,
        1450.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        5.425347353593679e-06,
        2.7126736767968396e-06
      ],
      "plane_d": 1694.9918212890625,
      "bbox_min": [
        1695.0,
        1442.5,
        120.0
      ],
      "bbox_max": [
        1695.0,
        1450.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1630.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1630.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1630.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1630.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1630.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1630.0,
        840.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        1660.0,
        867.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -887.0,
      "bbox_min": [
        1660.0,
        887.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.0,
        -0.24253562092781067
      ],
      "plane_d": 1651.6676025390625,
      "bbox_min": [
        1667.5,
        877.5,
        130.0
      ],
      "bbox_max": [
        1672.5,
        882.5,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -822.1957397460938,
      "bbox_min": [
        1667.5,
        877.5,
        130.0
      ],
      "bbox_max": [
        1672.5,
        882.5,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        0.0,
        -0.24253562092781067
      ],
      "plane_d": -1588.6082763671875,
      "bbox_min": [
        1670.0,
        877.5,
        130.0
      ],
      "bbox_max": [
        1672.5,
        882.5,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1630.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1630.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        960.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        1630.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        960.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1630.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        960.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1650.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        960.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1650.0,
      "bbox_min": [
        1650.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        960.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1630.0,
        940.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        960.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.08662962168455124,
        0.9962406754493713
      ],
      "plane_d": 1.7325897216796875,
      "bbox_min": [
        1630.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.13216373324394226,
        0.991227924823761
      ],
      "plane_d": 48.90058898925781,
      "bbox_min": [
        1630.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1026.25,
        87.49999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1630.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1630.0,
        960.0,
        87.49999237060547
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1630.0,
        1050.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1400.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        1630.0,
        1050.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1220.0,
      "bbox_min": [
        1630.0,
        1140.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 804.3154296875,
      "bbox_min": [
        1657.0,
        1140.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1657.0,
        1150.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1650.0,
      "bbox_min": [
        1630.0,
        960.0,
        87.49999237060547
      ],
      "bbox_max": [
        1680.0,
        1170.0,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1630.0,
        960.0,
        87.49999237060547
      ],
      "bbox_max": [
        1650.0,
        1170.0,
        133.3333282470703
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1630.0,
        960.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        133.3333282470703
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1630.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1630.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1633.0,
        1150.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1630.0,
        1150.0,
        118.0
      ],
      "bbox_max": [
        1633.0,
        1150.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 804.3154296875,
      "bbox_min": [
        1630.0,
        1140.0,
        120.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        133.3333282470703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1630.0,
        1140.0,
        120.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        133.3333282470703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1630.0,
        1150.0,
        120.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        133.3333282470703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.13216373324394226,
        0.991227924823761
      ],
      "plane_d": 48.90058898925781,
      "bbox_min": [
        1630.0,
        1026.25,
        87.49999237060547
      ],
      "bbox_max": [
        1650.0,
        1170.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1630.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1650.0,
        1170.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.13216373324394226,
        0.991227924823761
      ],
      "plane_d": 48.90058898925781,
      "bbox_min": [
        1650.0,
        960.0,
        87.49999237060547
      ],
      "bbox_max": [
        1680.0,
        1170.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1650.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1170.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1660.0,
      "bbox_min": [
        1650.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5547002553939819,
        -0.8320503234863281
      ],
      "plane_d": -450.9713134765625,
      "bbox_min": [
        1650.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1650.0,
        990.0,
        120.0
      ],
      "bbox_max": [
        1660.0,
        993.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1650.0,
        990.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 804.3154296875,
      "bbox_min": [
        1650.0,
        1140.0,
        131.3333282470703
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1650.0,
        1150.0,
        131.3333282470703
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1650.0,
        990.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1000.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1650.0,
        993.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1000.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1650.0,
        1000.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1000.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1680.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1680.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1750.0,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1680.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1750.0,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1680.0,
        840.0,
        100.0
      ],
      "bbox_max": [
        1750.0,
        840.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        1680.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1690.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1690.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1690.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        1690.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        940.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1220.0,
      "bbox_min": [
        1690.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -339.41131591796875,
      "bbox_min": [
        1690.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 346.48236083984375,
      "bbox_min": [
        1690.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2100.107421875,
      "bbox_min": [
        1690.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1690.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1700.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1690.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1700.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6666666269302368,
        0.6666666269302368,
        0.3333333134651184
      ],
      "plane_d": 286.6666259765625,
      "bbox_min": [
        1690.0,
        1200.0,
        100.0
      ],
      "bbox_max": [
        1710.0,
        1220.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8921462297439575,
        -0.07137169688940048,
        0.44607311487197876
      ],
      "plane_d": 1534.1346435546875,
      "bbox_min": [
        1680.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1210.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": 1457.91650390625,
      "bbox_min": [
        1680.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1210.0,
        134.40017700195312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1680.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1210.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6666666269302368,
        0.6666666269302368,
        0.3333333134651184
      ],
      "plane_d": 286.6666259765625,
      "bbox_min": [
        1680.0,
        1200.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        1210.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -339.41131591796875,
      "bbox_min": [
        1680.0,
        1200.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        1210.0,
        119.99980163574219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -339.41131591796875,
      "bbox_min": [
        1680.0,
        1200.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        1210.0,
        134.40017700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1680.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1210.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1680.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1690.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1680.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1690.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1680.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1690.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1680.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1690.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        700.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1530.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1550.0,
      "bbox_min": [
        1530.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 997.0205688476562,
      "bbox_min": [
        1530.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1530.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.500001847743988,
        -0.500001847743988,
        0.7071040868759155
      ],
      "plane_d": 1430.153076171875,
      "bbox_min": [
        1547.9998779296875,
        1505.455810546875,
        138.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1508.2841796875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1530.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1550.0,
        1507.455810546875,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1530.0,
        1450.0,
        138.0
      ],
      "bbox_max": [
        1547.9998779296875,
        1690.0,
        138.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1470.0,
      "bbox_min": [
        1549.9998779296875,
        1467.9998779296875,
        138.0
      ],
      "bbox_max": [
        1630.0,
        1508.2841796875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2938015743202413e-06,
        -0.7071091532707214,
        0.7071043252944946
      ],
      "plane_d": 940.4536743164062,
      "bbox_min": [
        1585.4556884765625,
        1467.9998779296875,
        138.0
      ],
      "bbox_max": [
        1630.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500001847743988,
        -0.500001847743988,
        0.7071040868759155
      ],
      "plane_d": 1430.153076171875,
      "bbox_min": [
        1585.4556884765625,
        1467.9998779296875,
        138.0
      ],
      "bbox_max": [
        1588.2841796875,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500001847743988,
        -0.500001847743988,
        0.7071040868759155
      ],
      "plane_d": 1430.153076171875,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        138.0
      ],
      "bbox_max": [
        1588.2841796875,
        1508.2841796875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500001847743988,
        -0.500001847743988,
        0.7071040868759155
      ],
      "plane_d": 1430.153076171875,
      "bbox_min": [
        1549.9998779296875,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1505.455810546875,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2938015743202413e-06,
        -0.7071091532707214,
        0.7071043252944946
      ],
      "plane_d": 940.4536743164062,
      "bbox_min": [
        1580.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1468.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1550.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1580.0,
        1480.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1530.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1530.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1630.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1530.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1630.0,
        1170.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1530.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1630.0,
        1170.0,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1530.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1530.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1615.0,
        1170.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1614.9998779296875,
      "bbox_min": [
        1555.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1555.0,
      "bbox_min": [
        1555.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1555.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1555.0,
      "bbox_min": [
        1555.0,
        1128.0,
        138.0
      ],
      "bbox_max": [
        1555.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1530.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1450.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": -813.9287719726562,
      "bbox_min": [
        1530.0,
        1440.0,
        120.0
      ],
      "bbox_max": [
        1580.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1439.9998779296875,
      "bbox_min": [
        1530.0,
        1440.0,
        120.0
      ],
      "bbox_max": [
        1580.0,
        1450.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 812.1399536132812,
      "bbox_min": [
        1530.0,
        1440.0,
        120.0
      ],
      "bbox_max": [
        1576.0,
        1450.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1566.5,
      "bbox_min": [
        1566.5,
        1440.0,
        124.75005340576172
      ],
      "bbox_max": [
        1566.5,
        1450.0,
        126.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1530.0,
        1440.0,
        120.0
      ],
      "bbox_max": [
        1566.5,
        1450.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1566.5,
      "bbox_min": [
        1566.5,
        1440.0,
        120.0
      ],
      "bbox_max": [
        1566.5,
        1450.0,
        124.75005340576172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1530.0,
        810.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1580.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1580.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        920.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        1580.0,
        845.0,
        135.0
      ],
      "bbox_max": [
        1598.0,
        845.0,
        138.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        1580.0,
        845.0,
        138.5
      ],
      "bbox_max": [
        1600.0,
        860.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -860.0,
      "bbox_min": [
        1598.0,
        860.0,
        138.5
      ],
      "bbox_max": [
        1600.0,
        860.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1600.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1600.0,
        840.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        840.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1530.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1530.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        960.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1530.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        960.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -579.8275756835938,
      "bbox_min": [
        1530.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        940.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1530.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        940.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1600.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        940.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -1046.4798583984375,
      "bbox_min": [
        1530.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1530.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1530.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        1535.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1534.9998779296875,
      "bbox_min": [
        1535.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1615.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1614.9998779296875,
      "bbox_min": [
        1555.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1615.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1555.0,
      "bbox_min": [
        1555.0,
        1110.0,
        138.0
      ],
      "bbox_max": [
        1555.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        700.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1250.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1480.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1480.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1235.4296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1480.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1530.0,
        1235.4296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1480.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1530.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1480.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1530.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1480.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1530.0,
        1235.4296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37629082798957825,
        0.9265016913414001,
        -0.0
      ],
      "plane_d": -1711.133544921875,
      "bbox_min": [
        1505.5,
        1214.5703125,
        134.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211457371711731,
        -0.3892177939414978,
        0.0
      ],
      "plane_d": -919.9827270507812,
      "bbox_min": [
        1505.5,
        1214.5703125,
        134.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1232.2733154296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37629082798957825,
        -0.9265016913414001,
        0.0
      ],
      "plane_d": 558.7955932617188,
      "bbox_min": [
        1505.5,
        1214.5703125,
        139.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1232.2733154296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211457371711731,
        0.3892177939414978,
        -0.0
      ],
      "plane_d": -1873.56640625,
      "bbox_min": [
        1513.2716064453125,
        1225.0,
        139.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1232.2733154296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1480.0,
        1350.0,
        115.65217590332031
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.04339630529284477,
        -0.04339630529284477,
        0.9981150031089783
      ],
      "plane_d": 7.377372741699219,
      "bbox_min": [
        1480.0,
        1350.0,
        115.65217590332031
      ],
      "bbox_max": [
        1530.0,
        1450.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1480.0,
        1380.0,
        138.0
      ],
      "bbox_max": [
        1500.0,
        1690.0,
        140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1640.0,
      "bbox_min": [
        1480.0,
        1610.0,
        138.0
      ],
      "bbox_max": [
        1500.0,
        1640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        1480.0,
        1610.0,
        138.0
      ],
      "bbox_max": [
        1500.0,
        1610.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1500.0,
        1470.0,
        138.0
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1500.0,
        1470.0,
        138.0
      ],
      "bbox_max": [
        1530.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1640.0,
      "bbox_min": [
        1500.0,
        1640.0,
        138.0
      ],
      "bbox_max": [
        1530.0,
        1640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08662962168455124,
        0.0,
        0.9962406754493713
      ],
      "plane_d": 8.662956237792969,
      "bbox_min": [
        1250.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1260.75,
        1590.0,
        100.62451171875
      ],
      "bbox_max": [
        1269.77294921875,
        1598.0,
        101.7193603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1597.9998779296875,
      "bbox_min": [
        1260.75,
        1590.0,
        100.62451171875
      ],
      "bbox_max": [
        1269.77294921875,
        1598.0,
        101.7193603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1260.75,
      "bbox_min": [
        1260.75,
        1590.0,
        100.62451171875
      ],
      "bbox_max": [
        1260.75,
        1598.0,
        100.93478393554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        1250.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1250.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03874197229743004,
        -0.8944270610809326,
        0.4455326497554779
      ],
      "plane_d": 1443.9354248046875,
      "bbox_min": [
        1250.0,
        1620.0,
        120.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9302632212638855,
        0.0,
        0.36689305305480957
      ],
      "plane_d": 1118.8017578125,
      "bbox_min": [
        1250.0,
        1620.0,
        120.0
      ],
      "bbox_max": [
        1257.887939453125,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        1250.0,
        1570.0,
        100.93478393554688
      ],
      "bbox_max": [
        1480.0,
        1610.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1250.0,
        1570.0,
        100.93478393554688
      ],
      "bbox_max": [
        1480.0,
        1610.0,
        140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1266.5,
        1570.0,
        138.0
      ],
      "bbox_max": [
        1480.0,
        1610.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1270.0,
        1590.0,
        138.0
      ],
      "bbox_max": [
        1270.0,
        1610.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1415.0,
      "bbox_min": [
        1266.5,
        1570.0,
        138.0
      ],
      "bbox_max": [
        1438.5,
        1590.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -592.141845703125,
      "bbox_min": [
        1435.0,
        1570.0,
        138.0
      ],
      "bbox_max": [
        1438.5,
        1590.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1435.0,
      "bbox_min": [
        1435.0,
        1580.0,
        138.0
      ],
      "bbox_max": [
        1438.5,
        1590.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1580.0,
      "bbox_min": [
        1435.0,
        1580.0,
        138.0
      ],
      "bbox_max": [
        1438.5,
        1580.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 508.5424499511719,
      "bbox_min": [
        1266.5,
        1580.0,
        138.0
      ],
      "bbox_max": [
        1280.0,
        1590.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        1266.5,
        1580.0,
        138.0
      ],
      "bbox_max": [
        1280.0,
        1590.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        1280.0,
        1580.0,
        138.0
      ],
      "bbox_max": [
        1280.0,
        1590.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -510.2789306640625,
      "bbox_min": [
        1250.0,
        1580.0,
        100.93478393554688
      ],
      "bbox_max": [
        1270.0,
        1598.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 508.5424499511719,
      "bbox_min": [
        1250.0,
        1580.0,
        126.57142639160156
      ],
      "bbox_max": [
        1270.0,
        1590.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1590.0,
      "bbox_min": [
        1250.0,
        1580.0,
        126.57142639160156
      ],
      "bbox_max": [
        1270.0,
        1590.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4653295874595642,
        0.0,
        0.8851376175880432
      ],
      "plane_d": -680.8985595703125,
      "bbox_min": [
        1250.0,
        1590.0,
        100.93478393554688
      ],
      "bbox_max": [
        1269.77294921875,
        1598.0,
        112.11428833007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1250.0,
        1590.0,
        100.93478393554688
      ],
      "bbox_max": [
        1269.77294921875,
        1598.0,
        112.11428833007812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.46532946825027466,
        0.0,
        -0.885137677192688
      ],
      "plane_d": 679.1281127929688,
      "bbox_min": [
        1250.0,
        1590.0,
        100.93478393554688
      ],
      "bbox_max": [
        1266.508544921875,
        1598.0,
        110.11428833007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1260.75,
      "bbox_min": [
        1260.75,
        1590.0,
        104.46280670166016
      ],
      "bbox_max": [
        1260.75,
        1598.0,
        106.46285247802734
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1260.75,
      "bbox_min": [
        1260.75,
        1590.0,
        100.93478393554688
      ],
      "bbox_max": [
        1260.75,
        1598.0,
        104.46280670166016
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1250.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1250.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1270.0001220703125,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1370.0,
      "bbox_min": [
        1370.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1370.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1290.0,
        1120.0,
        120.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1475.0,
      "bbox_min": [
        1475.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1475.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        -0.0,
        0.8944272398948669
      ],
      "plane_d": -711.0697021484375,
      "bbox_min": [
        1290.0,
        1128.0,
        120.0
      ],
      "bbox_max": [
        1475.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1290.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1310.0,
        1170.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1475.0,
      "bbox_min": [
        1475.0,
        1128.0,
        138.0
      ],
      "bbox_max": [
        1475.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04339630529284477,
        -0.04339630529284477,
        0.9981150031089783
      ],
      "plane_d": 7.377372741699219,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 42.4263916015625,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1428.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1420.0,
        140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -70.71063232421875,
      "bbox_min": [
        1280.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1480.0,
        1380.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        1280.0,
        1180.0001220703125,
        138.0
      ],
      "bbox_max": [
        1280.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        1280.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1362.071044921875,
        1247.071044921875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        1280.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1280.0,
        1180.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1834.335693359375,
      "bbox_min": [
        1347.071044921875,
        1232.071044921875,
        138.0
      ],
      "bbox_max": [
        1362.071044921875,
        1247.071044921875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1300.0,
        1205.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1250.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1270.0001220703125,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1250.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1270.0001220703125,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1250.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1270.0001220703125,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1250.0,
        1190.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1428.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1297.928955078125,
        1252.9288330078125,
        138.0
      ],
      "bbox_max": [
        1480.0,
        1428.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9996317028999329,
        0.027140598744153976,
        0.0
      ],
      "plane_d": 1440.6982421875,
      "bbox_min": [
        1479.7767333984375,
        1419.7767333984375,
        138.0
      ],
      "bbox_max": [
        1480.0,
        1428.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1250.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1250.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        1250.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        960.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1380.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        960.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1380.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -910.0,
      "bbox_min": [
        1380.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1470.0,
      "bbox_min": [
        1470.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1480.0,
        745.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        100.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        1500.0,
        750.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        940.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        1500.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1519.9998779296875,
      "bbox_min": [
        1500.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        940.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1500.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1510.0,
        900.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1250.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1250.0,
        1030.0,
        80.0
      ],
      "bbox_max": [
        1258.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -1046.4798583984375,
      "bbox_min": [
        1380.0,
        1110.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1380.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        1380.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1475.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1454.9998779296875,
      "bbox_min": [
        1455.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1475.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1475.0,
      "bbox_min": [
        1475.0,
        1110.0,
        138.0
      ],
      "bbox_max": [
        1475.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1030.0,
        825.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        1030.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1200.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1235.0,
      "bbox_min": [
        1200.0,
        1170.0,
        110.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1670.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1200.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1670.0,
        140.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1200.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1670.0,
        120.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1200.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1670.0,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1670.0,
      "bbox_min": [
        1215.0,
        1670.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1670.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1200.0,
        1250.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1670.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1650.0,
      "bbox_min": [
        1200.0,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1670.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1670.0,
      "bbox_min": [
        1200.0,
        1670.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1670.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        1200.0,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1460.0,
      "bbox_min": [
        1200.0,
        1250.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        1200.0,
        1250.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1200.0,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1235.0,
        1400.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1200.0,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1235.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 481.2547912597656,
      "bbox_min": [
        1211.5,
        1390.0,
        138.0
      ],
      "bbox_max": [
        1215.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1215.0,
      "bbox_min": [
        1200.0,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1215.0,
        1400.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 481.2547912597656,
      "bbox_min": [
        1200.0,
        1390.0,
        131.42857360839844
      ],
      "bbox_max": [
        1211.5,
        1400.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1235.0,
        1220.0,
        110.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1670.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        1235.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1400.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -21.2132568359375,
      "bbox_min": [
        1240.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1220.0,
      "bbox_min": [
        1240.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1240.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1235.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1240.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1235.0,
        1580.0,
        110.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1670.0,
        128.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1670.0,
      "bbox_min": [
        1235.0,
        1670.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1670.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1235.0,
        1580.0,
        118.0
      ],
      "bbox_max": [
        1238.8043212890625,
        1598.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4653295874595642,
        0.0,
        0.8851376175880432
      ],
      "plane_d": -680.8985595703125,
      "bbox_min": [
        1235.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1238.8043212890625,
        1598.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1598.0,
      "bbox_min": [
        1235.0,
        1598.0,
        118.0
      ],
      "bbox_max": [
        1238.8043212890625,
        1598.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -510.2789306640625,
      "bbox_min": [
        1235.0,
        1580.0,
        118.0
      ],
      "bbox_max": [
        1238.5,
        1590.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        1235.0,
        1580.0,
        118.0
      ],
      "bbox_max": [
        1238.5,
        1580.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 508.5424499511719,
      "bbox_min": [
        1235.0,
        1580.0,
        120.0
      ],
      "bbox_max": [
        1250.0,
        1590.0,
        128.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -510.2789306640625,
      "bbox_min": [
        1235.0,
        1580.0,
        120.0
      ],
      "bbox_max": [
        1250.0,
        1590.0,
        128.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1590.0,
      "bbox_min": [
        1235.0,
        1580.0,
        120.0
      ],
      "bbox_max": [
        1250.0,
        1590.0,
        128.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        1235.0,
        1580.0,
        120.0
      ],
      "bbox_max": [
        1250.0,
        1580.0,
        128.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46532946825027466,
        0.0,
        -0.885137677192688
      ],
      "plane_d": 679.1281127929688,
      "bbox_min": [
        1235.0,
        1590.0,
        110.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1598.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1235.0,
        1590.0,
        110.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1598.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1598.0,
      "bbox_min": [
        1235.0,
        1590.0,
        110.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1598.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4653295874595642,
        0.0,
        0.8851376175880432
      ],
      "plane_d": -680.8985595703125,
      "bbox_min": [
        1238.8043212890625,
        1590.0,
        112.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1598.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1030.0,
        1280.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1030.0,
        1280.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        1030.0,
        1280.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        1030.0,
        1390.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        1030.0,
        1390.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1550.0,
      "bbox_min": [
        1030.0,
        1390.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1550.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1140.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1140.0,
        1390.0,
        100.0199966430664
      ],
      "bbox_max": [
        1200.0,
        1460.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1140.0,
        1390.0,
        100.0199966430664
      ],
      "bbox_max": [
        1200.0,
        1460.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1140.0,
        1390.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": -1095.374267578125,
      "bbox_min": [
        1140.0,
        1415.0,
        118.0
      ],
      "bbox_max": [
        1160.0,
        1418.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913010776042938,
        0.9678216576576233,
        -0.24195532500743866
      ],
      "plane_d": -1419.4141845703125,
      "bbox_min": [
        1140.0,
        1415.0,
        119.28571319580078
      ],
      "bbox_max": [
        1142.5,
        1415.1785888671875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1460.0,
      "bbox_min": [
        1180.0,
        1460.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1140.0,
        1390.0,
        100.0199966430664
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": -1095.374267578125,
      "bbox_min": [
        1140.0,
        1415.771484375,
        114.28571319580078
      ],
      "bbox_max": [
        1153.0,
        1418.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1159.9998779296875,
      "bbox_min": [
        1140.0,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1460.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.06913010776042938,
        0.9678216576576233,
        -0.24195532500743866
      ],
      "plane_d": -1419.4141845703125,
      "bbox_min": [
        1140.0,
        1415.0,
        120.0
      ],
      "bbox_max": [
        1160.0,
        1430.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": -1095.374267578125,
      "bbox_min": [
        1140.0,
        1415.0,
        120.0
      ],
      "bbox_max": [
        1160.0,
        1430.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2747208774089813,
        0.0,
        -0.9615241289138794
      ],
      "plane_d": -179.2552032470703,
      "bbox_min": [
        1140.0,
        1420.0,
        139.2857208251953
      ],
      "bbox_max": [
        1142.5,
        1430.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 481.2547912597656,
      "bbox_min": [
        1180.0,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1400.0,
        131.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1180.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1400.0,
        131.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1030.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.05225301533937454,
        -0.8944270610809326,
        0.4441506266593933
      ],
      "plane_d": 1458.3773193359375,
      "bbox_min": [
        1030.0,
        1620.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8360482454299927,
        -0.0,
        0.5486558675765991
      ],
      "plane_d": -1069.0965576171875,
      "bbox_min": [
        1187.731689453125,
        1620.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1187.731689453125,
      "bbox_min": [
        1187.731689453125,
        1630.0,
        138.69459533691406
      ],
      "bbox_max": [
        1187.731689453125,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        121.03141784667969
      ],
      "bbox_max": [
        1187.731689453125,
        1630.64794921875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1187.731689453125,
      "bbox_min": [
        1187.731689453125,
        1630.0,
        138.69459533691406
      ],
      "bbox_max": [
        1187.731689453125,
        1630.64794921875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1030.0,
        1590.0,
        114.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1030.0,
        1590.0,
        114.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        1590.0,
        114.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        1030.0,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1047.5,
      "bbox_min": [
        1047.5,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1047.5,
        1620.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47058823704719543,
        0.0,
        -0.8823529481887817
      ],
      "plane_d": -384.1176452636719,
      "bbox_min": [
        1030.0,
        1610.0,
        114.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1030.0,
        1610.0,
        114.0
      ],
      "bbox_max": [
        1037.5,
        1610.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        1030.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1200.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1030.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1030.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1120.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1235.0,
      "bbox_min": [
        1235.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1120.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1120.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1235.0,
      "bbox_min": [
        1030.0,
        825.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        825.0,
        80.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1030.0,
        825.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1186.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1186.0,
        1030.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1030.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1200.0,
        1030.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1095.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1095.0,
      "bbox_min": [
        1200.0,
        1082.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1095.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1210.0,
      "bbox_min": [
        1210.0,
        1082.0,
        118.0
      ],
      "bbox_max": [
        1210.0,
        1085.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1030.0,
        825.0,
        120.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9992009997367859,
        -0.0,
        0.039968036115169525
      ],
      "plane_d": -1194.2449951171875,
      "bbox_min": [
        1030.0,
        930.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": -1114.3089599609375,
      "bbox_min": [
        1030.0,
        970.0,
        120.0
      ],
      "bbox_max": [
        1190.4000244140625,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1189.199951171875,
        970.0,
        130.0
      ],
      "bbox_max": [
        1190.0,
        970.4000244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1050.0,
        1079.5999755859375,
        130.0
      ],
      "bbox_max": [
        1190.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1189.199951171875,
        1079.5999755859375,
        130.0
      ],
      "bbox_max": [
        1190.0,
        1080.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1050.0,
        1109.199951171875,
        130.0
      ],
      "bbox_max": [
        1050.4000244140625,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        0.5547001957893372
      ],
      "plane_d": -1004.00732421875,
      "bbox_min": [
        1030.0,
        1109.5999755859375,
        130.0
      ],
      "bbox_max": [
        1190.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1040.0,
        1109.5999755859375,
        130.0
      ],
      "bbox_max": [
        1170.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1040.0,
        1109.5999755859375,
        130.0
      ],
      "bbox_max": [
        1050.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1030.0,
        1113.3333740234375,
        130.0
      ],
      "bbox_max": [
        1190.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1040.0,
        1113.3333740234375,
        130.0
      ],
      "bbox_max": [
        1170.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1163.7333984375,
        1113.3333740234375,
        130.0
      ],
      "bbox_max": [
        1170.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -1070.5714111328125,
      "bbox_min": [
        1189.599853515625,
        930.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1189.599853515625,
        960.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1189.5999755859375,
        960.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        970.0000610351562,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1189.599853515625,
        1080.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1189.599853515625,
        1119.199951171875,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974522560834885
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1193.3333740234375,
        930.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1193.3333740234375,
        960.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1193.3333740234375,
        1119.199951171875,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1193.3333740234375,
        960.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1193.3333740234375,
        1030.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1199.199951171875,
        1030.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1200.0,
        1030.0,
        120.0
      ],
      "bbox_max": [
        1235.0,
        1085.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": -701.69580078125,
      "bbox_min": [
        1200.0,
        1035.0,
        120.0
      ],
      "bbox_max": [
        1235.0,
        1085.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1200.0,
        1035.0,
        120.0
      ],
      "bbox_max": [
        1235.0,
        1085.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1055.0,
      "bbox_min": [
        1210.0,
        1055.0,
        138.0
      ],
      "bbox_max": [
        1235.0,
        1058.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1210.0,
      "bbox_min": [
        1210.0,
        1055.0,
        138.0
      ],
      "bbox_max": [
        1210.0,
        1058.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1210.0,
      "bbox_min": [
        1210.0,
        1055.0,
        120.0
      ],
      "bbox_max": [
        1210.0,
        1085.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10468478500843048,
        0.9945054650306702
      ],
      "plane_d": 17.796409606933594,
      "bbox_min": [
        1186.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1186.0,
        1030.0,
        80.0
      ],
      "bbox_max": [
        1235.0,
        1030.0,
        90.52631378173828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1186.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1186.0,
        1030.0,
        90.52631378173828
      ],
      "bbox_max": [
        1200.0,
        1030.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1200.0,
        1030.0,
        90.52631378173828
      ],
      "bbox_max": [
        1235.0,
        1030.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10468478500843048,
        0.9945054650306702
      ],
      "plane_d": 17.796409606933594,
      "bbox_min": [
        1235.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1235.0,
        1030.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1030.0,
        90.52631378173828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1235.0,
        1030.0,
        90.52631378173828
      ],
      "bbox_max": [
        1250.0,
        1055.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1235.0,
        1035.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1055.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1055.0,
      "bbox_min": [
        1235.0,
        1055.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1055.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        780.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        780.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        140.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        780.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1635.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        780.0,
        1120.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1635.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        790.0,
        1120.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1540.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -790.0,
      "bbox_min": [
        790.0,
        1530.0,
        98.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        -0.371390700340271,
        0.0
      ],
      "plane_d": -475.3800964355469,
      "bbox_min": [
        960.0,
        1120.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1170.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15730521082878113,
        0.0,
        0.9875500798225403
      ],
      "plane_d": 49.98626708984375,
      "bbox_min": [
        885.0,
        1540.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1635.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        960.0,
        1570.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1635.0,
      "bbox_min": [
        885.0,
        1625.0,
        98.0
      ],
      "bbox_max": [
        915.0,
        1635.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 24.76092529296875,
      "bbox_min": [
        912.5,
        1630.0,
        98.0
      ],
      "bbox_max": [
        915.0,
        1634.330078125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        780.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        780.0,
        1472.83544921875,
        60.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        790.0,
        1472.83544921875,
        61.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -790.0,
      "bbox_min": [
        790.0,
        1530.0,
        61.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        960.0,
        1570.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        780.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        790.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1540.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -790.0,
      "bbox_min": [
        790.0,
        1530.0,
        80.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        -0.371390700340271,
        0.0
      ],
      "plane_d": -475.3800964355469,
      "bbox_min": [
        960.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1170.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15730521082878113,
        0.0,
        0.9875500798225403
      ],
      "plane_d": 49.98626708984375,
      "bbox_min": [
        820.0,
        1540.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        960.0,
        1570.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        840.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        840.0,
        1120.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1120.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -945.5584716796875,
      "bbox_min": [
        945.5584716796875,
        1540.0,
        120.0
      ],
      "bbox_max": [
        945.5584716796875,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8237894773483276,
        -0.29381439089775085,
        -0.48481348156929016
      ],
      "plane_d": -413.284423828125,
      "bbox_min": [
        971.7703247070312,
        1120.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1143.07421875,
        133.9837646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        840.0,
        1570.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        955.0,
        1655.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1873.8330078125,
      "bbox_min": [
        960.0,
        1670.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        955.0,
        1570.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1605.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 431.3350830078125,
      "bbox_min": [
        960.0,
        1570.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1590.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        840.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1540.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8304547071456909,
        -0.3321818709373474,
        -0.4472138285636902
      ],
      "plane_d": -380.4714660644531,
      "bbox_min": [
        960.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8237894773483276,
        -0.29381439089775085,
        -0.48481348156929016
      ],
      "plane_d": -413.284423828125,
      "bbox_min": [
        960.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1143.07421875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        840.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        885.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        885.0,
        1625.0,
        100.0
      ],
      "bbox_max": [
        940.0,
        1641.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9363291263580322,
        0.0,
        -0.3511234223842621
      ],
      "plane_d": -808.7542724609375,
      "bbox_min": [
        905.0,
        1625.0,
        110.0
      ],
      "bbox_max": [
        910.3886108398438,
        1641.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8374775648117065,
        -0.41873878240585327,
        -0.3511256277561188
      ],
      "plane_d": -34.655479431152344,
      "bbox_min": [
        905.0,
        1634.291748046875,
        110.0
      ],
      "bbox_max": [
        910.3886108398438,
        1641.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1635.0,
      "bbox_min": [
        885.0,
        1625.0,
        100.0
      ],
      "bbox_max": [
        940.0,
        1641.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": -78.26239013671875,
      "bbox_min": [
        905.0,
        1635.0,
        100.0
      ],
      "bbox_max": [
        908.0,
        1641.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -885.0,
      "bbox_min": [
        885.0,
        1625.0,
        100.0
      ],
      "bbox_max": [
        885.0,
        1635.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        955.0,
        1655.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        955.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1605.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 431.3350830078125,
      "bbox_min": [
        960.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1590.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        960.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        780.0,
        1450.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        780.0,
        1540.0,
        120.0
      ],
      "bbox_max": [
        840.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        805.0,
        1570.0,
        120.0
      ],
      "bbox_max": [
        840.0,
        1610.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        805.0,
        1595.0,
        120.0
      ],
      "bbox_max": [
        840.0,
        1610.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1704.12744140625,
      "bbox_min": [
        805.0,
        1595.0,
        120.0
      ],
      "bbox_max": [
        815.0,
        1605.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        0.5144957304000854,
        -0.0
      ],
      "plane_d": -1555.4921875,
      "bbox_min": [
        780.0,
        1530.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        1690.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        780.0,
        1530.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        1610.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -790.0,
      "bbox_min": [
        790.0,
        1530.0,
        100.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        805.0,
        1595.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1704.12744140625,
      "bbox_min": [
        805.0,
        1595.0,
        100.0
      ],
      "bbox_max": [
        815.0,
        1605.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        980.0,
        1120.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        1460.0,
        98.0
      ],
      "bbox_max": [
        1003.75,
        1640.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.47058823704719543,
        0.0,
        -0.8823529481887817
      ],
      "plane_d": -384.1176452636719,
      "bbox_min": [
        1000.0,
        1610.0,
        98.0
      ],
      "bbox_max": [
        1003.75,
        1620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1000.0,
        1610.0,
        98.0
      ],
      "bbox_max": [
        1003.75,
        1620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1000.0,
        1610.0,
        98.0
      ],
      "bbox_max": [
        1003.75,
        1610.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8237894773483276,
        -0.29381439089775085,
        -0.48481348156929016
      ],
      "plane_d": -413.284423828125,
      "bbox_min": [
        980.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1000.0,
        1590.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1620.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1000.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1620.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47058823704719543,
        0.0,
        -0.8823529481887817
      ],
      "plane_d": -384.1176452636719,
      "bbox_min": [
        1003.75,
        1610.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1620.0,
        114.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1590.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8304547071456909,
        -0.3321818709373474,
        -0.4472138285636902
      ],
      "plane_d": -380.4714660644531,
      "bbox_min": [
        980.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        980.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1000.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        82.10526275634766
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.10459312796592712,
        0.04183724895119667,
        0.9936347007751465
      ],
      "plane_d": -20.709434509277344,
      "bbox_min": [
        1010.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        82.10526275634766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        780.0,
        930.0,
        78.88890075683594
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        950.0,
        930.0,
        78.88890075683594
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043035984039307,
        0.0,
        0.9938838481903076
      ],
      "plane_d": 26.50244140625,
      "bbox_min": [
        950.0,
        970.0,
        78.88890075683594
      ],
      "bbox_max": [
        960.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        950.0,
        970.0,
        78.88890075683594
      ],
      "bbox_max": [
        950.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        950.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        950.0,
        1100.0,
        100.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        865.0,
        980.0,
        110.0
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        865.0,
        1083.890869140625,
        110.0
      ],
      "bbox_max": [
        907.4263916015625,
        1100.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        865.0,
        1083.890869140625,
        120.0
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974521815776825
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1010.0,
        1109.5999755859375,
        130.0
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": -1114.3089599609375,
      "bbox_min": [
        1020.0,
        1109.5999755859375,
        130.0
      ],
      "bbox_max": [
        1030.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        700.0,
        980.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        700.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        720.0,
        1040.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        720.0,
        1040.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        110.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        740.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1550.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        720.0,
        1040.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        760.0,
        1040.0,
        110.0
      ],
      "bbox_max": [
        780.0,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        260.0,
        670.0,
        139.99998474121094
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        1180.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        269.94561767578125,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -450.0,
      "bbox_min": [
        269.94561767578125,
        1550.0,
        190.0
      ],
      "bbox_max": [
        450.0,
        1690.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.23023629188537598,
        -0.3445734679698944,
        0.910088062286377
      ],
      "plane_d": 181.0498046875,
      "bbox_min": [
        269.94561767578125,
        1550.0,
        281.75616455078125
      ],
      "bbox_max": [
        419.63916015625,
        1675.537109375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35946810245513916,
        -0.24018871784210205,
        0.9017161726951599
      ],
      "plane_d": -27.496994018554688,
      "bbox_min": [
        269.94561767578125,
        1550.0,
        291.6202087402344
      ],
      "bbox_max": [
        380.6481018066406,
        1634.350341796875,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4490928053855896,
        -0.08933013677597046,
        0.8890084028244019
      ],
      "plane_d": -285.03179931640625,
      "bbox_min": [
        269.94561767578125,
        1550.0,
        319.85107421875
      ],
      "bbox_max": [
        309.8317565917969,
        1572.7098388671875,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        790.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        1480.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        1659.9998779296875,
        1550.0,
        337.5488586425781
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9679223895072937,
        -0.251249760389328,
        0.0
      ],
      "plane_d": 2063.14892578125,
      "bbox_min": [
        1692.8388671875,
        1608.9862060546875,
        340.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        1692.8388671875,
        1608.9862060546875,
        340.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.26658356189727783,
        -0.9638118147850037,
        0.0
      ],
      "plane_d": 2022.61279296875,
      "bbox_min": [
        1757.2113037109375,
        1608.9862060546875,
        340.0
      ],
      "bbox_max": [
        1770.0,
        1612.5234375,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1488.300048828125,
      "bbox_min": [
        1480.0,
        1610.0,
        177.0
      ],
      "bbox_max": [
        1488.300048828125,
        1690.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 176.99998474121094,
      "bbox_min": [
        1480.0,
        1610.0,
        177.0
      ],
      "bbox_max": [
        1488.300048828125,
        1690.0,
        179.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -179.0,
      "bbox_min": [
        1480.0,
        1610.0,
        177.0
      ],
      "bbox_max": [
        1488.300048828125,
        1690.0,
        179.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1480.0,
        1610.0,
        177.0
      ],
      "bbox_max": [
        1488.300048828125,
        1610.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        790.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        429.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1200.0,
        1610.0,
        140.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        429.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1350.0,
      "bbox_min": [
        1200.0,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        429.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1258.199951171875,
      "bbox_min": [
        1200.0,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        429.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": -1376.9708251953125,
      "bbox_min": [
        1325.0,
        1630.0,
        379.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 379.0,
      "bbox_min": [
        1200.0,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        1200.0,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5881717205047607,
        0.0,
        -0.8087361454963684
      ],
      "plane_d": -502.1515808105469,
      "bbox_min": [
        1200.0,
        1630.0,
        148.0
      ],
      "bbox_max": [
        1225.0,
        1690.0,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -158.0,
      "bbox_min": [
        1200.0,
        1630.0,
        148.0
      ],
      "bbox_max": [
        1225.0,
        1690.0,
        158.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 148.0,
      "bbox_min": [
        1200.0,
        1630.0,
        148.0
      ],
      "bbox_max": [
        1225.0,
        1690.0,
        158.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -473.3931884765625,
      "bbox_min": [
        1200.0,
        1640.0,
        148.0
      ],
      "bbox_max": [
        1225.0,
        1680.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870620250702,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1085.2369384765625,
      "bbox_min": [
        1205.85791015625,
        1640.0,
        148.0
      ],
      "bbox_max": [
        1225.0,
        1680.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1048.28173828125,
      "bbox_min": [
        1220.0,
        1640.0,
        148.0
      ],
      "bbox_max": [
        1225.0,
        1680.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        -0.9238780736923218,
        -0.0
      ],
      "plane_d": 2018.9932861328125,
      "bbox_min": [
        1220.0,
        1677.928955078125,
        148.0
      ],
      "bbox_max": [
        1225.0,
        1680.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9302632212638855,
        0.0,
        0.36689305305480957
      ],
      "plane_d": 1118.8017578125,
      "bbox_min": [
        1225.0,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -158.0,
      "bbox_min": [
        1225.0,
        1630.0,
        148.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        158.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 148.0,
      "bbox_min": [
        1225.0,
        1630.0,
        148.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        158.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9238780736923218,
        0.3826870620250702,
        0.0
      ],
      "plane_d": 510.3482666015625,
      "bbox_min": [
        1225.0,
        1642.071044921875,
        148.0
      ],
      "bbox_max": [
        1240.0,
        1677.928955078125,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238780736923218,
        -0.3826870620250702,
        -0.0
      ],
      "plane_d": 1780.869384765625,
      "bbox_min": [
        1225.0,
        1642.071044921875,
        148.0
      ],
      "bbox_max": [
        1240.0,
        1677.928955078125,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1048.28173828125,
      "bbox_min": [
        1225.0,
        1642.071044921875,
        148.0
      ],
      "bbox_max": [
        1234.14208984375,
        1677.928955078125,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        -0.9238780736923218,
        -0.0
      ],
      "plane_d": 2018.9932861328125,
      "bbox_min": [
        1225.0,
        1674.14208984375,
        148.0
      ],
      "bbox_max": [
        1234.14208984375,
        1677.928955078125,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -179.0,
      "bbox_min": [
        1350.0,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8523236513137817,
        -0.0,
        0.5230147838592529
      ],
      "plane_d": -1334.6610107421875,
      "bbox_min": [
        1468.300048828125,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 176.99998474121094,
      "bbox_min": [
        1468.300048828125,
        1630.0,
        177.0
      ],
      "bbox_max": [
        1468.3050537109375,
        1690.0,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 176.99998474121094,
      "bbox_min": [
        1468.3050537109375,
        1630.0,
        177.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1360.0,
      "bbox_min": [
        1350.0,
        1640.0,
        179.0
      ],
      "bbox_max": [
        1360.0,
        1680.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -1110.15771484375,
      "bbox_min": [
        1350.0,
        1640.0,
        179.0
      ],
      "bbox_max": [
        1360.0,
        1680.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1639.9998779296875,
      "bbox_min": [
        1350.0,
        1640.0,
        179.0
      ],
      "bbox_max": [
        1360.0,
        1680.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1350.0,
        1680.0,
        179.0
      ],
      "bbox_max": [
        1360.0,
        1680.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.038732245564460754,
        -0.8944514393806458,
        0.44548454880714417
      ],
      "plane_d": 1443.968505859375,
      "bbox_min": [
        1200.0,
        1610.0,
        140.0
      ],
      "bbox_max": [
        1480.0,
        1630.0,
        329.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8523236513137817,
        -0.0,
        0.5230147838592529
      ],
      "plane_d": -1334.6610107421875,
      "bbox_min": [
        1257.887939453125,
        1620.0,
        140.0
      ],
      "bbox_max": [
        1480.0,
        1630.0,
        159.05850219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9302632212638855,
        0.0,
        0.36689305305480957
      ],
      "plane_d": 1118.8017578125,
      "bbox_min": [
        1257.887939453125,
        1629.6195068359375,
        140.0
      ],
      "bbox_max": [
        1258.199951171875,
        1630.0,
        140.79110717773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 176.99998474121094,
      "bbox_min": [
        1200.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1480.0,
        1630.0,
        329.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -179.0,
      "bbox_min": [
        1200.0,
        1610.0,
        177.0
      ],
      "bbox_max": [
        1480.0,
        1630.0,
        329.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1350.0,
        1610.0,
        177.0
      ],
      "bbox_max": [
        1350.0,
        1630.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        1200.0,
        1610.0,
        251.81817626953125
      ],
      "bbox_max": [
        1225.0,
        1630.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5881717205047607,
        0.0,
        -0.8087361454963684
      ],
      "plane_d": -502.1515808105469,
      "bbox_min": [
        1200.0,
        1610.0,
        251.81817626953125
      ],
      "bbox_max": [
        1225.0,
        1630.0,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.030754676088690758,
        0.0,
        -0.9995269775390625
      ],
      "plane_d": 117.94418334960938,
      "bbox_min": [
        1215.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1320.0,
        1630.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.030754676088690758,
        0.0,
        0.9995269775390625
      ],
      "plane_d": -119.9432373046875,
      "bbox_min": [
        1215.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1320.0,
        1630.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -159.99998474121094,
      "bbox_min": [
        1215.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1320.0,
        1630.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 156.0,
      "bbox_min": [
        1215.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1320.0,
        1630.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        1215.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1320.0,
        1630.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1215.0,
        1630.0,
        157.38461303710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -158.0,
      "bbox_min": [
        1215.0,
        1610.0,
        157.38461303710938
      ],
      "bbox_max": [
        1235.0,
        1630.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1610.0,
        157.38461303710938
      ],
      "bbox_max": [
        1215.0,
        1630.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 158.0,
      "bbox_min": [
        1300.0,
        1610.0,
        158.0
      ],
      "bbox_max": [
        1320.0,
        1630.0,
        158.61538696289062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        1320.0,
        1610.0,
        158.0
      ],
      "bbox_max": [
        1320.0,
        1630.0,
        158.61538696289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 149.99998474121094,
      "bbox_min": [
        790.0,
        1610.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        429.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        800.0,
        1610.0,
        150.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        429.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1170.0,
      "bbox_min": [
        800.0,
        1630.0,
        150.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        251.81817626953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8574929237365723,
        0.5144957304000854,
        -0.0
      ],
      "plane_d": -1555.4921875,
      "bbox_min": [
        800.0,
        1630.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        955.0,
        1630.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1873.8330078125,
      "bbox_min": [
        960.0,
        1664.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        970.0,
        1664.0,
        150.0
      ],
      "bbox_max": [
        970.0,
        1680.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        970.0,
        1630.0,
        150.0
      ],
      "bbox_max": [
        970.0,
        1664.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5881717205047607,
        0.0,
        -0.8087361454963684
      ],
      "plane_d": -502.1515808105469,
      "bbox_min": [
        1170.0,
        1630.0,
        158.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        251.81817626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 230.0,
      "bbox_min": [
        970.0,
        1610.0,
        150.0
      ],
      "bbox_max": [
        1200.0,
        1630.0,
        251.81817626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5881717205047607,
        0.0,
        -0.8087361454963684
      ],
      "plane_d": -502.1515808105469,
      "bbox_min": [
        1170.0,
        1610.0,
        230.0
      ],
      "bbox_max": [
        1200.0,
        1630.0,
        251.81817626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        970.0,
        1625.0,
        189.99993896484375
      ],
      "bbox_max": [
        970.0,
        1630.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        970.0,
        1610.0,
        150.0
      ],
      "bbox_max": [
        970.0,
        1630.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        800.0,
        1610.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -572.7564697265625,
      "bbox_min": [
        800.0,
        1630.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        0.5144957304000854,
        -0.0
      ],
      "plane_d": -1555.4921875,
      "bbox_min": [
        800.0,
        1655.0,
        140.0
      ],
      "bbox_max": [
        960.0,
        1690.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        955.0,
        1655.0,
        145.0000457763672
      ],
      "bbox_max": [
        960.0,
        1658.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1873.8330078125,
      "bbox_min": [
        955.0,
        1655.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        955.0,
        1655.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 148.0,
      "bbox_min": [
        1187.731689453125,
        1630.0,
        148.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        148.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -572.7564697265625,
      "bbox_min": [
        950.0,
        1610.0,
        140.0
      ],
      "bbox_max": [
        960.0,
        1630.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        790.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1480.0,
        1610.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1250.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1480.0,
        1610.0,
        200.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -159.99998474121094,
      "bbox_min": [
        1300.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        1480.0,
        1610.0,
        179.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 157.99998474121094,
      "bbox_min": [
        1300.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        1480.0,
        1610.0,
        160.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1590.0,
      "bbox_min": [
        1300.0,
        1570.0,
        158.0
      ],
      "bbox_max": [
        1480.0,
        1610.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1435.0,
      "bbox_min": [
        1300.0,
        1570.0,
        158.0
      ],
      "bbox_max": [
        1480.0,
        1590.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1300.0,
        1570.0,
        158.0
      ],
      "bbox_max": [
        1300.0,
        1590.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 590.4053955078125,
      "bbox_min": [
        1466.5,
        1570.0,
        158.0
      ],
      "bbox_max": [
        1480.0,
        1580.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1580.0,
      "bbox_min": [
        1466.5,
        1580.0,
        158.0
      ],
      "bbox_max": [
        1480.0,
        1580.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1300.0,
        1590.0,
        158.0
      ],
      "bbox_max": [
        1323.1578369140625,
        1610.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5350520610809326,
        0.0,
        -0.8448190689086914
      ],
      "plane_d": -572.787353515625,
      "bbox_min": [
        1320.0,
        1590.0,
        158.0
      ],
      "bbox_max": [
        1323.1578369140625,
        1610.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        1320.0,
        1590.0,
        158.0
      ],
      "bbox_max": [
        1323.1578369140625,
        1600.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        1320.0,
        1600.0,
        158.0
      ],
      "bbox_max": [
        1323.1578369140625,
        1600.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -592.141845703125,
      "bbox_min": [
        1435.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        1470.0,
        1580.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 590.4053955078125,
      "bbox_min": [
        1435.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        1470.0,
        1580.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1580.0,
      "bbox_min": [
        1435.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        1470.0,
        1580.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5350520610809326,
        0.0,
        0.8448190689086914
      ],
      "plane_d": 571.09765625,
      "bbox_min": [
        1320.0,
        1600.0,
        160.0
      ],
      "bbox_max": [
        1360.0,
        1610.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        1320.0,
        1600.0,
        160.0
      ],
      "bbox_max": [
        1360.0,
        1610.0,
        179.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -178.99998474121094,
      "bbox_min": [
        1350.0,
        1600.0,
        179.0
      ],
      "bbox_max": [
        1353.157958984375,
        1610.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 177.0,
      "bbox_min": [
        1350.0,
        1600.0,
        177.0
      ],
      "bbox_max": [
        1360.0,
        1610.0,
        179.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -178.99998474121094,
      "bbox_min": [
        1353.157958984375,
        1600.0,
        177.0
      ],
      "bbox_max": [
        1360.0,
        1610.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1360.0,
      "bbox_min": [
        1360.0,
        1600.0,
        177.0
      ],
      "bbox_max": [
        1360.0,
        1610.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 159.99998474121094,
      "bbox_min": [
        1250.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1480.0,
        1570.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        1266.0,
        1550.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1570.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1266.0,
        1550.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1570.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1350.0,
      "bbox_min": [
        1350.0,
        1550.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1570.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1564.9998779296875,
      "bbox_min": [
        1290.0,
        1550.0,
        190.0
      ],
      "bbox_max": [
        1350.0,
        1570.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -199.99998474121094,
      "bbox_min": [
        1290.0,
        1565.0,
        190.0
      ],
      "bbox_max": [
        1350.0,
        1570.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1350.0,
      "bbox_min": [
        1350.0,
        1565.0,
        190.0
      ],
      "bbox_max": [
        1350.0,
        1570.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1345.0,
      "bbox_min": [
        1345.0,
        1550.0,
        190.0
      ],
      "bbox_max": [
        1350.0,
        1565.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1350.0,
      "bbox_min": [
        1345.0,
        1550.0,
        190.0
      ],
      "bbox_max": [
        1350.0,
        1565.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        1345.0,
        1550.0,
        200.0
      ],
      "bbox_max": [
        1350.0,
        1565.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1250.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1266.0,
        1570.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        790.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1610.0,
        216.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        980.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1570.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        790.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1610.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 149.99998474121094,
      "bbox_min": [
        790.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1610.0,
        216.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        805.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1610.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 431.3350830078125,
      "bbox_min": [
        805.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1605.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        970.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        970.0,
        1595.9998779296875,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        970.0,
        1595.9998779296875,
        150.0
      ],
      "bbox_max": [
        970.0,
        1610.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 1230.3658447265625,
      "bbox_min": [
        800.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1610.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        805.0,
        1590.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1610.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -572.7564697265625,
      "bbox_min": [
        805.0,
        1590.0,
        140.0
      ],
      "bbox_max": [
        960.0,
        1608.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1704.12744140625,
      "bbox_min": [
        805.0,
        1595.0,
        140.0
      ],
      "bbox_max": [
        815.0,
        1605.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -572.7564697265625,
      "bbox_min": [
        950.0,
        1602.0,
        140.0
      ],
      "bbox_max": [
        960.0,
        1610.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        -0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        810.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1600.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1704.12744140625,
      "bbox_min": [
        810.0,
        1595.0,
        140.0
      ],
      "bbox_max": [
        815.0,
        1600.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 431.3350830078125,
      "bbox_min": [
        960.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        970.0,
        1580.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        260.0,
        670.0,
        139.99998474121094
      ],
      "bbox_max": [
        1770.0,
        1550.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1660.0,
        670.0,
        139.99998474121094
      ],
      "bbox_max": [
        1770.0,
        1550.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        280.0
      ],
      "bbox_max": [
        1735.0,
        1490.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        280.0
      ],
      "bbox_max": [
        1735.0,
        1490.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1220.0,
      "bbox_min": [
        1660.0,
        670.0,
        139.99998474121094
      ],
      "bbox_max": [
        1770.0,
        1469.9998779296875,
        410.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1400.0,
      "bbox_min": [
        1660.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1469.9998779296875,
        400.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1420.0,
      "bbox_min": [
        1680.0,
        1400.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1469.9998779296875,
        400.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 711.9593505859375,
      "bbox_min": [
        1680.0,
        1400.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1420.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1680.0,
        1400.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1420.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -713.6958618164062,
      "bbox_min": [
        1683.5,
        1400.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1410.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -179.99998474121094,
      "bbox_min": [
        1750.0,
        1400.0,
        180.0
      ],
      "bbox_max": [
        1753.5,
        1410.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 178.0,
      "bbox_min": [
        1750.0,
        1400.0,
        178.0
      ],
      "bbox_max": [
        1770.0,
        1410.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -179.99998474121094,
      "bbox_min": [
        1753.5,
        1400.0,
        180.0
      ],
      "bbox_max": [
        1770.0,
        1410.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        1748.13330078125,
        1410.0,
        178.0
      ],
      "bbox_max": [
        1770.0,
        1420.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 177.99998474121094,
      "bbox_min": [
        1748.13330078125,
        1410.0,
        178.0
      ],
      "bbox_max": [
        1770.0,
        1420.0,
        178.933349609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        -0.0,
        -0.8944272398948669
      ],
      "plane_d": 941.8319091796875,
      "bbox_min": [
        1748.13330078125,
        1410.0,
        178.0
      ],
      "bbox_max": [
        1750.0,
        1420.0,
        178.933349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -806.1017456054688,
      "bbox_min": [
        1680.0,
        1400.0,
        178.933349609375
      ],
      "bbox_max": [
        1770.0,
        1420.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        -0.0,
        0.8944272398948669
      ],
      "plane_d": -943.6207275390625,
      "bbox_min": [
        1700.0,
        1400.0,
        178.933349609375
      ],
      "bbox_max": [
        1750.0,
        1420.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1409.9998779296875,
      "bbox_min": [
        1700.0,
        1400.0,
        178.933349609375
      ],
      "bbox_max": [
        1750.0,
        1420.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        -0.0,
        -0.8944272398948669
      ],
      "plane_d": 941.8319091796875,
      "bbox_min": [
        1700.0,
        1410.0,
        178.933349609375
      ],
      "bbox_max": [
        1748.13330078125,
        1420.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -199.99998474121094,
      "bbox_min": [
        1706.0,
        1410.0,
        200.0
      ],
      "bbox_max": [
        1710.0,
        1420.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 198.0,
      "bbox_min": [
        1700.0,
        1410.0,
        198.0
      ],
      "bbox_max": [
        1710.0,
        1420.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -199.99998474121094,
      "bbox_min": [
        1700.0,
        1410.0,
        198.0
      ],
      "bbox_max": [
        1706.0,
        1420.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1700.0,
      "bbox_min": [
        1700.0,
        1410.0,
        198.0
      ],
      "bbox_max": [
        1700.0,
        1420.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 197.99998474121094,
      "bbox_min": [
        1700.0,
        1400.0,
        198.0
      ],
      "bbox_max": [
        1713.9998779296875,
        1410.0,
        200.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        1700.0,
        1400.0,
        198.0
      ],
      "bbox_max": [
        1710.0,
        1410.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1700.0,
      "bbox_min": [
        1700.0,
        1400.0,
        198.0
      ],
      "bbox_max": [
        1700.0,
        1410.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        1710.0,
        1400.0,
        198.0
      ],
      "bbox_max": [
        1740.0,
        1410.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1710.0,
        1400.0,
        198.0
      ],
      "bbox_max": [
        1740.0,
        1410.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1740.0,
      "bbox_min": [
        1740.0,
        1400.0,
        198.0
      ],
      "bbox_max": [
        1740.0,
        1410.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        1680.0,
        1420.0,
        280.0
      ],
      "bbox_max": [
        1735.0,
        1469.9998779296875,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 183.8477783203125,
      "bbox_min": [
        1660.0,
        1400.0,
        260.0
      ],
      "bbox_max": [
        1680.0,
        1420.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5773502588272095,
        0.5773502588272095,
        -0.5773502588272095
      ],
      "plane_d": 311.7691650390625,
      "bbox_min": [
        1660.0,
        1400.0,
        260.0
      ],
      "bbox_max": [
        1680.0,
        1420.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1660.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        280.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 1371.7872314453125,
      "bbox_min": [
        1660.0,
        1220.0,
        260.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.800000011920929,
        0.0,
        -0.5999999642372131
      ],
      "plane_d": -1308.0,
      "bbox_min": [
        1750.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": -1012.0,
      "bbox_min": [
        1750.0,
        1220.0,
        153.3333282470703
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": 1084.0,
      "bbox_min": [
        1750.0,
        1220.0,
        153.3333282470703
      ],
      "bbox_max": [
        1770.0,
        1235.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1750.0,
        1235.0,
        153.3333282470703
      ],
      "bbox_max": [
        1755.0,
        1235.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1385.0,
      "bbox_min": [
        1750.0,
        1385.0,
        153.3333282470703
      ],
      "bbox_max": [
        1755.0,
        1385.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1755.0,
      "bbox_min": [
        1750.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1755.0,
        1385.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1385.0,
      "bbox_min": [
        1750.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1755.0,
        1385.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1750.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1755.0,
        1235.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1088.9444580078125,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1750.0,
        1400.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1695.0,
      "bbox_min": [
        1695.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1750.0,
        1400.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1385.0,
      "bbox_min": [
        1695.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1750.0,
        1400.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1695.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1750.0,
        1235.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": 1084.0,
      "bbox_min": [
        1700.0,
        1220.0,
        160.0
      ],
      "bbox_max": [
        1750.0,
        1235.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": -1012.0,
      "bbox_min": [
        1700.0,
        1385.0,
        160.0
      ],
      "bbox_max": [
        1750.0,
        1400.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        -0.0,
        -0.5999999642372131
      ],
      "plane_d": 1452.0,
      "bbox_min": [
        1680.0,
        1220.0,
        155.0
      ],
      "bbox_max": [
        1740.0,
        1400.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1700.0,
      "bbox_min": [
        1680.0,
        1220.0,
        157.14285278320312
      ],
      "bbox_max": [
        1740.0,
        1400.0,
        260.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -210.0,
      "bbox_min": [
        1680.0,
        1220.0,
        157.14285278320312
      ],
      "bbox_max": [
        1700.0,
        1400.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        1680.0,
        1220.0,
        157.14285278320312
      ],
      "bbox_max": [
        1700.0,
        1400.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": -1012.0,
      "bbox_min": [
        1680.0,
        1220.0,
        157.14285278320312
      ],
      "bbox_max": [
        1700.0,
        1400.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": 1084.0,
      "bbox_min": [
        1680.0,
        1220.0,
        157.14285278320312
      ],
      "bbox_max": [
        1700.0,
        1235.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1695.0,
        1235.0,
        157.14285278320312
      ],
      "bbox_max": [
        1700.0,
        1235.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1385.0,
      "bbox_min": [
        1695.0,
        1385.0,
        157.14285278320312
      ],
      "bbox_max": [
        1700.0,
        1385.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -1053.589111328125,
      "bbox_min": [
        1680.0,
        1280.0,
        200.0
      ],
      "bbox_max": [
        1700.0,
        1330.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1680.0,
        1250.0,
        210.0
      ],
      "bbox_max": [
        1700.0,
        1360.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        1680.0,
        1280.0,
        220.0
      ],
      "bbox_max": [
        1700.0,
        1330.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -749.533203125,
      "bbox_min": [
        1680.0,
        1280.0,
        220.0
      ],
      "bbox_max": [
        1700.0,
        1330.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1290.0,
      "bbox_min": [
        1680.0,
        1290.0,
        230.0
      ],
      "bbox_max": [
        1700.0,
        1290.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 1096.015625,
      "bbox_min": [
        1680.0,
        1320.0,
        220.0
      ],
      "bbox_max": [
        1700.0,
        1330.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1320.0,
      "bbox_min": [
        1680.0,
        1320.0,
        230.0
      ],
      "bbox_max": [
        1700.0,
        1320.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1360.0,
      "bbox_min": [
        1680.0,
        1250.0,
        210.0
      ],
      "bbox_max": [
        1700.0,
        1360.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        1680.0,
        1250.0,
        210.0
      ],
      "bbox_max": [
        1700.0,
        1250.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        1700.0,
        1220.0,
        160.0
      ],
      "bbox_max": [
        1740.0,
        1400.0,
        210.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": -1012.0,
      "bbox_min": [
        1700.0,
        1220.0,
        160.0
      ],
      "bbox_max": [
        1719.9998779296875,
        1400.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": 1084.0,
      "bbox_min": [
        1700.0,
        1220.0,
        160.0
      ],
      "bbox_max": [
        1719.9998779296875,
        1235.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -1350.573974609375,
      "bbox_min": [
        1700.0,
        1220.0,
        200.0
      ],
      "bbox_max": [
        1710.0,
        1400.0,
        210.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -1053.589111328125,
      "bbox_min": [
        1700.0,
        1280.0,
        200.0
      ],
      "bbox_max": [
        1710.0,
        1330.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 791.9596557617188,
      "bbox_min": [
        1700.0,
        1320.0,
        200.0
      ],
      "bbox_max": [
        1710.0,
        1330.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1695.0,
      "bbox_min": [
        1695.0,
        1235.0,
        155.0
      ],
      "bbox_max": [
        1697.142822265625,
        1385.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1385.0,
      "bbox_min": [
        1695.0,
        1235.0,
        155.0
      ],
      "bbox_max": [
        1697.142822265625,
        1385.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1695.0,
        1235.0,
        155.0
      ],
      "bbox_max": [
        1697.142822265625,
        1235.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1660.0,
        670.0,
        140.0
      ],
      "bbox_max": [
        1680.0,
        900.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": 1009.5543212890625,
      "bbox_min": [
        1660.0,
        670.0,
        258.0
      ],
      "bbox_max": [
        1680.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1660.0,
        840.0,
        140.0
      ],
      "bbox_max": [
        1680.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1660.0,
        840.0,
        140.0
      ],
      "bbox_max": [
        1680.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1660.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        1680.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": 1578.9068603515625,
      "bbox_min": [
        1665.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -894.9564819335938,
      "bbox_min": [
        1665.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": -1661.3690185546875,
      "bbox_min": [
        1665.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.0,
        -0.24253562092781067
      ],
      "plane_d": 1651.6676025390625,
      "bbox_min": [
        1665.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -822.1957397460938,
      "bbox_min": [
        1665.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        0.0,
        -0.24253562092781067
      ],
      "plane_d": -1588.6082763671875,
      "bbox_min": [
        1672.5,
        875.0,
        140.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1700.0,
      "bbox_min": [
        1680.0,
        700.0,
        139.99998474121094
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2100.107421875,
      "bbox_min": [
        1700.0,
        700.0,
        139.99998474121094
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 346.48236083984375,
      "bbox_min": [
        1700.0,
        700.0,
        139.99998474121094
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1700.0,
        700.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        900.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1700.0,
        700.0,
        258.0
      ],
      "bbox_max": [
        1770.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1700.0,
        840.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1700.0,
        840.0,
        220.0
      ],
      "bbox_max": [
        1770.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1700.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        1770.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        1680.0,
        700.0,
        139.99998474121094
      ],
      "bbox_max": [
        1700.0,
        1210.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 346.48236083984375,
      "bbox_min": [
        1690.0,
        700.0,
        140.0
      ],
      "bbox_max": [
        1700.0,
        1210.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1690.0,
        700.0,
        258.0
      ],
      "bbox_max": [
        1700.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1690.0,
        840.0,
        140.0
      ],
      "bbox_max": [
        1700.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1690.0,
        840.0,
        220.0
      ],
      "bbox_max": [
        1700.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1690.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        1700.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1680.0,
        700.0,
        140.0
      ],
      "bbox_max": [
        1690.0,
        900.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1680.0,
        700.0,
        258.0
      ],
      "bbox_max": [
        1690.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1680.0,
        840.0,
        140.0
      ],
      "bbox_max": [
        1690.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1680.0,
        840.0,
        220.0
      ],
      "bbox_max": [
        1690.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1680.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        1690.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        260.0,
        720.0,
        139.99998474121094
      ],
      "bbox_max": [
        1660.0,
        1550.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        260.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1660.0,
        1550.0,
        1180.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1350.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1660.0,
        1550.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        1350.0,
        1469.9998779296875,
        140.0
      ],
      "bbox_max": [
        1588.2841796875,
        1550.0,
        1180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        140.0
      ],
      "bbox_max": [
        1588.2841796875,
        1550.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2162.533447265625,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        140.0
      ],
      "bbox_max": [
        1588.2841796875,
        1508.2841796875,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1528.0,
      "bbox_min": [
        1350.0,
        1520.0,
        190.0
      ],
      "bbox_max": [
        1371.0,
        1528.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1520.0,
      "bbox_min": [
        1350.0,
        1520.0,
        190.0
      ],
      "bbox_max": [
        1371.0,
        1528.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        1350.0,
        1520.0,
        190.0
      ],
      "bbox_max": [
        1371.0,
        1528.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        1350.0,
        1520.0,
        190.0
      ],
      "bbox_max": [
        1371.0,
        1528.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1371.0,
      "bbox_min": [
        1371.0,
        1520.0,
        190.0
      ],
      "bbox_max": [
        1371.0,
        1528.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        9.39002404720668e-07,
        0.0
      ],
      "plane_d": -1630.0013427734375,
      "bbox_min": [
        1350.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1469.9998779296875,
        784.9600830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1350.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1630.0,
        1469.9998779296875,
        784.9600830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1350.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1530.0,
        1400.0,
        714.2493896484375
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.213134765625,
      "bbox_min": [
        1350.0,
        1292.393798828125,
        140.0
      ],
      "bbox_max": [
        1507.24658203125,
        1400.0,
        643.5386962890625
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1989.644775390625,
      "bbox_min": [
        1372.393798828125,
        1292.393798828125,
        290.0
      ],
      "bbox_max": [
        1507.24658203125,
        1400.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1939.644775390625,
      "bbox_min": [
        1372.393798828125,
        1292.393798828125,
        340.0
      ],
      "bbox_max": [
        1471.8912353515625,
        1391.8912353515625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 390.0,
      "bbox_min": [
        1372.393798828125,
        1292.393798828125,
        390.0
      ],
      "bbox_max": [
        1436.535888671875,
        1356.535888671875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        1407.7491455078125,
        1327.7491455078125,
        340.0
      ],
      "bbox_max": [
        1471.8912353515625,
        1391.8912353515625,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2019.644775390625,
      "bbox_min": [
        1456.208984375,
        1363.1044921875,
        290.0
      ],
      "bbox_max": [
        1507.24658203125,
        1400.0,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 290.0,
      "bbox_min": [
        1456.208984375,
        1363.1044921875,
        290.0
      ],
      "bbox_max": [
        1507.24658203125,
        1400.0,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2039.644775390625,
      "bbox_min": [
        1484.4931640625,
        1377.24658203125,
        290.0
      ],
      "bbox_max": [
        1507.24658203125,
        1400.0,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1430.0,
        1400.0,
        140.0
      ],
      "bbox_max": [
        1484.4931640625,
        1469.9998779296875,
        728.3914184570312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.213134765625,
      "bbox_min": [
        1430.0,
        1400.0,
        140.0
      ],
      "bbox_max": [
        1480.0,
        1450.0,
        714.2493896484375
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2039.644775390625,
      "bbox_min": [
        1443.1044921875,
        1400.0,
        290.0
      ],
      "bbox_max": [
        1480.0,
        1427.24658203125,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 290.0,
      "bbox_min": [
        1443.1044921875,
        1400.0,
        290.0
      ],
      "bbox_max": [
        1480.0,
        1427.24658203125,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2019.644775390625,
      "bbox_min": [
        1443.1044921875,
        1400.0,
        290.0
      ],
      "bbox_max": [
        1456.208984375,
        1413.1044921875,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2039.644775390625,
      "bbox_min": [
        1480.0,
        1400.0,
        290.0
      ],
      "bbox_max": [
        1484.4931640625,
        1404.4931640625,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 290.0,
      "bbox_min": [
        1480.0,
        1400.0,
        290.0
      ],
      "bbox_max": [
        1484.4931640625,
        1404.4931640625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        360.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1460.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        714.611572265625,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1280.0,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1000.0,
        1270.0,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1270.0,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        714.611572265625,
        1270.0,
        160.0
      ],
      "bbox_max": [
        717.8607788085938,
        1280.0,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        714.611572265625,
        1270.0,
        520.0
      ],
      "bbox_max": [
        717.8607788085938,
        1280.0,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        1030.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1460.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1250.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1460.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        1290.0,
        1450.0,
        190.0
      ],
      "bbox_max": [
        1350.0,
        1460.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1030.0,
        1300.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1460.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1030.0,
        1300.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1390.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      "bbox_max": [
        1175.0,
        1390.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      "bbox_max": [
        1175.0,
        1390.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      "bbox_max": [
        1175.0,
        1380.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70710688829422,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -466.63031005859375,
      "bbox_min": [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1380.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071067094802856
      ],
      "plane_d": -476.6302490234375,
      "bbox_min": [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1330.0,
        375.9431457519531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70710688829422,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -466.63031005859375,
      "bbox_min": [
        1030.0,
        1380.0,
        370.0852355957031
      ],
      "bbox_max": [
        1050.0,
        1390.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1030.0,
        1390.0,
        140.0
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        515.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.70710688829422,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -466.63031005859375,
      "bbox_min": [
        1030.0,
        1390.0,
        140.0
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2747208774089813,
        0.0,
        -0.9615241289138794
      ],
      "plane_d": -179.2552032470703,
      "bbox_min": [
        1142.5,
        1418.75,
        140.0
      ],
      "bbox_max": [
        1160.0,
        1430.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913010776042938,
        0.9678216576576233,
        -0.24195532500743866
      ],
      "plane_d": -1419.4141845703125,
      "bbox_min": [
        1142.5,
        1418.75,
        140.0
      ],
      "bbox_max": [
        1160.0,
        1420.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70710688829422,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -466.63031005859375,
      "bbox_min": [
        840.0,
        1310.0,
        180.0
      ],
      "bbox_max": [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1309.9998779296875,
      "bbox_min": [
        840.0,
        1310.0,
        180.0
      ],
      "bbox_max": [
        1030.0,
        1330.0,
        370.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071067094802856
      ],
      "plane_d": -476.6302490234375,
      "bbox_min": [
        854.056884765625,
        1310.0,
        180.0
      ],
      "bbox_max": [
        1030.0,
        1330.0,
        355.9431457519531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        0.30901700258255005,
        -0.0
      ],
      "plane_d": -1081.358154296875,
      "bbox_min": [
        360.0,
        1280.0,
        160.0
      ],
      "bbox_max": [
        840.0,
        1460.0,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1384.3714599609375,
      "bbox_min": [
        360.0,
        1280.0,
        160.0
      ],
      "bbox_max": [
        719.4853515625,
        1460.0,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        0.8090178370475769,
        -0.0
      ],
      "plane_d": -1500.44677734375,
      "bbox_min": [
        440.0,
        1280.0,
        160.0
      ],
      "bbox_max": [
        719.4853515625,
        1384.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        440.0,
        1280.0,
        160.0
      ],
      "bbox_max": [
        719.4853515625,
        1380.0,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        1340.0,
        200.0
      ],
      "bbox_max": [
        440.0,
        1380.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1415.0,
      "bbox_min": [
        360.0,
        1415.0,
        190.0
      ],
      "bbox_max": [
        440.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -360.0,
      "bbox_min": [
        360.0,
        1415.0,
        190.0
      ],
      "bbox_max": [
        360.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70710688829422,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -466.63031005859375,
      "bbox_min": [
        839.914794921875,
        1310.0,
        180.0
      ],
      "bbox_max": [
        840.0,
        1460.0,
        180.08523559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1309.9998779296875,
      "bbox_min": [
        839.914794921875,
        1310.0,
        180.00003051757812
      ],
      "bbox_max": [
        840.0,
        1310.0,
        180.08523559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        0.30901700258255005,
        -0.0
      ],
      "plane_d": -1081.358154296875,
      "bbox_min": [
        582.7122802734375,
        1280.0,
        520.0
      ],
      "bbox_max": [
        719.4853515625,
        1384.3714599609375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1384.3714599609375,
      "bbox_min": [
        582.7122802734375,
        1280.0,
        520.0
      ],
      "bbox_max": [
        719.4853515625,
        1384.3714599609375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        717.8607788085938,
        1280.0,
        520.0
      ],
      "bbox_max": [
        719.4853515625,
        1285.0,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        260.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -450.0,
      "bbox_min": [
        260.0,
        1460.0,
        190.0
      ],
      "bbox_max": [
        450.0,
        1550.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4657464623451233,
        -0.0,
        0.8849182724952698
      ],
      "plane_d": -421.96630859375,
      "bbox_min": [
        260.0,
        1460.0,
        240.0
      ],
      "bbox_max": [
        450.0,
        1550.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4490928053855896,
        -0.08933013677597046,
        0.8890084028244019
      ],
      "plane_d": -285.03179931640625,
      "bbox_min": [
        260.0,
        1460.0,
        240.0
      ],
      "bbox_max": [
        450.0,
        1550.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35946810245513916,
        -0.24018871784210205,
        0.9017161726951599
      ],
      "plane_d": -27.496994018554688,
      "bbox_min": [
        309.8317565917969,
        1460.0,
        240.0
      ],
      "bbox_max": [
        450.0,
        1550.0,
        319.85107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23023629188537598,
        -0.3445734679698944,
        0.910088062286377
      ],
      "plane_d": 181.0498046875,
      "bbox_min": [
        380.6481018066406,
        1460.0,
        240.0
      ],
      "bbox_max": [
        450.0,
        1550.0,
        291.6202087402344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        780.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        1266.0,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1266.0,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1290.0,
        1550.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1250.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1266.0,
        1550.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.70710688829422,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -466.63031005859375,
      "bbox_min": [
        780.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        780.0,
        1470.0,
        140.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        1175.0,
        1470.0,
        515.0852661132812
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1539.9998779296875,
      "bbox_min": [
        799.9147338867188,
        1470.0,
        140.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        515.0852661132812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        1175.0,
        1470.0,
        515.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        515.0852661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1472.83544921875,
        140.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        440.0,
        720.0,
        139.99998474121094
      ],
      "bbox_max": [
        1660.0,
        1270.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1530.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        465.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1535.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        1615.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1530.0,
        810.0,
        140.0
      ],
      "bbox_max": [
        1660.0,
        940.0,
        240.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        1580.0,
        845.0,
        140.0
      ],
      "bbox_max": [
        1600.0,
        860.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -860.0,
      "bbox_min": [
        1598.0,
        860.0,
        140.0
      ],
      "bbox_max": [
        1600.0,
        860.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1600.0,
        810.0,
        140.0
      ],
      "bbox_max": [
        1660.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1600.0,
        840.0,
        200.0
      ],
      "bbox_max": [
        1660.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1600.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        1660.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -989.9495849609375,
      "bbox_min": [
        1600.0,
        860.0,
        200.0
      ],
      "bbox_max": [
        1620.0,
        900.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -869.9999389648438,
      "bbox_min": [
        1600.0,
        870.0,
        200.0
      ],
      "bbox_max": [
        1620.0,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1600.0,
        900.0,
        200.0
      ],
      "bbox_max": [
        1620.0,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        1535.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1494.5458984375,
      "bbox_min": [
        1535.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1605.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1535.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1605.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1605.0,
      "bbox_min": [
        1565.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1605.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1565.0,
        1100.0,
        465.0
      ],
      "bbox_max": [
        1605.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1475.0,
        1130.0,
        140.0
      ],
      "bbox_max": [
        1530.0,
        1235.4296875,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -141.0,
      "bbox_min": [
        1494.6551513671875,
        1214.5703125,
        140.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        157.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.37629082798957825,
        -0.9265016913414001,
        0.0
      ],
      "plane_d": 558.7955932617188,
      "bbox_min": [
        1505.5,
        1214.5703125,
        140.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37629082798957825,
        0.9265016913414001,
        -0.0
      ],
      "plane_d": -1711.133544921875,
      "bbox_min": [
        1505.5,
        1217.7266845703125,
        140.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211457371711731,
        0.3892177939414978,
        -0.0
      ],
      "plane_d": -1873.56640625,
      "bbox_min": [
        1513.2716064453125,
        1217.7266845703125,
        140.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1232.2733154296875,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211457371711731,
        -0.3892177939414978,
        0.0
      ],
      "plane_d": -919.9827270507812,
      "bbox_min": [
        1513.2716064453125,
        1217.7266845703125,
        140.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1225.0,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37631431221961975,
        -0.9264920949935913,
        0.0
      ],
      "plane_d": 563.24853515625,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        141.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1230.57275390625,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37631431221961975,
        -0.9264920949935913,
        0.0
      ],
      "plane_d": 573.57470703125,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        141.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1230.57275390625,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211491346359253,
        0.389210045337677,
        -0.0
      ],
      "plane_d": -1869.06201171875,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        141.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1230.57275390625,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 146.0,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        141.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1230.57275390625,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -147.99998474121094,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        146.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1230.57275390625,
        157.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.37631431221961975,
        0.9264920949935913,
        -0.0
      ],
      "plane_d": -1706.6572265625,
      "bbox_min": [
        1505.5,
        1221.19482421875,
        146.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1230.57275390625,
        148.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211491346359253,
        -0.389210045337677,
        0.0
      ],
      "plane_d": -915.497314453125,
      "bbox_min": [
        1509.851806640625,
        1221.19482421875,
        146.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1225.0,
        148.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3131498694419861,
        -0.7712409496307373,
        0.5541881918907166
      ],
      "plane_d": 386.3155517578125,
      "bbox_min": [
        1502.2545166015625,
        1222.125732421875,
        148.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3131498694419861,
        0.7712409496307373,
        0.5541881918907166
      ],
      "plane_d": -560.33056640625,
      "bbox_min": [
        1502.2545166015625,
        1222.125732421875,
        148.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3131498396396637,
        0.7712410092353821,
        0.5541882514953613
      ],
      "plane_d": -1503.224853515625,
      "bbox_min": [
        1502.2545166015625,
        1222.125732421875,
        148.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7378709316253662,
        0.3116414248943329,
        0.5986869931221008
      ],
      "plane_d": -1586.6192626953125,
      "bbox_min": [
        1502.2545166015625,
        1222.125732421875,
        148.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737870991230011,
        -0.3116414248943329,
        0.5986870527267456
      ],
      "plane_d": -823.097900390625,
      "bbox_min": [
        1502.2545166015625,
        1222.125732421875,
        148.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 152.99998474121094,
      "bbox_min": [
        1502.2545166015625,
        1222.125732421875,
        148.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37619802355766296,
        -0.9265393614768982,
        0.0
      ],
      "plane_d": 567.9815063476562,
      "bbox_min": [
        1505.5,
        1224.2843017578125,
        148.0
      ],
      "bbox_max": [
        1506.574462890625,
        1225.7156982421875,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37619802355766296,
        0.9265393614768982,
        -0.0
      ],
      "plane_d": -1702.0400390625,
      "bbox_min": [
        1505.5,
        1224.6627197265625,
        148.0
      ],
      "bbox_max": [
        1506.574462890625,
        1225.7156982421875,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9212018847465515,
        0.3890852630138397,
        -0.0
      ],
      "plane_d": -1864.48876953125,
      "bbox_min": [
        1506.4320068359375,
        1224.6627197265625,
        148.0
      ],
      "bbox_max": [
        1506.574462890625,
        1225.3372802734375,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9212018847465515,
        -0.3890852630138397,
        0.0
      ],
      "plane_d": -911.2297973632812,
      "bbox_min": [
        1506.4320068359375,
        1224.6627197265625,
        148.0
      ],
      "bbox_max": [
        1506.574462890625,
        1225.0,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211491346359253,
        0.389210045337677,
        0.0
      ],
      "plane_d": -1858.0826416015625,
      "bbox_min": [
        1499.5404052734375,
        1221.19482421875,
        141.0
      ],
      "bbox_max": [
        1507.1171875,
        1225.7225341796875,
        146.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37630537152290344,
        -0.9264957308769226,
        0.0
      ],
      "plane_d": 567.2664184570312,
      "bbox_min": [
        1505.5,
        1223.74462890625,
        141.0
      ],
      "bbox_max": [
        1507.1171875,
        1225.7225341796875,
        146.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211454391479492,
        0.3892185688018799,
        -0.0
      ],
      "plane_d": -1865.06689453125,
      "bbox_min": [
        1506.8118896484375,
        1224.2774658203125,
        141.0
      ],
      "bbox_max": [
        1507.1171875,
        1225.7225341796875,
        146.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211454391479492,
        -0.3892185688018799,
        0.0
      ],
      "plane_d": -911.4814453125,
      "bbox_min": [
        1506.8118896484375,
        1224.2774658203125,
        141.0
      ],
      "bbox_max": [
        1507.1171875,
        1225.0,
        146.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1475.0,
        720.0,
        139.99998474121094
      ],
      "bbox_max": [
        1480.0,
        880.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        1475.0,
        880.0,
        139.99998474121094
      ],
      "bbox_max": [
        1480.0,
        880.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1414.94287109375,
      "bbox_min": [
        1485.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1525.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1485.0,
      "bbox_min": [
        1485.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1525.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1525.0,
      "bbox_min": [
        1485.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1525.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1485.0,
        1100.0,
        465.0
      ],
      "bbox_max": [
        1525.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        440.0,
        720.0,
        139.99998474121094
      ],
      "bbox_max": [
        1475.0,
        1270.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1455.0,
        1130.0,
        465.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1455.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1455.0,
      "bbox_min": [
        1455.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1455.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -975.879638671875,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1130.0,
        260.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -939.1484985351562,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1130.0,
        260.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1389.9998779296875,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1130.0,
        260.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -1171.6995849609375,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        1240.0,
        720.0,
        139.99998474121094
      ],
      "bbox_max": [
        1475.0,
        960.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        720.0,
        139.99998474121094
      ],
      "bbox_max": [
        1250.0,
        880.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        140.0
      ],
      "bbox_max": [
        1250.0,
        960.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1500.51611328125,
      "bbox_min": [
        1240.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1455.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1455.0,
      "bbox_min": [
        1405.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1455.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1405.0,
      "bbox_min": [
        1405.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1445.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1405.0,
        1100.0,
        465.0
      ],
      "bbox_max": [
        1445.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        1240.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1395.0,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        1240.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1120.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1040.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -1171.6995849609375,
      "bbox_min": [
        1240.0,
        962.6142578125,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1040.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1240.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1258.0,
        1030.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1240.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1030.0,
        160.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -975.879638671875,
      "bbox_min": [
        1240.0,
        1040.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1120.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1389.9998779296875,
      "bbox_min": [
        1240.0,
        1040.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1120.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -1171.6995849609375,
      "bbox_min": [
        1240.0,
        1040.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1120.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        1040.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        1000.0,
        1170.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1270.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1000.0,
        1170.0,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1270.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1170.0,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1270.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9418852925300598,
        -0.33593469858169556,
        0.0
      ],
      "plane_d": -550.1356201171875,
      "bbox_min": [
        983.5406494140625,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        140.0
      ],
      "bbox_max": [
        1001.373779296875,
        1170.0,
        280.9158630371094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1001.373779296875,
        1170.0,
        280.9158630371094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": -1114.3089599609375,
      "bbox_min": [
        1010.7999877929688,
        950.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1119.199951171875,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9992009997367859,
        -0.0,
        0.039968036115169525
      ],
      "plane_d": -1194.2449951171875,
      "bbox_min": [
        1050.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1109.5999755859375,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1050.0,
        970.0,
        140.0
      ],
      "bbox_max": [
        1189.5999755859375,
        1109.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1050.0,
        1090.0,
        140.0
      ],
      "bbox_max": [
        1160.0,
        1109.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1150.0,
        1090.0,
        140.0
      ],
      "bbox_max": [
        1160.0,
        1109.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1170.0,
        970.0,
        140.0
      ],
      "bbox_max": [
        1189.5999755859375,
        1030.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1186.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1189.5999755859375,
        1030.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": -1192.56982421875,
      "bbox_min": [
        1173.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1109.5999755859375,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974521815776825
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1180.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1109.5999755859375,
        380.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1180.0,
        960.4000244140625,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1089.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1180.0,
        966.6666870117188,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1089.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -1070.5714111328125,
      "bbox_min": [
        1187.0400390625,
        966.6666870117188,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1083.3333740234375,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1189.3616943359375,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1193.33349609375,
        1030.0,
        145.95767211914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1187.0400390625,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1030.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1194.0799560546875,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1030.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": -1112.6187744140625,
      "bbox_min": [
        1010.7999877929688,
        1091.9998779296875,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1119.199951171875,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": -1192.56982421875,
      "bbox_min": [
        1173.0,
        1091.9998779296875,
        380.0
      ],
      "bbox_max": [
        1180.0,
        1100.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974521815776825
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1040.4000244140625,
        1100.0,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1119.199951171875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1040.4000244140625,
        1100.0,
        140.0
      ],
      "bbox_max": [
        1169.5999755859375,
        1119.199951171875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1040.4000244140625,
        1100.0,
        140.0
      ],
      "bbox_max": [
        1163.3333740234375,
        1119.199951171875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        0.5547001957893372
      ],
      "plane_d": -1004.00732421875,
      "bbox_min": [
        1046.6666259765625,
        1110.0,
        140.0
      ],
      "bbox_max": [
        1163.3333740234375,
        1113.3333740234375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1173.0,
      "bbox_min": [
        1173.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974522560834885
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1180.0,
        930.7999877929688,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9992009997367859,
        -0.0,
        0.039968036115169525
      ],
      "plane_d": -1194.2449951171875,
      "bbox_min": [
        1180.0,
        940.4000244140625,
        140.0
      ],
      "bbox_max": [
        1189.5999755859375,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1039.16015625,
        825.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        825.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1173.0,
      "bbox_min": [
        1050.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1515.329833984375,
      "bbox_min": [
        1050.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        803.63623046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 47.37615966796875,
      "bbox_min": [
        1135.85791015625,
        1055.85791015625,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -65.760986328125,
      "bbox_min": [
        1148.85791015625,
        1055.85791015625,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1080.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -1355.414306640625,
      "bbox_min": [
        861.330810546875,
        1120.0,
        170.0
      ],
      "bbox_max": [
        868.6692504882812,
        1121.3931884765625,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        861.330810546875,
        1120.0,
        170.0
      ],
      "bbox_max": [
        868.6692504882812,
        1121.3931884765625,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 578.7291259765625,
      "bbox_min": [
        440.0,
        1120.0,
        160.0
      ],
      "bbox_max": [
        714.611572265625,
        1270.0,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        440.0,
        1120.0,
        160.0
      ],
      "bbox_max": [
        714.611572265625,
        1270.0,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        440.0,
        1120.0,
        290.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -1355.414306640625,
      "bbox_min": [
        647.2877197265625,
        1120.0,
        520.0
      ],
      "bbox_max": [
        868.6692504882812,
        1270.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 578.7291259765625,
      "bbox_min": [
        647.2877197265625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        663.947021484375,
        1197.732177734375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        663.947021484375,
        1197.732177734375,
        520.0
      ],
      "bbox_max": [
        714.611572265625,
        1270.0,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 578.7291259765625,
      "bbox_min": [
        663.947021484375,
        1197.732177734375,
        520.0
      ],
      "bbox_max": [
        699.5303955078125,
        1223.5849609375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112825989723206,
        0.4117816090583801,
        0.0
      ],
      "plane_d": -1293.248291015625,
      "bbox_min": [
        440.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1120.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112825989723206,
        -0.4117816090583801,
        0.0
      ],
      "plane_d": -432.6246337890625,
      "bbox_min": [
        440.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1120.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -1355.414306640625,
      "bbox_min": [
        440.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        922.2498779296875,
        1120.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        440.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        922.2498779296875,
        1120.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        700.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        922.2498779296875,
        1120.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        700.0,
        1000.0,
        140.0
      ],
      "bbox_max": [
        700.0,
        1090.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        807.7501220703125,
        1076.008544921875,
        140.0
      ],
      "bbox_max": [
        922.2498779296875,
        1120.0,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        865.0,
        1083.890869140625,
        140.0
      ],
      "bbox_max": [
        907.4263916015625,
        1100.0,
        170.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}